// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/contract_model.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { ExecutionAuthorityBasis, ExecutionCommercialTreatment, ExecutionPerformanceDisposition, ExecutionScopeAssessment, ExecutionTrackingMode, ExecutionWorkItemKind } from "../../common/v1/execution_scope_pb";
import { ReviewItem } from "../../common/v1/types_pb";
/**
 * OccurrenceWindow is ListOccurrences' window filter (D104).
 *
 * @generated from enum mono.datagateway.v1.OccurrenceWindow
 */ export var OccurrenceWindow = /*#__PURE__*/ function(OccurrenceWindow) {
    /**
   * @generated from enum value: OCCURRENCE_WINDOW_UNSPECIFIED = 0;
   */ OccurrenceWindow[OccurrenceWindow["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * Every row.
   *
   * @generated from enum value: OCCURRENCE_WINDOW_ALL = 1;
   */ OccurrenceWindow[OccurrenceWindow["ALL"] = 1] = "ALL";
    /**
   * The contract period (Base, OPn) containing as_of, plus open rows
   * carried over from before it.
   *
   * @generated from enum value: OCCURRENCE_WINDOW_CONTRACT_CURRENT_PERIOD = 2;
   */ OccurrenceWindow[OccurrenceWindow["CONTRACT_CURRENT_PERIOD"] = 2] = "CONTRACT_CURRENT_PERIOD";
    /**
   * workstream_id's own current window: the in-force SOW's interval
   * containing as_of, else its exercise line's window; plus its open rows
   * carried over from before it.
   *
   * @generated from enum value: OCCURRENCE_WINDOW_WORKSTREAM_CURRENT_WINDOW = 3;
   */ OccurrenceWindow[OccurrenceWindow["WORKSTREAM_CURRENT_WINDOW"] = 3] = "WORKSTREAM_CURRENT_WINDOW";
    /**
   * period_of_performance_id's span (a past period on the D104 picker),
   * plus open rows carried over from before it. Status is still computed on
   * as_of.
   *
   * @generated from enum value: OCCURRENCE_WINDOW_CONTRACT_PERIOD = 4;
   */ OccurrenceWindow[OccurrenceWindow["CONTRACT_PERIOD"] = 4] = "CONTRACT_PERIOD";
    return OccurrenceWindow;
}({});
// Retrieve enum metadata with: proto3.getEnumType(OccurrenceWindow)
proto3.util.setEnumType(OccurrenceWindow, "mono.datagateway.v1.OccurrenceWindow", [
    {
        no: 0,
        name: "OCCURRENCE_WINDOW_UNSPECIFIED"
    },
    {
        no: 1,
        name: "OCCURRENCE_WINDOW_ALL"
    },
    {
        no: 2,
        name: "OCCURRENCE_WINDOW_CONTRACT_CURRENT_PERIOD"
    },
    {
        no: 3,
        name: "OCCURRENCE_WINDOW_WORKSTREAM_CURRENT_WINDOW"
    },
    {
        no: 4,
        name: "OCCURRENCE_WINDOW_CONTRACT_PERIOD"
    }
]);
/**
 * SowGapChoice is the answer to a SOW_HISTORY_MISSING item (D104).
 *
 * @generated from enum mono.datagateway.v1.SowGapChoice
 */ export var SowGapChoice = /*#__PURE__*/ function(SowGapChoice) {
    /**
   * @generated from enum value: SOW_GAP_CHOICE_UNSPECIFIED = 0;
   */ SowGapChoice[SowGapChoice["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * "Latest SOW applied all along": sow_id is the later SOW.
   *
   * @generated from enum value: SOW_GAP_CHOICE_LATEST_SOW = 1;
   */ SowGapChoice[SowGapChoice["LATEST_SOW"] = 1] = "LATEST_SOW";
    /**
   * "Award schedule applied".
   *
   * @generated from enum value: SOW_GAP_CHOICE_AWARD = 2;
   */ SowGapChoice[SowGapChoice["AWARD"] = 2] = "AWARD";
    /**
   * "Upload the earlier version": an action, not a ruling. Nothing is stored;
   * the gap stays open until CreateSow adds the version.
   *
   * @generated from enum value: SOW_GAP_CHOICE_UPLOAD_EARLIER = 3;
   */ SowGapChoice[SowGapChoice["UPLOAD_EARLIER"] = 3] = "UPLOAD_EARLIER";
    return SowGapChoice;
}({});
// Retrieve enum metadata with: proto3.getEnumType(SowGapChoice)
proto3.util.setEnumType(SowGapChoice, "mono.datagateway.v1.SowGapChoice", [
    {
        no: 0,
        name: "SOW_GAP_CHOICE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "SOW_GAP_CHOICE_LATEST_SOW"
    },
    {
        no: 2,
        name: "SOW_GAP_CHOICE_AWARD"
    },
    {
        no: 3,
        name: "SOW_GAP_CHOICE_UPLOAD_EARLIER"
    }
]);
/**
 * WriteContext is which audit correlation a write joins. Who is writing is
 * never in the message: the tenant and the actor are the gateway principal's
 * (X-Tenant-ID / X-User-ID, forwarded by the caller; R8).
 *
 * @generated from message mono.datagateway.v1.WriteContext
 */ export class WriteContext extends Message {
    static fromBinary(bytes, options) {
        return new WriteContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WriteContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WriteContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WriteContext, a, b);
    }
    constructor(data){
        super(), /**
   * correlation_id groups this write's audit event with others; "" mints one.
   *
   * @generated from field: string correlation_id = 2;
   */ _define_property(this, "correlationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WriteContext, "runtime", proto3);
_define_property(WriteContext, "typeName", "mono.datagateway.v1.WriteContext");
_define_property(WriteContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * MintCounts is what the verb's Mint wrote.
 *
 * @generated from message mono.datagateway.v1.MintCounts
 */ export class MintCounts extends Message {
    static fromBinary(bytes, options) {
        return new MintCounts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MintCounts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MintCounts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MintCounts, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 inserted = 1;
   */ _define_property(this, "inserted", 0), /**
   * @generated from field: int32 updated = 2;
   */ _define_property(this, "updated", 0), /**
   * @generated from field: int32 retired = 3;
   */ _define_property(this, "retired", 0), /**
   * @generated from field: int32 revived = 4;
   */ _define_property(this, "revived", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MintCounts, "runtime", proto3);
_define_property(MintCounts, "typeName", "mono.datagateway.v1.MintCounts");
_define_property(MintCounts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "inserted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "retired",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "revived",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * WriteResult is on every write response.
 *
 * @generated from message mono.datagateway.v1.WriteResult
 */ export class WriteResult extends Message {
    static fromBinary(bytes, options) {
        return new WriteResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WriteResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WriteResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WriteResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.MintCounts mint = 1;
   */ _define_property(this, "mint", void 0), /**
   * @generated from field: string audit_event_id = 2;
   */ _define_property(this, "auditEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WriteResult, "runtime", proto3);
_define_property(WriteResult, "typeName", "mono.datagateway.v1.WriteResult");
_define_property(WriteResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "mint",
            kind: "message",
            T: MintCounts
        },
        {
            no: 2,
            name: "audit_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractDuty
 */ export class ContractDuty extends Message {
    static fromBinary(bytes, options) {
        return new ContractDuty().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractDuty().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractDuty().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractDuty, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string duty_key = 3;
   */ _define_property(this, "dutyKey", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string pws_ref = 5;
   */ _define_property(this, "pwsRef", ""), /**
   * @generated from field: string letter = 6;
   */ _define_property(this, "letter", ""), /**
   * @generated from field: repeated string aliases = 7;
   */ _define_property(this, "aliases", []), /**
   * @generated from field: string description = 8;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string format = 9;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 10;
   */ _define_property(this, "submissionMethod", ""), /**
   * @generated from field: string acceptance_criteria = 11;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * @generated from field: string final_review_tier = 12;
   */ _define_property(this, "finalReviewTier", ""), /**
   * @generated from field: string origin = 13;
   */ _define_property(this, "origin", ""), /**
   * @generated from field: string sow_id = 14;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string source_document_id = 15;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 16;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string introduced_by_modification_id = 17;
   */ _define_property(this, "introducedByModificationId", ""), /**
   * @generated from field: string ended_by_modification_id = 18;
   */ _define_property(this, "endedByModificationId", ""), /**
   * @generated from field: string ended_on = 19;
   */ _define_property(this, "endedOn", ""), /**
   * event_kind is the event this duty dates ("" = none): logging that event
   * meets its date, and the event's dependents are projected from it until
   * then (S6).
   *
   * @generated from field: string event_kind = 20;
   */ _define_property(this, "eventKind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractDuty, "runtime", proto3);
_define_property(ContractDuty, "typeName", "mono.datagateway.v1.ContractDuty");
_define_property(ContractDuty, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duty_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "pws_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "letter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "aliases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "final_review_tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "introduced_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "ended_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "ended_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractScheduleRule
 */ export class ContractScheduleRule extends Message {
    static fromBinary(bytes, options) {
        return new ContractScheduleRule().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractScheduleRule().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractScheduleRule().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractScheduleRule, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string duty_id = 2;
   */ _define_property(this, "dutyId", ""), /**
   * assignment_id is set on a team rule (gate "sow").
   *
   * @generated from field: string assignment_id = 3;
   */ _define_property(this, "assignmentId", ""), /**
   * @generated from field: string clin_id = 4;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: string gate = 5;
   */ _define_property(this, "gate", ""), /**
   * @generated from field: string period_of_performance_id = 6;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: string optional_task_id = 7;
   */ _define_property(this, "optionalTaskId", ""), /**
   * @generated from field: string kind = 8;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string due_on = 9;
   */ _define_property(this, "dueOn", ""), /**
   * offset_n is signed; has_offset distinguishes 0 from unset.
   *
   * @generated from field: bool has_offset = 10;
   */ _define_property(this, "hasOffset", false), /**
   * @generated from field: int32 offset_n = 11;
   */ _define_property(this, "offsetN", 0), /**
   * @generated from field: string offset_unit = 12;
   */ _define_property(this, "offsetUnit", ""), /**
   * @generated from field: string cadence = 13;
   */ _define_property(this, "cadence", ""), /**
   * @generated from field: int32 cadence_interval = 14;
   */ _define_property(this, "cadenceInterval", 0), /**
   * @generated from field: repeated int32 day_ordinals = 15;
   */ _define_property(this, "dayOrdinals", []), /**
   * @generated from field: string day_weekday = 16;
   */ _define_property(this, "dayWeekday", ""), /**
   * @generated from field: string day_basis = 17;
   */ _define_property(this, "dayBasis", ""), /**
   * @generated from field: string event_kind = 18;
   */ _define_property(this, "eventKind", ""), /**
   * @generated from field: repeated string subjects = 19;
   */ _define_property(this, "subjects", []), /**
   * @generated from field: string rule_text = 20;
   */ _define_property(this, "ruleText", ""), /**
   * @generated from field: string source_document_id = 21;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 22;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string effective_from = 23;
   */ _define_property(this, "effectiveFrom", ""), /**
   * @generated from field: string effective_to = 24;
   */ _define_property(this, "effectiveTo", ""), /**
   * @generated from field: string established_by_modification_id = 25;
   */ _define_property(this, "establishedByModificationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractScheduleRule, "runtime", proto3);
_define_property(ContractScheduleRule, "typeName", "mono.datagateway.v1.ContractScheduleRule");
_define_property(ContractScheduleRule, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "gate",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "has_offset",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "offset_n",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "offset_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "cadence_interval",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "day_ordinals",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        },
        {
            no: 16,
            name: "day_weekday",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "day_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "subjects",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 20,
            name: "rule_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "effective_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "effective_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "established_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OverrideLocator
 */ export class OverrideLocator extends Message {
    static fromBinary(bytes, options) {
        return new OverrideLocator().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OverrideLocator().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OverrideLocator().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OverrideLocator, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string field = 1;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string source_locator = 2;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string quote = 3;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OverrideLocator, "runtime", proto3);
_define_property(OverrideLocator, "typeName", "mono.datagateway.v1.OverrideLocator");
_define_property(OverrideLocator, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractDutyAssignment
 */ export class ContractDutyAssignment extends Message {
    static fromBinary(bytes, options) {
        return new ContractDutyAssignment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractDutyAssignment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractDutyAssignment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractDutyAssignment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string sow_id = 2;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string duty_id = 3;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string handling = 4;
   */ _define_property(this, "handling", ""), /**
   * @generated from field: string routed_to_workstream_id = 5;
   */ _define_property(this, "routedToWorkstreamId", ""), /**
   * @generated from field: string not_owed_reason = 6;
   */ _define_property(this, "notOwedReason", ""), /**
   * Overrides; "" inherits the duty's term.
   *
   * @generated from field: string title_as_stated = 7;
   */ _define_property(this, "titleAsStated", ""), /**
   * @generated from field: string sender_contact_id = 8;
   */ _define_property(this, "senderContactId", ""), /**
   * @generated from field: string recipient = 9;
   */ _define_property(this, "recipient", ""), /**
   * @generated from field: string format = 10;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 11;
   */ _define_property(this, "submissionMethod", ""), /**
   * @generated from field: string acceptance_criteria = 12;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * @generated from field: repeated mono.datagateway.v1.OverrideLocator override_locators = 13;
   */ _define_property(this, "overrideLocators", []), /**
   * @generated from field: string source_locator = 14;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string note = 15;
   */ _define_property(this, "note", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ContractScheduleRule team_rules = 16;
   */ _define_property(this, "teamRules", []), /**
   * effective_terms reads the overrides over the award's terms.
   *
   * @generated from field: repeated mono.datagateway.v1.EffectiveTerm effective_terms = 17;
   */ _define_property(this, "effectiveTerms", []), /**
   * disposition (R12-C) is handling, routed_to_workstream_id and
   * not_owed_reason as one execution disposition: performed is
   * PERFORMED_HERE; routed to a team FULFILLED_ELSEWHERE, to the base scope
   * BASE_SCOPE; not owed WAIVED, NOT_APPLICABLE, OUT_OF_SCOPE (not listed)
   * or DUPLICATE_NO_SEPARATE_DELIVERY. Read-only: the columns are stored.
   *
   * @generated from field: mono.common.v1.ExecutionPerformanceDisposition disposition = 18;
   */ _define_property(this, "disposition", ExecutionPerformanceDisposition.UNSPECIFIED), /**
   * tracking_mode (R12-C): OWN_SERIES for a performed assignment, else
   * NO_SERIES (the team holds no dated series; a routing watches its
   * receiver's).
   *
   * @generated from field: mono.common.v1.ExecutionTrackingMode tracking_mode = 19;
   */ _define_property(this, "trackingMode", ExecutionTrackingMode.UNSPECIFIED);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractDutyAssignment, "runtime", proto3);
_define_property(ContractDutyAssignment, "typeName", "mono.datagateway.v1.ContractDutyAssignment");
_define_property(ContractDutyAssignment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "handling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "routed_to_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "not_owed_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "title_as_stated",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "sender_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "recipient",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "override_locators",
            kind: "message",
            T: OverrideLocator,
            repeated: true
        },
        {
            no: 14,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "team_rules",
            kind: "message",
            T: ContractScheduleRule,
            repeated: true
        },
        {
            no: 17,
            name: "effective_terms",
            kind: "message",
            T: EffectiveTerm,
            repeated: true
        },
        {
            no: 18,
            name: "disposition",
            kind: "enum",
            T: proto3.getEnumType(ExecutionPerformanceDisposition)
        },
        {
            no: 19,
            name: "tracking_mode",
            kind: "enum",
            T: proto3.getEnumType(ExecutionTrackingMode)
        }
    ]));
/**
 * EffectiveTerm is one field of a duty under an assignment. stated is false
 * when neither the SOW nor the award says anything.
 *
 * @generated from message mono.datagateway.v1.EffectiveTerm
 */ export class EffectiveTerm extends Message {
    static fromBinary(bytes, options) {
        return new EffectiveTerm().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EffectiveTerm().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EffectiveTerm().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EffectiveTerm, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string field = 1;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string value = 2;
   */ _define_property(this, "value", ""), /**
   * @generated from field: bool stated = 3;
   */ _define_property(this, "stated", false), /**
   * @generated from field: bool from_sow = 4;
   */ _define_property(this, "fromSow", false), /**
   * @generated from field: string source_locator = 5;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string quote = 6;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EffectiveTerm, "runtime", proto3);
_define_property(EffectiveTerm, "typeName", "mono.datagateway.v1.EffectiveTerm");
_define_property(EffectiveTerm, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "stated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "from_sow",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractOccurrence
 */ export class ContractOccurrence extends Message {
    static fromBinary(bytes, options) {
        return new ContractOccurrence().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractOccurrence().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractOccurrence().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractOccurrence, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string duty_id = 2;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string rule_id = 3;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: string workstream_id = 4;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string exercise_id = 5;
   */ _define_property(this, "exerciseId", ""), /**
   * @generated from field: string period_of_performance_id = 6;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: string event_id = 7;
   */ _define_property(this, "eventId", ""), /**
   * @generated from field: string period_key = 8;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: string label = 9;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string nominal_due_on = 10;
   */ _define_property(this, "nominalDueOn", ""), /**
   * @generated from field: string due_on = 11;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: string moved_from_due_on = 12;
   */ _define_property(this, "movedFromDueOn", ""), /**
   * @generated from field: string moved_reason = 13;
   */ _define_property(this, "movedReason", ""), /**
   * @generated from field: string waived_on = 14;
   */ _define_property(this, "waivedOn", ""), /**
   * @generated from field: string waiver_reason = 15;
   */ _define_property(this, "waiverReason", ""), /**
   * @generated from field: string waiver_document_id = 16;
   */ _define_property(this, "waiverDocumentId", ""), /**
   * @generated from field: bool retired = 17;
   */ _define_property(this, "retired", false), /**
   * @generated from field: string retired_reason = 18;
   */ _define_property(this, "retiredReason", ""), /**
   * @generated from field: string retired_by_modification_id = 19;
   */ _define_property(this, "retiredByModificationId", ""), /**
   * @generated from field: string retired_by_user_id = 20;
   */ _define_property(this, "retiredByUserId", ""), /**
   * @generated from field: string created_by_user_id = 21;
   */ _define_property(this, "createdByUserId", ""), /**
   * @generated from field: mono.datagateway.v1.OccurrenceStatus status = 22;
   */ _define_property(this, "status", void 0), /**
   * latest_submission is the date's latest live (not withdrawn) submission,
   * unset when none; on ListOccurrences, GetOccurrence and
   * ListOccurrenceDecisions rows.
   *
   * @generated from field: mono.datagateway.v1.OccurrenceSubmissionSummary latest_submission = 23;
   */ _define_property(this, "latestSubmission", void 0), /**
   * Derived at read time from live occurrences; never persisted.
   *
   * @generated from field: bool reassigned = 24;
   */ _define_property(this, "reassigned", false), /**
   * event is set on a date of a duty that dates an event, and on a projected
   * row (ListOccurrences include_projected). Derived at read time.
   *
   * @generated from field: mono.datagateway.v1.OccurrenceEvent event = 25;
   */ _define_property(this, "event", void 0), /**
   * dependents counts the other deliverables that follow this date: anchored
   * on the event it dates, or on its own submission or acceptance (a
   * deliverable trigger, deliverable_submitted_<duty id> /
   * deliverable_accepted_<duty id>). Such a date moves only by an approved
   * extension. Derived at read time.
   *
   * @generated from field: int32 dependents = 26;
   */ _define_property(this, "dependents", 0), /**
   * moved_document_id is the evidence on the approved extension that moved
   * this date to due_on (a program document), "" when none. Derived at read
   * time from the applied extension.
   *
   * @generated from field: string moved_document_id = 27;
   */ _define_property(this, "movedDocumentId", ""), /**
   * covered_by_duty_id (R22-A) is the deliverable whose own series delivers
   * this date (a cover, status "covered"), "" when none.
   *
   * @generated from field: string covered_by_duty_id = 28;
   */ _define_property(this, "coveredByDutyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractOccurrence, "runtime", proto3);
_define_property(ContractOccurrence, "typeName", "mono.datagateway.v1.ContractOccurrence");
_define_property(ContractOccurrence, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "nominal_due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "moved_from_due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "moved_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "waived_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "waiver_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "waiver_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "retired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 18,
            name: "retired_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "retired_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "retired_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "created_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "status",
            kind: "message",
            T: OccurrenceStatus
        },
        {
            no: 23,
            name: "latest_submission",
            kind: "message",
            T: OccurrenceSubmissionSummary
        },
        {
            no: 24,
            name: "reassigned",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 25,
            name: "event",
            kind: "message",
            T: OccurrenceEvent
        },
        {
            no: 26,
            name: "dependents",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 27,
            name: "moved_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "covered_by_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * OccurrenceEvent ties a date to an event (S6). On a date of a duty that
 * dates the event, held_on and event_id are the logged event that met it
 * (status "held"), unset while none has. On a projected row (status
 * "waiting_on_event", never stored, never late) projected is set, planned_on
 * is the event's planned date and holding_occurrence_id the date it comes
 * from; the row's id is not an occurrence id any verb takes.
 *
 * @generated from message mono.datagateway.v1.OccurrenceEvent
 */ export class OccurrenceEvent extends Message {
    static fromBinary(bytes, options) {
        return new OccurrenceEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OccurrenceEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OccurrenceEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OccurrenceEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * name is how the event reads: the title of the duty that dates it, else
   * its kind in words.
   *
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string held_on = 3;
   */ _define_property(this, "heldOn", ""), /**
   * @generated from field: string event_id = 4;
   */ _define_property(this, "eventId", ""), /**
   * business_days_late: federal workdays from the holding date to held_on.
   *
   * @generated from field: int32 business_days_late = 5;
   */ _define_property(this, "businessDaysLate", 0), /**
   * @generated from field: bool projected = 6;
   */ _define_property(this, "projected", false), /**
   * @generated from field: string planned_on = 7;
   */ _define_property(this, "plannedOn", ""), /**
   * @generated from field: string holding_occurrence_id = 8;
   */ _define_property(this, "holdingOccurrenceId", ""), /**
   * dependents, on a date of a duty that dates the event, counts the other
   * duties with a rule (one-off or cadence) anchored on the event.
   *
   * @generated from field: int32 dependents = 9;
   */ _define_property(this, "dependents", 0), /**
   * held_document_id is the program document the logged event cites: the
   * minutes or attendee list a milestone was marked held with (SAD-869).
   *
   * @generated from field: string held_document_id = 10;
   */ _define_property(this, "heldDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OccurrenceEvent, "runtime", proto3);
_define_property(OccurrenceEvent, "typeName", "mono.datagateway.v1.OccurrenceEvent");
_define_property(OccurrenceEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "held_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "business_days_late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "projected",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "planned_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "holding_occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "dependents",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "held_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * OccurrenceSubmissionSummary is a list row's view of its latest filing.
 *
 * @generated from message mono.datagateway.v1.OccurrenceSubmissionSummary
 */ export class OccurrenceSubmissionSummary extends Message {
    static fromBinary(bytes, options) {
        return new OccurrenceSubmissionSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OccurrenceSubmissionSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OccurrenceSubmissionSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OccurrenceSubmissionSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string submission_id = 1;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: int32 attempt = 2;
   */ _define_property(this, "attempt", 0), /**
   * @generated from field: string submitted_on = 3;
   */ _define_property(this, "submittedOn", ""), /**
   * @generated from field: string submitted_by_display = 4;
   */ _define_property(this, "submittedByDisplay", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSubmissionAttachment attachments = 5;
   */ _define_property(this, "attachments", []), /**
   * attested_by: as ContractSubmission.attested_by.
   *
   * @generated from field: string attested_by = 6;
   */ _define_property(this, "attestedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OccurrenceSubmissionSummary, "runtime", proto3);
_define_property(OccurrenceSubmissionSummary, "typeName", "mono.datagateway.v1.OccurrenceSubmissionSummary");
_define_property(OccurrenceSubmissionSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "attempt",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "submitted_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "submitted_by_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "attachments",
            kind: "message",
            T: ContractSubmissionAttachment,
            repeated: true
        },
        {
            no: 6,
            name: "attested_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * OccurrenceStatus is occurrencestatus.Status on the request's as_of day.
 *
 * @generated from message mono.datagateway.v1.OccurrenceStatus
 */ export class OccurrenceStatus extends Message {
    static fromBinary(bytes, options) {
        return new OccurrenceStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OccurrenceStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OccurrenceStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OccurrenceStatus, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string state = 1;
   */ _define_property(this, "state", ""), /**
   * @generated from field: bool waived = 2;
   */ _define_property(this, "waived", false), /**
   * @generated from field: int32 attempt = 3;
   */ _define_property(this, "attempt", 0), /**
   * @generated from field: bool timing_known = 4;
   */ _define_property(this, "timingKnown", false), /**
   * @generated from field: bool on_time = 5;
   */ _define_property(this, "onTime", false), /**
   * @generated from field: int32 days_late = 6;
   */ _define_property(this, "daysLate", 0), /**
   * @generated from field: bool auto_approved = 7;
   */ _define_property(this, "autoApproved", false), /**
   * pending_submission_id is, on an approved date, a later live submission
   * still awaiting review (SAD-991); "" with none. The state stays approved.
   *
   * @generated from field: string pending_submission_id = 8;
   */ _define_property(this, "pendingSubmissionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OccurrenceStatus, "runtime", proto3);
_define_property(OccurrenceStatus, "typeName", "mono.datagateway.v1.OccurrenceStatus");
_define_property(OccurrenceStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "waived",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "attempt",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "timing_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "on_time",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "days_late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "auto_approved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "pending_submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractEvent
 */ export class ContractEvent extends Message {
    static fromBinary(bytes, options) {
        return new ContractEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string workstream_id = 3;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string duty_id = 4;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string kind = 5;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string occurred_on = 6;
   */ _define_property(this, "occurredOn", ""), /**
   * @generated from field: string label = 7;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string source_document_id = 8;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 9;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string recorded_by_user_id = 10;
   */ _define_property(this, "recordedByUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractEvent, "runtime", proto3);
_define_property(ContractEvent, "typeName", "mono.datagateway.v1.ContractEvent");
_define_property(ContractEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "occurred_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "recorded_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractWorkstream
 */ export class ContractWorkstream extends Message {
    static fromBinary(bytes, options) {
        return new ContractWorkstream().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractWorkstream().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractWorkstream().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractWorkstream, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: repeated string aliases = 4;
   */ _define_property(this, "aliases", []), /**
   * @generated from field: string named_by_modification_id = 5;
   */ _define_property(this, "namedByModificationId", ""), /**
   * @generated from field: string owner_contact_id = 6;
   */ _define_property(this, "ownerContactId", ""), /**
   * line_numbers are the base and option-period lines the team owns
   * ("0001AE"; "0001" owns its sub-lines too). Optional-task lines are
   * linked by their exercise (SetExerciseWorkstream).
   *
   * @generated from field: repeated string line_numbers = 7;
   */ _define_property(this, "lineNumbers", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractWorkstream, "runtime", proto3);
_define_property(ContractWorkstream, "typeName", "mono.datagateway.v1.ContractWorkstream");
_define_property(ContractWorkstream, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "aliases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "named_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "line_numbers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractWorkstreamLineage
 */ export class ContractWorkstreamLineage extends Message {
    static fromBinary(bytes, options) {
        return new ContractWorkstreamLineage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractWorkstreamLineage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractWorkstreamLineage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractWorkstreamLineage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string predecessor_workstream_id = 2;
   */ _define_property(this, "predecessorWorkstreamId", ""), /**
   * @generated from field: string successor_workstream_id = 3;
   */ _define_property(this, "successorWorkstreamId", ""), /**
   * @generated from field: string effective_on = 4;
   */ _define_property(this, "effectiveOn", ""), /**
   * @generated from field: string source_document_id = 5;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 6;
   */ _define_property(this, "sourceLocator", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractWorkstreamLineage, "runtime", proto3);
_define_property(ContractWorkstreamLineage, "typeName", "mono.datagateway.v1.ContractWorkstreamLineage");
_define_property(ContractWorkstreamLineage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "predecessor_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "successor_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "effective_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractSow
 */ export class ContractSow extends Message {
    static fromBinary(bytes, options) {
        return new ContractSow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractSow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractSow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractSow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string workstream_id = 2;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string version = 4;
   */ _define_property(this, "version", ""), /**
   * @generated from field: string approved_on = 5;
   */ _define_property(this, "approvedOn", ""), /**
   * @generated from field: string pop_start = 6;
   */ _define_property(this, "popStart", ""), /**
   * @generated from field: string pop_end = 7;
   */ _define_property(this, "popEnd", ""), /**
   * @generated from field: string program_document_id = 8;
   */ _define_property(this, "programDocumentId", ""), /**
   * @generated from field: bool terms_known = 9;
   */ _define_property(this, "termsKnown", false), /**
   * @generated from field: string named_in_sow_id = 10;
   */ _define_property(this, "namedInSowId", ""), /**
   * @generated from field: string named_in_locator = 11;
   */ _define_property(this, "namedInLocator", ""), /**
   * @generated from field: string named_in_quote = 12;
   */ _define_property(this, "namedInQuote", ""), /**
   * @generated from field: string supersedes_sow_id = 13;
   */ _define_property(this, "supersedesSowId", ""), /**
   * state is derived on the request's as_of day: approved_waiting | in_force | ended.
   *
   * @generated from field: string state = 14;
   */ _define_property(this, "state", ""), /**
   * dossier_json (R17-B) is the SOW's rows as its reading kept them (what it
   * says about each deliverable it could owe); set only on a
   * ListWorkstreams with include_dossiers.
   *
   * @generated from field: string dossier_json = 15;
   */ _define_property(this, "dossierJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractSow, "runtime", proto3);
_define_property(ContractSow, "typeName", "mono.datagateway.v1.ContractSow");
_define_property(ContractSow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "approved_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pop_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pop_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "program_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "terms_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "named_in_sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "named_in_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "named_in_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "supersedes_sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "dossier_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SowGapRuling
 */ export class SowGapRuling extends Message {
    static fromBinary(bytes, options) {
        return new SowGapRuling().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SowGapRuling().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SowGapRuling().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SowGapRuling, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string workstream_id = 2;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string from_on = 3;
   */ _define_property(this, "fromOn", ""), /**
   * @generated from field: string to_on = 4;
   */ _define_property(this, "toOn", ""), /**
   * @generated from field: string ruling = 5;
   */ _define_property(this, "ruling", ""), /**
   * @generated from field: string sow_id = 6;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string decided_by_user_id = 7;
   */ _define_property(this, "decidedByUserId", ""), /**
   * @generated from field: string change_item_id = 8;
   */ _define_property(this, "changeItemId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SowGapRuling, "runtime", proto3);
_define_property(SowGapRuling, "typeName", "mono.datagateway.v1.SowGapRuling");
_define_property(SowGapRuling, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "to_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ruling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "decided_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "change_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractSubmissionAttachment
 */ export class ContractSubmissionAttachment extends Message {
    static fromBinary(bytes, options) {
        return new ContractSubmissionAttachment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractSubmissionAttachment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractSubmissionAttachment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractSubmissionAttachment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string url = 3;
   */ _define_property(this, "url", ""), /**
   * link_kind is derived by the database from url.
   *
   * @generated from field: string link_kind = 4;
   */ _define_property(this, "linkKind", ""), /**
   * @generated from field: string label = 5;
   */ _define_property(this, "label", ""), /**
   * filename, size_bytes and mime_type come from artifacts.artifacts
   * (one join per page), never a tesoro lookup. Empty on a link.
   *
   * @generated from field: string filename = 6;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: int64 size_bytes = 7;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * @generated from field: string mime_type = 8;
   */ _define_property(this, "mimeType", ""), /**
   * openable is whether this caller can open the file in the app: a
   * link always; a stored file on a live submission; a withdrawn
   * file only when the caller owns it (source_read_context / D6).
   *
   * @generated from field: bool openable = 9;
   */ _define_property(this, "openable", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractSubmissionAttachment, "runtime", proto3);
_define_property(ContractSubmissionAttachment, "typeName", "mono.datagateway.v1.ContractSubmissionAttachment");
_define_property(ContractSubmissionAttachment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "link_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 8,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "openable",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractSubmissionReview
 */ export class ContractSubmissionReview extends Message {
    static fromBinary(bytes, options) {
        return new ContractSubmissionReview().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractSubmissionReview().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractSubmissionReview().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractSubmissionReview, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string submission_id = 2;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string tier = 3;
   */ _define_property(this, "tier", ""), /**
   * @generated from field: string decision = 4;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string reviewer_contact_id = 5;
   */ _define_property(this, "reviewerContactId", ""), /**
   * @generated from field: string reviewer_display = 6;
   */ _define_property(this, "reviewerDisplay", ""), /**
   * @generated from field: string decided_on = 7;
   */ _define_property(this, "decidedOn", ""), /**
   * @generated from field: string notes = 8;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string evidence_artifact_id = 9;
   */ _define_property(this, "evidenceArtifactId", ""), /**
   * @generated from field: string recorded_by_user_id = 10;
   */ _define_property(this, "recordedByUserId", ""), /**
   * @generated from field: string superseded_by_id = 11;
   */ _define_property(this, "supersededById", ""), /**
   * @generated from field: bool superseded = 12;
   */ _define_property(this, "superseded", false), /**
   * evidence_filename / size / mime come from artifacts.artifacts
   * with the attachment join. Empty when there is no evidence file.
   * The UI does not offer Open for review evidence, so chat marks it
   * not openable (D6).
   *
   * @generated from field: string evidence_filename = 13;
   */ _define_property(this, "evidenceFilename", ""), /**
   * @generated from field: int64 evidence_size_bytes = 14;
   */ _define_property(this, "evidenceSizeBytes", protoInt64.zero), /**
   * @generated from field: string evidence_mime_type = 15;
   */ _define_property(this, "evidenceMimeType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractSubmissionReview, "runtime", proto3);
_define_property(ContractSubmissionReview, "typeName", "mono.datagateway.v1.ContractSubmissionReview");
_define_property(ContractSubmissionReview, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reviewer_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reviewer_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "decided_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "evidence_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "recorded_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "superseded_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "evidence_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "evidence_size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 15,
            name: "evidence_mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractSubmission
 */ export class ContractSubmission extends Message {
    static fromBinary(bytes, options) {
        return new ContractSubmission().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractSubmission().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractSubmission().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractSubmission, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string occurrence_id = 2;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string sibling_of_submission_id = 3;
   */ _define_property(this, "siblingOfSubmissionId", ""), /**
   * attempt is derived: the submission's place among its occurrence's.
   *
   * @generated from field: int32 attempt = 4;
   */ _define_property(this, "attempt", 0), /**
   * @generated from field: string submitted_on = 5;
   */ _define_property(this, "submittedOn", ""), /**
   * submitted_at is RFC 3339, set only when the source gave an instant.
   *
   * @generated from field: string submitted_at = 6;
   */ _define_property(this, "submittedAt", ""), /**
   * @generated from field: string submitted_by_contact_id = 7;
   */ _define_property(this, "submittedByContactId", ""), /**
   * @generated from field: string submitted_by_display = 8;
   */ _define_property(this, "submittedByDisplay", ""), /**
   * @generated from field: repeated string sent_to_contact_ids = 9;
   */ _define_property(this, "sentToContactIds", []), /**
   * @generated from field: string note = 10;
   */ _define_property(this, "note", ""), /**
   * @generated from field: string recorded_by_user_id = 11;
   */ _define_property(this, "recordedByUserId", ""), /**
   * @generated from field: bool withdrawn = 12;
   */ _define_property(this, "withdrawn", false), /**
   * @generated from field: string withdrawn_reason = 13;
   */ _define_property(this, "withdrawnReason", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSubmissionAttachment attachments = 14;
   */ _define_property(this, "attachments", []), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSubmissionReview reviews = 15;
   */ _define_property(this, "reviews", []), /**
   * attested_by is set on a submission a client's record of its deliverables
   * states with no document ("attested by evidence, no document"): the
   * source and its row. Such a submission has no attachment.
   *
   * @generated from field: string attested_by = 16;
   */ _define_property(this, "attestedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractSubmission, "runtime", proto3);
_define_property(ContractSubmission, "typeName", "mono.datagateway.v1.ContractSubmission");
_define_property(ContractSubmission, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sibling_of_submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "attempt",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "submitted_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "submitted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "submitted_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "submitted_by_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sent_to_contact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "recorded_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "withdrawn",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "withdrawn_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "attachments",
            kind: "message",
            T: ContractSubmissionAttachment,
            repeated: true
        },
        {
            no: 15,
            name: "reviews",
            kind: "message",
            T: ContractSubmissionReview,
            repeated: true
        },
        {
            no: 16,
            name: "attested_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DutyCheck is a read-time check (design §6.2): a warning shown on the duty,
 * never staged. fix_verb names the RPC that clears it.
 *
 * @generated from message mono.datagateway.v1.DutyCheck
 */ export class DutyCheck extends Message {
    static fromBinary(bytes, options) {
        return new DutyCheck().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutyCheck().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutyCheck().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutyCheck, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string code = 1;
   */ _define_property(this, "code", ""), /**
   * @generated from field: string message = 2;
   */ _define_property(this, "message", ""), /**
   * @generated from field: string fix_verb = 3;
   */ _define_property(this, "fixVerb", ""), /**
   * @generated from field: string rule_id = 4;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: string workstream_id = 5;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string period_of_performance_id = 6;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: string exercise_id = 7;
   */ _define_property(this, "exerciseId", ""), /**
   * @generated from field: string from_on = 8;
   */ _define_property(this, "fromOn", ""), /**
   * @generated from field: string to_on = 9;
   */ _define_property(this, "toOn", ""), /**
   * suggested_on is a date the reviewer may accept, never applied by itself
   * (D98, D107): on a needs_start_date check of a receipt-of-order rule on an
   * option period, the effective date of the one applied modification that
   * exercised the period. suggested_label is that modification's number
   * (P00003) and suggested_document_id its program document, when on file.
   *
   * @generated from field: string suggested_on = 10;
   */ _define_property(this, "suggestedOn", ""), /**
   * @generated from field: string suggested_label = 11;
   */ _define_property(this, "suggestedLabel", ""), /**
   * @generated from field: string suggested_document_id = 12;
   */ _define_property(this, "suggestedDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DutyCheck, "runtime", proto3);
_define_property(DutyCheck, "typeName", "mono.datagateway.v1.DutyCheck");
_define_property(DutyCheck, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "fix_verb",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "from_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "to_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "suggested_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "suggested_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "suggested_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DutyCheckCodes is one duty's check codes.
 *
 * @generated from message mono.datagateway.v1.DutyCheckCodes
 */ export class DutyCheckCodes extends Message {
    static fromBinary(bytes, options) {
        return new DutyCheckCodes().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutyCheckCodes().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutyCheckCodes().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutyCheckCodes, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string codes = 1;
   */ _define_property(this, "codes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DutyCheckCodes, "runtime", proto3);
_define_property(DutyCheckCodes, "typeName", "mono.datagateway.v1.DutyCheckCodes");
_define_property(DutyCheckCodes, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * DutyFields is a duty's writable content.
 *
 * @generated from message mono.datagateway.v1.DutyFields
 */ export class DutyFields extends Message {
    static fromBinary(bytes, options) {
        return new DutyFields().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutyFields().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutyFields().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutyFields, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string pws_ref = 2;
   */ _define_property(this, "pwsRef", ""), /**
   * @generated from field: string letter = 3;
   */ _define_property(this, "letter", ""), /**
   * @generated from field: repeated string aliases = 4;
   */ _define_property(this, "aliases", []), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string format = 6;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 7;
   */ _define_property(this, "submissionMethod", ""), /**
   * @generated from field: string acceptance_criteria = 8;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * final_review_tier "" takes the default (va_pm).
   *
   * @generated from field: string final_review_tier = 9;
   */ _define_property(this, "finalReviewTier", ""), /**
   * @generated from field: string source_document_id = 10;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 11;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string introduced_by_modification_id = 12;
   */ _define_property(this, "introducedByModificationId", ""), /**
   * @generated from field: string ended_by_modification_id = 13;
   */ _define_property(this, "endedByModificationId", ""), /**
   * @generated from field: string ended_on = 14;
   */ _define_property(this, "endedOn", ""), /**
   * event_kind: the event this duty dates ("" = none). One live duty per
   * kind; native kinds and on_request are refused.
   *
   * @generated from field: string event_kind = 15;
   */ _define_property(this, "eventKind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DutyFields, "runtime", proto3);
_define_property(DutyFields, "typeName", "mono.datagateway.v1.DutyFields");
_define_property(DutyFields, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pws_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "letter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "aliases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "final_review_tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "introduced_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "ended_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "ended_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateDutyRequest
 */ export class CreateDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string duty_key = 4;
   */ _define_property(this, "dutyKey", ""), /**
   * origin: award | modification | sow | manual; "" = manual.
   *
   * @generated from field: string origin = 5;
   */ _define_property(this, "origin", ""), /**
   * sow_id is required with origin "sow", which also writes the SOW's
   * automatic "performed" assignment (design §2.3).
   *
   * @generated from field: string sow_id = 6;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: mono.datagateway.v1.DutyFields fields = 7;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDutyRequest, "runtime", proto3);
_define_property(CreateDutyRequest, "typeName", "mono.datagateway.v1.CreateDutyRequest");
_define_property(CreateDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "duty_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "fields",
            kind: "message",
            T: DutyFields
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateDutyResponse
 */ export class CreateDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractDuty duty = 1;
   */ _define_property(this, "duty", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDutyResponse, "runtime", proto3);
_define_property(CreateDutyResponse, "typeName", "mono.datagateway.v1.CreateDutyResponse");
_define_property(CreateDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty",
            kind: "message",
            T: ContractDuty
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * UpdateDutyRequest replaces the duty's writable content. duty_key and origin
 * are its identity and never change.
 *
 * @generated from message mono.datagateway.v1.UpdateDutyRequest
 */ export class UpdateDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string duty_id = 4;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: mono.datagateway.v1.DutyFields fields = 5;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDutyRequest, "runtime", proto3);
_define_property(UpdateDutyRequest, "typeName", "mono.datagateway.v1.UpdateDutyRequest");
_define_property(UpdateDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "fields",
            kind: "message",
            T: DutyFields
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateDutyResponse
 */ export class UpdateDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractDuty duty = 1;
   */ _define_property(this, "duty", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDutyResponse, "runtime", proto3);
_define_property(UpdateDutyResponse, "typeName", "mono.datagateway.v1.UpdateDutyResponse");
_define_property(UpdateDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty",
            kind: "message",
            T: ContractDuty
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteDutyRequest
 */ export class DeleteDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string duty_id = 4;
   */ _define_property(this, "dutyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDutyRequest, "runtime", proto3);
_define_property(DeleteDutyRequest, "typeName", "mono.datagateway.v1.DeleteDutyRequest");
_define_property(DeleteDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteDutyResponse
 */ export class DeleteDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDutyResponse, "runtime", proto3);
_define_property(DeleteDutyResponse, "typeName", "mono.datagateway.v1.DeleteDutyResponse");
_define_property(DeleteDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDutyRequest
 */ export class GetDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string duty_id = 3;
   */ _define_property(this, "dutyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDutyRequest, "runtime", proto3);
_define_property(GetDutyRequest, "typeName", "mono.datagateway.v1.GetDutyRequest");
_define_property(GetDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDutyResponse
 */ export class GetDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractDuty duty = 1;
   */ _define_property(this, "duty", void 0), /**
   * rules are the award rules; team rules ride on their assignment.
   *
   * @generated from field: repeated mono.datagateway.v1.ContractScheduleRule rules = 2;
   */ _define_property(this, "rules", []), /**
   * @generated from field: repeated mono.datagateway.v1.ContractDutyAssignment assignments = 3;
   */ _define_property(this, "assignments", []), /**
   * @generated from field: repeated mono.datagateway.v1.DutyCheck checks = 4;
   */ _define_property(this, "checks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDutyResponse, "runtime", proto3);
_define_property(GetDutyResponse, "typeName", "mono.datagateway.v1.GetDutyResponse");
_define_property(GetDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty",
            kind: "message",
            T: ContractDuty
        },
        {
            no: 2,
            name: "rules",
            kind: "message",
            T: ContractScheduleRule,
            repeated: true
        },
        {
            no: 3,
            name: "assignments",
            kind: "message",
            T: ContractDutyAssignment,
            repeated: true
        },
        {
            no: 4,
            name: "checks",
            kind: "message",
            T: DutyCheck,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDutiesRequest
 */ export class ListDutiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDutiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDutiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDutiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDutiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * include_rules: also return every live rule of the duties (award and
   * team), e.g. to read each duty's CLIN (rule clin_id).
   *
   * @generated from field: bool include_rules = 3;
   */ _define_property(this, "includeRules", false), /**
   * include_detail (SAD-994): also return, per listed duty, exactly what
   * GetDuty returns for it (details), so a page that needs every duty's
   * assignments and checks makes one call, not one per duty.
   *
   * @generated from field: bool include_detail = 4;
   */ _define_property(this, "includeDetail", false), /**
   * workstream_id (SAD-997): list only the duties a SOW of this workstream
   * assigns (any handling: performed, routed or not owed), the rows the
   * team page reads a duty's detail for. Every other field of the answer
   * is ListDuties' own, kept for those duties only. "" lists every duty; a
   * workstream not in the program is NotFound.
   *
   * @generated from field: string workstream_id = 5;
   */ _define_property(this, "workstreamId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDutiesRequest, "runtime", proto3);
_define_property(ListDutiesRequest, "typeName", "mono.datagateway.v1.ListDutiesRequest");
_define_property(ListDutiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_rules",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "include_detail",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDutiesResponse
 */ export class ListDutiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDutiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDutiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDutiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDutiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractDuty duties = 1;
   */ _define_property(this, "duties", []), /**
   * check_codes: each duty's GetDuty check codes, by duty id (a duty with
   * none is absent), so a list can badge "needs a start date" without a
   * GetDuty per row.
   *
   * @generated from field: map<string, mono.datagateway.v1.DutyCheckCodes> check_codes = 2;
   */ _define_property(this, "checkCodes", {}), /**
   * rules is set only with include_rules.
   *
   * @generated from field: repeated mono.datagateway.v1.ContractScheduleRule rules = 3;
   */ _define_property(this, "rules", []), /**
   * undated_reasons (SAD-967): per deliverable row, why it would hold no
   * firm date, read from the rules that govern that row, so a list renders
   * the reason and never infers it from another row's check.
   *
   * @generated from field: repeated mono.datagateway.v1.UndatedReason undated_reasons = 4;
   */ _define_property(this, "undatedReasons", []), /**
   * routings (SAD-975): each SOW routing of a listed deliverable from one
   * team to another, so a list names where it went without a GetDuty per row.
   *
   * @generated from field: repeated mono.datagateway.v1.DutyRouting routings = 5;
   */ _define_property(this, "routings", []), /**
   * watches (SAD-978): each team whose SOW routing hands a listed
   * deliverable's dates to another team (the owner, at the end of the
   * routing chain). The watcher sees those dates read-only.
   *
   * @generated from field: repeated mono.datagateway.v1.DutyWatch watches = 6;
   */ _define_property(this, "watches", []), /**
   * details is set only with include_detail: one GetDuty answer per listed
   * duty, in the order of duties, each equal to GetDuty for that duty.
   *
   * @generated from field: repeated mono.datagateway.v1.GetDutyResponse details = 7;
   */ _define_property(this, "details", []), /**
   * clauses (R10-B) is set only with include_rules: the program's accepted
   * PWS clauses (M4), each an optional task that performs every deliverable
   * of a PWS section, so a SOW reader can list a team's inherited
   * deliverables as candidates.
   *
   * @generated from field: repeated mono.datagateway.v1.DutyClause clauses = 8;
   */ _define_property(this, "clauses", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDutiesResponse, "runtime", proto3);
_define_property(ListDutiesResponse, "typeName", "mono.datagateway.v1.ListDutiesResponse");
_define_property(ListDutiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duties",
            kind: "message",
            T: ContractDuty,
            repeated: true
        },
        {
            no: 2,
            name: "check_codes",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: DutyCheckCodes
            }
        },
        {
            no: 3,
            name: "rules",
            kind: "message",
            T: ContractScheduleRule,
            repeated: true
        },
        {
            no: 4,
            name: "undated_reasons",
            kind: "message",
            T: UndatedReason,
            repeated: true
        },
        {
            no: 5,
            name: "routings",
            kind: "message",
            T: DutyRouting,
            repeated: true
        },
        {
            no: 6,
            name: "watches",
            kind: "message",
            T: DutyWatch,
            repeated: true
        },
        {
            no: 7,
            name: "details",
            kind: "message",
            T: GetDutyResponse,
            repeated: true
        },
        {
            no: 8,
            name: "clauses",
            kind: "message",
            T: DutyClause,
            repeated: true
        }
    ]));
/**
 * DutyClause is one accepted PWS clause: the optional task performs every
 * deliverable of the section (M4).
 *
 * @generated from message mono.datagateway.v1.DutyClause
 */ export class DutyClause extends Message {
    static fromBinary(bytes, options) {
        return new DutyClause().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutyClause().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutyClause().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutyClause, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string optional_task_id = 1;
   */ _define_property(this, "optionalTaskId", ""), /**
   * @generated from field: string section = 2;
   */ _define_property(this, "section", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DutyClause, "runtime", proto3);
_define_property(DutyClause, "typeName", "mono.datagateway.v1.DutyClause");
_define_property(DutyClause, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DutyWatch is one team watching a deliverable its SOW routed: the owner
 * team owes the dates; the watcher only sees them.
 *
 * @generated from message mono.datagateway.v1.DutyWatch
 */ export class DutyWatch extends Message {
    static fromBinary(bytes, options) {
        return new DutyWatch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutyWatch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutyWatch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutyWatch, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string duty_id = 1;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string watcher_workstream_id = 2;
   */ _define_property(this, "watcherWorkstreamId", ""), /**
   * @generated from field: string owner_workstream_id = 3;
   */ _define_property(this, "ownerWorkstreamId", ""), /**
   * disposition (R12-C) is why the watcher sees the owner's dates:
   * FULFILLED_ELSEWHERE (its SOW routes the deliverable to the owner team),
   * BASE_SCOPE (to the contract), or SHARED_DELIVERY: a deliverable the
   * watcher reaches by a clause and the contract level owes, one series
   * (SHARED_SERIES) one filing satisfies for every team it is shared with.
   *
   * @generated from field: mono.common.v1.ExecutionPerformanceDisposition disposition = 4;
   */ _define_property(this, "disposition", ExecutionPerformanceDisposition.UNSPECIFIED), /**
   * from_on and to_on (R16-A, YYYY-MM-DD, "" open) bound the days the watch
   * holds: the term of the watcher's SOW that routes or shares the
   * deliverable. A routing reaches only its own SOW's period.
   *
   * @generated from field: string from_on = 5;
   */ _define_property(this, "fromOn", ""), /**
   * @generated from field: string to_on = 6;
   */ _define_property(this, "toOn", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DutyWatch, "runtime", proto3);
_define_property(DutyWatch, "typeName", "mono.datagateway.v1.DutyWatch");
_define_property(DutyWatch, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "watcher_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "disposition",
            kind: "enum",
            T: proto3.getEnumType(ExecutionPerformanceDisposition)
        },
        {
            no: 5,
            name: "from_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "to_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DutyRouting is one SOW's routing of a deliverable: the SOW's team
 * (from_workstream_id) sends it to to_workstream_id.
 *
 * @generated from message mono.datagateway.v1.DutyRouting
 */ export class DutyRouting extends Message {
    static fromBinary(bytes, options) {
        return new DutyRouting().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutyRouting().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutyRouting().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutyRouting, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string duty_id = 1;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string sow_id = 2;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string from_workstream_id = 3;
   */ _define_property(this, "fromWorkstreamId", ""), /**
   * @generated from field: string to_workstream_id = 4;
   */ _define_property(this, "toWorkstreamId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DutyRouting, "runtime", proto3);
_define_property(DutyRouting, "typeName", "mono.datagateway.v1.DutyRouting");
_define_property(DutyRouting, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "to_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * UndatedReason is one deliverable row's reason for holding no firm date in
 * its window. assignment_id "" is the row of the award rules (contract-wide,
 * and a team whose SOW sets no team rule for the duty); otherwise the row of
 * that SOW assignment's team rules, whose team is workstream_id.
 *
 * @generated from message mono.datagateway.v1.UndatedReason
 */ export class UndatedReason extends Message {
    static fromBinary(bytes, options) {
        return new UndatedReason().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UndatedReason().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UndatedReason().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UndatedReason, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string duty_id = 1;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string assignment_id = 2;
   */ _define_property(this, "assignmentId", ""), /**
   * @generated from field: string workstream_id = 3;
   */ _define_property(this, "workstreamId", ""), /**
   * reason: on_request (a governing rule is due after a government ask, or
   * after each occurrence of an as_needed_* condition) | waiting_on_event (a
   * governing rule waits on an event not logged) | needs_start_date (a
   * governing rule has no first date, or the row has no rule) |
   * none_this_period.
   *
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", ""), /**
   * rule_id is the governing rule the reason reads; event_kind and
   * event_label are its event (event_label: the event in words, for
   * waiting_on_event and an as_needed_* condition).
   *
   * @generated from field: string rule_id = 5;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: string event_kind = 6;
   */ _define_property(this, "eventKind", ""), /**
   * @generated from field: string event_label = 7;
   */ _define_property(this, "eventLabel", ""), /**
   * The on_request rule's offset ("within 10 days"); has_offset false = none.
   *
   * @generated from field: bool has_offset = 8;
   */ _define_property(this, "hasOffset", false), /**
   * @generated from field: int32 offset_n = 9;
   */ _define_property(this, "offsetN", 0), /**
   * @generated from field: string offset_unit = 10;
   */ _define_property(this, "offsetUnit", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UndatedReason, "runtime", proto3);
_define_property(UndatedReason, "typeName", "mono.datagateway.v1.UndatedReason");
_define_property(UndatedReason, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "event_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "has_offset",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "offset_n",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "offset_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ScheduleRuleFields is a rule's typed content (migration 000212's columns).
 *
 * @generated from message mono.datagateway.v1.ScheduleRuleFields
 */ export class ScheduleRuleFields extends Message {
    static fromBinary(bytes, options) {
        return new ScheduleRuleFields().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScheduleRuleFields().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScheduleRuleFields().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScheduleRuleFields, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_id = 1;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: string gate = 2;
   */ _define_property(this, "gate", ""), /**
   * @generated from field: string period_of_performance_id = 3;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: string optional_task_id = 4;
   */ _define_property(this, "optionalTaskId", ""), /**
   * @generated from field: string kind = 5;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string due_on = 6;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: bool has_offset = 7;
   */ _define_property(this, "hasOffset", false), /**
   * @generated from field: int32 offset_n = 8;
   */ _define_property(this, "offsetN", 0), /**
   * @generated from field: string offset_unit = 9;
   */ _define_property(this, "offsetUnit", ""), /**
   * @generated from field: string cadence = 10;
   */ _define_property(this, "cadence", ""), /**
   * cadence_interval 0 = 1.
   *
   * @generated from field: int32 cadence_interval = 11;
   */ _define_property(this, "cadenceInterval", 0), /**
   * @generated from field: repeated int32 day_ordinals = 12;
   */ _define_property(this, "dayOrdinals", []), /**
   * @generated from field: string day_weekday = 13;
   */ _define_property(this, "dayWeekday", ""), /**
   * @generated from field: string day_basis = 14;
   */ _define_property(this, "dayBasis", ""), /**
   * @generated from field: string event_kind = 15;
   */ _define_property(this, "eventKind", ""), /**
   * @generated from field: repeated string subjects = 16;
   */ _define_property(this, "subjects", []), /**
   * @generated from field: string rule_text = 17;
   */ _define_property(this, "ruleText", ""), /**
   * @generated from field: string source_document_id = 18;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 19;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string effective_from = 20;
   */ _define_property(this, "effectiveFrom", ""), /**
   * @generated from field: string effective_to = 21;
   */ _define_property(this, "effectiveTo", ""), /**
   * @generated from field: string established_by_modification_id = 22;
   */ _define_property(this, "establishedByModificationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ScheduleRuleFields, "runtime", proto3);
_define_property(ScheduleRuleFields, "typeName", "mono.datagateway.v1.ScheduleRuleFields");
_define_property(ScheduleRuleFields, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "gate",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "has_offset",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "offset_n",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "offset_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "cadence_interval",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "day_ordinals",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        },
        {
            no: 13,
            name: "day_weekday",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "day_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "subjects",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 17,
            name: "rule_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "effective_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "effective_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "established_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateScheduleRuleRequest
 */ export class CreateScheduleRuleRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateScheduleRuleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateScheduleRuleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateScheduleRuleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateScheduleRuleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string duty_id = 4;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: mono.datagateway.v1.ScheduleRuleFields fields = 5;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateScheduleRuleRequest, "runtime", proto3);
_define_property(CreateScheduleRuleRequest, "typeName", "mono.datagateway.v1.CreateScheduleRuleRequest");
_define_property(CreateScheduleRuleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "fields",
            kind: "message",
            T: ScheduleRuleFields
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateScheduleRuleResponse
 */ export class CreateScheduleRuleResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateScheduleRuleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateScheduleRuleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateScheduleRuleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateScheduleRuleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractScheduleRule rule = 1;
   */ _define_property(this, "rule", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateScheduleRuleResponse, "runtime", proto3);
_define_property(CreateScheduleRuleResponse, "typeName", "mono.datagateway.v1.CreateScheduleRuleResponse");
_define_property(CreateScheduleRuleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rule",
            kind: "message",
            T: ContractScheduleRule
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * UpdateScheduleRuleRequest replaces the rule's content in place (the fix for
 * "needs a start date"). A mod's change is a new rule, not an edit.
 *
 * @generated from message mono.datagateway.v1.UpdateScheduleRuleRequest
 */ export class UpdateScheduleRuleRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateScheduleRuleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateScheduleRuleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateScheduleRuleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateScheduleRuleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string rule_id = 4;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: mono.datagateway.v1.ScheduleRuleFields fields = 5;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateScheduleRuleRequest, "runtime", proto3);
_define_property(UpdateScheduleRuleRequest, "typeName", "mono.datagateway.v1.UpdateScheduleRuleRequest");
_define_property(UpdateScheduleRuleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "fields",
            kind: "message",
            T: ScheduleRuleFields
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateScheduleRuleResponse
 */ export class UpdateScheduleRuleResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateScheduleRuleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateScheduleRuleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateScheduleRuleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateScheduleRuleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractScheduleRule rule = 1;
   */ _define_property(this, "rule", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateScheduleRuleResponse, "runtime", proto3);
_define_property(UpdateScheduleRuleResponse, "typeName", "mono.datagateway.v1.UpdateScheduleRuleResponse");
_define_property(UpdateScheduleRuleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rule",
            kind: "message",
            T: ContractScheduleRule
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteScheduleRuleRequest
 */ export class DeleteScheduleRuleRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteScheduleRuleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteScheduleRuleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteScheduleRuleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteScheduleRuleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string rule_id = 4;
   */ _define_property(this, "ruleId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteScheduleRuleRequest, "runtime", proto3);
_define_property(DeleteScheduleRuleRequest, "typeName", "mono.datagateway.v1.DeleteScheduleRuleRequest");
_define_property(DeleteScheduleRuleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteScheduleRuleResponse
 */ export class DeleteScheduleRuleResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteScheduleRuleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteScheduleRuleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteScheduleRuleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteScheduleRuleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteScheduleRuleResponse, "runtime", proto3);
_define_property(DeleteScheduleRuleResponse, "typeName", "mono.datagateway.v1.DeleteScheduleRuleResponse");
_define_property(DeleteScheduleRuleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddOccurrenceRequest
 */ export class AddOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string duty_id = 4;
   */ _define_property(this, "dutyId", ""), /**
   * due_on "" = due unknown.
   *
   * @generated from field: string due_on = 5;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: string label = 6;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string workstream_id = 7;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string period_of_performance_id = 8;
   */ _define_property(this, "periodOfPerformanceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddOccurrenceRequest, "runtime", proto3);
_define_property(AddOccurrenceRequest, "typeName", "mono.datagateway.v1.AddOccurrenceRequest");
_define_property(AddOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddOccurrenceResponse
 */ export class AddOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 1;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddOccurrenceResponse, "runtime", proto3);
_define_property(AddOccurrenceResponse, "typeName", "mono.datagateway.v1.AddOccurrenceResponse");
_define_property(AddOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RemoveOccurrenceRequest
 */ export class RemoveOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 4;
   */ _define_property(this, "occurrenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveOccurrenceRequest, "runtime", proto3);
_define_property(RemoveOccurrenceRequest, "typeName", "mono.datagateway.v1.RemoveOccurrenceRequest");
_define_property(RemoveOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RemoveOccurrenceResponse
 */ export class RemoveOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveOccurrenceResponse, "runtime", proto3);
_define_property(RemoveOccurrenceResponse, "typeName", "mono.datagateway.v1.RemoveOccurrenceResponse");
_define_property(RemoveOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MoveOccurrenceRequest
 */ export class MoveOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new MoveOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 4;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string due_on = 5;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveOccurrenceRequest, "runtime", proto3);
_define_property(MoveOccurrenceRequest, "typeName", "mono.datagateway.v1.MoveOccurrenceRequest");
_define_property(MoveOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MoveOccurrenceResponse
 */ export class MoveOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new MoveOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 1;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveOccurrenceResponse, "runtime", proto3);
_define_property(MoveOccurrenceResponse, "typeName", "mono.datagateway.v1.MoveOccurrenceResponse");
_define_property(MoveOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WaiveOccurrenceRequest
 */ export class WaiveOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new WaiveOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WaiveOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WaiveOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WaiveOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 4;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string waived_on = 5;
   */ _define_property(this, "waivedOn", ""), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string waiver_document_id = 7;
   */ _define_property(this, "waiverDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WaiveOccurrenceRequest, "runtime", proto3);
_define_property(WaiveOccurrenceRequest, "typeName", "mono.datagateway.v1.WaiveOccurrenceRequest");
_define_property(WaiveOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "waived_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "waiver_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WaiveOccurrenceResponse
 */ export class WaiveOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new WaiveOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WaiveOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WaiveOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WaiveOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 1;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WaiveOccurrenceResponse, "runtime", proto3);
_define_property(WaiveOccurrenceResponse, "typeName", "mono.datagateway.v1.WaiveOccurrenceResponse");
_define_property(WaiveOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MarkOccurrenceNotOwedRequest
 */ export class MarkOccurrenceNotOwedRequest extends Message {
    static fromBinary(bytes, options) {
        return new MarkOccurrenceNotOwedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkOccurrenceNotOwedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkOccurrenceNotOwedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkOccurrenceNotOwedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 4;
   */ _define_property(this, "occurrenceId", ""), /**
   * reason: not_owed | generated_in_error.
   *
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * note is required: why, in words; kept on the audit event.
   *
   * @generated from field: string note = 6;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkOccurrenceNotOwedRequest, "runtime", proto3);
_define_property(MarkOccurrenceNotOwedRequest, "typeName", "mono.datagateway.v1.MarkOccurrenceNotOwedRequest");
_define_property(MarkOccurrenceNotOwedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MarkOccurrenceNotOwedResponse
 */ export class MarkOccurrenceNotOwedResponse extends Message {
    static fromBinary(bytes, options) {
        return new MarkOccurrenceNotOwedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkOccurrenceNotOwedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkOccurrenceNotOwedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkOccurrenceNotOwedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 1;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkOccurrenceNotOwedResponse, "runtime", proto3);
_define_property(MarkOccurrenceNotOwedResponse, "typeName", "mono.datagateway.v1.MarkOccurrenceNotOwedResponse");
_define_property(MarkOccurrenceNotOwedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * OccurrenceDecision is a proposed waiver, not-owed mark, extension, or
 * submission edit/evidence addition (D111, SAD-902): an OccurrenceDecision
 * change set with one item.
 *
 * @generated from message mono.datagateway.v1.OccurrenceDecision
 */ export class OccurrenceDecision extends Message {
    static fromBinary(bytes, options) {
        return new OccurrenceDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OccurrenceDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OccurrenceDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OccurrenceDecision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string item_id = 2;
   */ _define_property(this, "itemId", ""), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * kind: waiver | not_owed | extension | submission_edit | submission_evidence |
   * waiver_evidence (SAD-1010; attachments are the additions to an applied waiver) |
   * extension_evidence (attachments are the additions to an applied extension) |
   * waiver_edit (waived_on, reason and waiver_document_id are the waiver after
   * the edit; waiver_before is the waiver it was proposed against).
   *
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * state: the change set's (UnderReview, Applied, Rejected, ...).
   *
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string proposed_by_user_id = 6;
   */ _define_property(this, "proposedByUserId", ""), /**
   * @generated from field: string approved_by_user_id = 7;
   */ _define_property(this, "approvedByUserId", ""), /**
   * @generated from field: string waived_on = 8;
   */ _define_property(this, "waivedOn", ""), /**
   * reason: the waiver's reason, or not_owed | generated_in_error.
   *
   * @generated from field: string reason = 9;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string waiver_document_id = 10;
   */ _define_property(this, "waiverDocumentId", ""), /**
   * @generated from field: string note = 11;
   */ _define_property(this, "note", ""), /**
   * state_reason is why a Rejected or Cancelled proposal ended.
   *
   * @generated from field: string state_reason = 12;
   */ _define_property(this, "stateReason", ""), /**
   * decided_by_user_id is who ended it: the approver (Applied), the
   * rejecter (Rejected) or the proposer (Cancelled, withdrawn).
   *
   * @generated from field: string decided_by_user_id = 13;
   */ _define_property(this, "decidedByUserId", ""), /**
   * proposed_at / decided_at are RFC 3339 instants; decided_at is "" while open.
   *
   * @generated from field: string proposed_at = 14;
   */ _define_property(this, "proposedAt", ""), /**
   * @generated from field: string decided_at = 15;
   */ _define_property(this, "decidedAt", ""), /**
   * due_on is an extension's proposed new due date.
   *
   * @generated from field: string due_on = 16;
   */ _define_property(this, "dueOn", ""), /**
   * evidence_document_id is the program document the proposer attached as
   * evidence (an extension's correspondence); "" when none.
   *
   * @generated from field: string evidence_document_id = 17;
   */ _define_property(this, "evidenceDocumentId", ""), /**
   * step is where the proposal stands, derived from state and value
   * (SAD-866): proposed (a waiver or extension awaiting the COR),
   * awaiting_approval (the COR agreed, or a not-owed mark, which needs no
   * COR), approved, cor_declined, rejected or withdrawn.
   *
   * @generated from field: string step = 18;
   */ _define_property(this, "step", ""), /**
   * cor_agreed_on is the COR's date on an agreed waiver or extension.
   *
   * @generated from field: string cor_agreed_on = 19;
   */ _define_property(this, "corAgreedOn", ""), /**
   * proposed_by_name is the proposer's name; "" when unknown.
   *
   * @generated from field: string proposed_by_name = 20;
   */ _define_property(this, "proposedByName", ""), /**
   * via_assist is true when the proposal was staged from a Specra Assist
   * chat card (SAD-870). History shows "via Specra Assist".
   *
   * @generated from field: bool via_assist = 21;
   */ _define_property(this, "viaAssist", false), /**
   * submission_id is set on submission_edit and submission_evidence (SAD-902).
   *
   * @generated from field: string submission_id = 22;
   */ _define_property(this, "submissionId", ""), /**
   * submitted_on is a submission_edit's proposed filing date ("" = leave blank).
   *
   * @generated from field: string submitted_on = 23;
   */ _define_property(this, "submittedOn", ""), /**
   * @generated from field: repeated string sent_to_contact_ids = 24;
   */ _define_property(this, "sentToContactIds", []), /**
   * submission_note is the proposed note on the submission itself; note (11)
   * remains the proposer's why.
   *
   * @generated from field: string submission_note = 25;
   */ _define_property(this, "submissionNote", ""), /**
   * attachments are proposed files/links: a full replace when
   * replace_attachments is set on a submission_edit, or the additions on
   * submission_evidence.
   *
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 26;
   */ _define_property(this, "attachments", []), /**
   * @generated from field: bool replace_attachments = 27;
   */ _define_property(this, "replaceAttachments", false), /**
   * @generated from field: string submitted_by_contact_id = 28;
   */ _define_property(this, "submittedByContactId", ""), /**
   * @generated from field: string submitted_by_display = 29;
   */ _define_property(this, "submittedByDisplay", ""), /**
   * waiver_before is set on waiver_edit: the waiver as it stood when the
   * edit was proposed.
   *
   * @generated from field: mono.datagateway.v1.WaiverFields waiver_before = 30;
   */ _define_property(this, "waiverBefore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OccurrenceDecision, "runtime", proto3);
_define_property(OccurrenceDecision, "typeName", "mono.datagateway.v1.OccurrenceDecision");
_define_property(OccurrenceDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "proposed_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "approved_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "waived_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "waiver_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "state_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "decided_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "proposed_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "decided_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "evidence_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "step",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "cor_agreed_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "proposed_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "via_assist",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 22,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "submitted_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "sent_to_contact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 25,
            name: "submission_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        },
        {
            no: 27,
            name: "replace_attachments",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 28,
            name: "submitted_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "submitted_by_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "waiver_before",
            kind: "message",
            T: WaiverFields
        }
    ]));
/**
 * WaiverFields are an applied waiver's own fields. waived_on is YYYY-MM-DD,
 * "" when the COR's date was not recorded; waiver_document_id is "" when none.
 *
 * @generated from message mono.datagateway.v1.WaiverFields
 */ export class WaiverFields extends Message {
    static fromBinary(bytes, options) {
        return new WaiverFields().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WaiverFields().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WaiverFields().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WaiverFields, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string waived_on = 1;
   */ _define_property(this, "waivedOn", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string waiver_document_id = 3;
   */ _define_property(this, "waiverDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WaiverFields, "runtime", proto3);
_define_property(WaiverFields, "typeName", "mono.datagateway.v1.WaiverFields");
_define_property(WaiverFields, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "waived_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "waiver_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeSubmissionEditRequest
 */ export class ProposeSubmissionEditRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeSubmissionEditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeSubmissionEditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeSubmissionEditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeSubmissionEditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string submission_id = 4;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string submitted_on = 5;
   */ _define_property(this, "submittedOn", ""), /**
   * @generated from field: string submitted_by_contact_id = 6;
   */ _define_property(this, "submittedByContactId", ""), /**
   * @generated from field: string submitted_by_display = 7;
   */ _define_property(this, "submittedByDisplay", ""), /**
   * @generated from field: repeated string sent_to_contact_ids = 8;
   */ _define_property(this, "sentToContactIds", []), /**
   * submission_note is the filing's note after approval.
   *
   * @generated from field: string submission_note = 9;
   */ _define_property(this, "submissionNote", ""), /**
   * note is the proposer's why (required).
   *
   * @generated from field: string note = 10;
   */ _define_property(this, "note", ""), /**
   * @generated from field: bool replace_attachments = 11;
   */ _define_property(this, "replaceAttachments", false), /**
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 12;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeSubmissionEditRequest, "runtime", proto3);
_define_property(ProposeSubmissionEditRequest, "typeName", "mono.datagateway.v1.ProposeSubmissionEditRequest");
_define_property(ProposeSubmissionEditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "submitted_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "submitted_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "submitted_by_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "sent_to_contact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "submission_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "replace_attachments",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeSubmissionEditResponse
 */ export class ProposeSubmissionEditResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeSubmissionEditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeSubmissionEditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeSubmissionEditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeSubmissionEditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeSubmissionEditResponse, "runtime", proto3);
_define_property(ProposeSubmissionEditResponse, "typeName", "mono.datagateway.v1.ProposeSubmissionEditResponse");
_define_property(ProposeSubmissionEditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeSubmissionEvidenceRequest
 */ export class ProposeSubmissionEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeSubmissionEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeSubmissionEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeSubmissionEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeSubmissionEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string submission_id = 4;
   */ _define_property(this, "submissionId", ""), /**
   * note is the proposer's why (required).
   *
   * @generated from field: string note = 5;
   */ _define_property(this, "note", ""), /**
   * At least one file or link.
   *
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 6;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeSubmissionEvidenceRequest, "runtime", proto3);
_define_property(ProposeSubmissionEvidenceRequest, "typeName", "mono.datagateway.v1.ProposeSubmissionEvidenceRequest");
_define_property(ProposeSubmissionEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeSubmissionEvidenceResponse
 */ export class ProposeSubmissionEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeSubmissionEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeSubmissionEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeSubmissionEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeSubmissionEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeSubmissionEvidenceResponse, "runtime", proto3);
_define_property(ProposeSubmissionEvidenceResponse, "typeName", "mono.datagateway.v1.ProposeSubmissionEvidenceResponse");
_define_property(ProposeSubmissionEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeWaiverEvidenceRequest
 */ export class ProposeWaiverEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeWaiverEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeWaiverEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeWaiverEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeWaiverEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * note is the proposer's why (required).
   *
   * @generated from field: string note = 4;
   */ _define_property(this, "note", ""), /**
   * At least one file or link.
   *
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 5;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeWaiverEvidenceRequest, "runtime", proto3);
_define_property(ProposeWaiverEvidenceRequest, "typeName", "mono.datagateway.v1.ProposeWaiverEvidenceRequest");
_define_property(ProposeWaiverEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeWaiverEvidenceResponse
 */ export class ProposeWaiverEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeWaiverEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeWaiverEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeWaiverEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeWaiverEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeWaiverEvidenceResponse, "runtime", proto3);
_define_property(ProposeWaiverEvidenceResponse, "typeName", "mono.datagateway.v1.ProposeWaiverEvidenceResponse");
_define_property(ProposeWaiverEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeExtensionEvidenceRequest
 */ export class ProposeExtensionEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeExtensionEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeExtensionEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeExtensionEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeExtensionEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * note is the proposer's why (required).
   *
   * @generated from field: string note = 4;
   */ _define_property(this, "note", ""), /**
   * At least one file or link.
   *
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 5;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeExtensionEvidenceRequest, "runtime", proto3);
_define_property(ProposeExtensionEvidenceRequest, "typeName", "mono.datagateway.v1.ProposeExtensionEvidenceRequest");
_define_property(ProposeExtensionEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeExtensionEvidenceResponse
 */ export class ProposeExtensionEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeExtensionEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeExtensionEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeExtensionEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeExtensionEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeExtensionEvidenceResponse, "runtime", proto3);
_define_property(ProposeExtensionEvidenceResponse, "typeName", "mono.datagateway.v1.ProposeExtensionEvidenceResponse");
_define_property(ProposeExtensionEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeWaiverEditRequest
 */ export class ProposeWaiverEditRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeWaiverEditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeWaiverEditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeWaiverEditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeWaiverEditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * note is the proposer's why (required).
   *
   * @generated from field: string note = 4;
   */ _define_property(this, "note", ""), /**
   * Each field left unset keeps the stored value. waived_on (YYYY-MM-DD) and
   * waiver_document_id set to "" clear it; reason cannot be cleared. At least
   * one field must change.
   *
   * @generated from field: optional string waived_on = 5;
   */ _define_property(this, "waivedOn", void 0), /**
   * @generated from field: optional string reason = 6;
   */ _define_property(this, "reason", void 0), /**
   * @generated from field: optional string waiver_document_id = 7;
   */ _define_property(this, "waiverDocumentId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeWaiverEditRequest, "runtime", proto3);
_define_property(ProposeWaiverEditRequest, "typeName", "mono.datagateway.v1.ProposeWaiverEditRequest");
_define_property(ProposeWaiverEditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "waived_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 7,
            name: "waiver_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeWaiverEditResponse
 */ export class ProposeWaiverEditResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeWaiverEditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeWaiverEditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeWaiverEditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeWaiverEditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeWaiverEditResponse, "runtime", proto3);
_define_property(ProposeWaiverEditResponse, "typeName", "mono.datagateway.v1.ProposeWaiverEditResponse");
_define_property(ProposeWaiverEditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeOccurrenceWaiverRequest
 */ export class ProposeOccurrenceWaiverRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceWaiverRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceWaiverRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceWaiverRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceWaiverRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * waived_on, reason and waiver_document_id are the COR's answer, set only
   * when the COR already agreed; reason set means agreed.
   *
   * @generated from field: string waived_on = 4;
   */ _define_property(this, "waivedOn", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string waiver_document_id = 6;
   */ _define_property(this, "waiverDocumentId", ""), /**
   * note is the proposer's note. A note or a reason is required.
   *
   * @generated from field: string note = 7;
   */ _define_property(this, "note", ""), /**
   * attachments are further files or links beyond waiver_document_id (the
   * main document); stored on the decision's attachments.
   *
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 8;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceWaiverRequest, "runtime", proto3);
_define_property(ProposeOccurrenceWaiverRequest, "typeName", "mono.datagateway.v1.ProposeOccurrenceWaiverRequest");
_define_property(ProposeOccurrenceWaiverRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "waived_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "waiver_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeOccurrenceWaiverResponse
 */ export class ProposeOccurrenceWaiverResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceWaiverResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceWaiverResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceWaiverResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceWaiverResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceWaiverResponse, "runtime", proto3);
_define_property(ProposeOccurrenceWaiverResponse, "typeName", "mono.datagateway.v1.ProposeOccurrenceWaiverResponse");
_define_property(ProposeOccurrenceWaiverResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeOccurrenceExtensionRequest
 */ export class ProposeOccurrenceExtensionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceExtensionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceExtensionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceExtensionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceExtensionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string due_on = 4;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * evidence_document_id is optional: a program document of this program
   * (the government's extension, e.g. an .eml) that the approver can open.
   *
   * @generated from field: string evidence_document_id = 6;
   */ _define_property(this, "evidenceDocumentId", ""), /**
   * note is the proposer's note. A note or a reason is required; reason set
   * means the COR already agreed, on cor_agreed_on.
   *
   * @generated from field: string note = 7;
   */ _define_property(this, "note", ""), /**
   * @generated from field: string cor_agreed_on = 8;
   */ _define_property(this, "corAgreedOn", ""), /**
   * attachments are further files or links beyond evidence_document_id (the
   * main document); stored on the decision's attachments.
   *
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 9;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceExtensionRequest, "runtime", proto3);
_define_property(ProposeOccurrenceExtensionRequest, "typeName", "mono.datagateway.v1.ProposeOccurrenceExtensionRequest");
_define_property(ProposeOccurrenceExtensionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "evidence_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "cor_agreed_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeOccurrenceExtensionResponse
 */ export class ProposeOccurrenceExtensionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceExtensionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceExtensionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceExtensionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceExtensionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceExtensionResponse, "runtime", proto3);
_define_property(ProposeOccurrenceExtensionResponse, "typeName", "mono.datagateway.v1.ProposeOccurrenceExtensionResponse");
_define_property(ProposeOccurrenceExtensionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeOccurrenceNotOwedRequest
 */ export class ProposeOccurrenceNotOwedRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceNotOwedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceNotOwedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceNotOwedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceNotOwedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * reason: not_owed | generated_in_error.
   *
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string note = 5;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceNotOwedRequest, "runtime", proto3);
_define_property(ProposeOccurrenceNotOwedRequest, "typeName", "mono.datagateway.v1.ProposeOccurrenceNotOwedRequest");
_define_property(ProposeOccurrenceNotOwedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeOccurrenceNotOwedResponse
 */ export class ProposeOccurrenceNotOwedResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceNotOwedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceNotOwedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceNotOwedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceNotOwedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceNotOwedResponse, "runtime", proto3);
_define_property(ProposeOccurrenceNotOwedResponse, "typeName", "mono.datagateway.v1.ProposeOccurrenceNotOwedResponse");
_define_property(ProposeOccurrenceNotOwedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordOccurrenceDecisionCorAnswerRequest
 */ export class RecordOccurrenceDecisionCorAnswerRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordOccurrenceDecisionCorAnswerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordOccurrenceDecisionCorAnswerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordOccurrenceDecisionCorAnswerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordOccurrenceDecisionCorAnswerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string change_set_id = 3;
   */ _define_property(this, "changeSetId", ""), /**
   * agreed: true when the COR agreed, false when the COR declined.
   *
   * @generated from field: bool agreed = 4;
   */ _define_property(this, "agreed", false), /**
   * cor_on is the COR's date; required when agreed.
   *
   * @generated from field: string cor_on = 5;
   */ _define_property(this, "corOn", ""), /**
   * reason is required either way: the COR's reason, or why they declined.
   *
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", ""), /**
   * document_id is optional: a program document of this program.
   *
   * @generated from field: string document_id = 7;
   */ _define_property(this, "documentId", ""), /**
   * attachments are further files or links beyond document_id; appended to
   * the decision's existing attachments.
   *
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 8;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordOccurrenceDecisionCorAnswerRequest, "runtime", proto3);
_define_property(RecordOccurrenceDecisionCorAnswerRequest, "typeName", "mono.datagateway.v1.RecordOccurrenceDecisionCorAnswerRequest");
_define_property(RecordOccurrenceDecisionCorAnswerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "agreed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "cor_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordOccurrenceDecisionCorAnswerResponse
 */ export class RecordOccurrenceDecisionCorAnswerResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordOccurrenceDecisionCorAnswerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordOccurrenceDecisionCorAnswerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordOccurrenceDecisionCorAnswerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordOccurrenceDecisionCorAnswerResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 2;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 3;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordOccurrenceDecisionCorAnswerResponse, "runtime", proto3);
_define_property(RecordOccurrenceDecisionCorAnswerResponse, "typeName", "mono.datagateway.v1.RecordOccurrenceDecisionCorAnswerResponse");
_define_property(RecordOccurrenceDecisionCorAnswerResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 3,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ApproveOccurrenceDecisionRequest
 */ export class ApproveOccurrenceDecisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApproveOccurrenceDecisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveOccurrenceDecisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveOccurrenceDecisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveOccurrenceDecisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string change_set_id = 3;
   */ _define_property(this, "changeSetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveOccurrenceDecisionRequest, "runtime", proto3);
_define_property(ApproveOccurrenceDecisionRequest, "typeName", "mono.datagateway.v1.ApproveOccurrenceDecisionRequest");
_define_property(ApproveOccurrenceDecisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ApproveOccurrenceDecisionResponse
 */ export class ApproveOccurrenceDecisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApproveOccurrenceDecisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveOccurrenceDecisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveOccurrenceDecisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveOccurrenceDecisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 2;
   */ _define_property(this, "occurrence", void 0), /**
   * result.audit_event_id is the verb's own event (the item's applied event).
   *
   * @generated from field: mono.datagateway.v1.WriteResult result = 3;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveOccurrenceDecisionResponse, "runtime", proto3);
_define_property(ApproveOccurrenceDecisionResponse, "typeName", "mono.datagateway.v1.ApproveOccurrenceDecisionResponse");
_define_property(ApproveOccurrenceDecisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 3,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectOccurrenceDecisionRequest
 */ export class RejectOccurrenceDecisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectOccurrenceDecisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectOccurrenceDecisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectOccurrenceDecisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectOccurrenceDecisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string change_set_id = 3;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectOccurrenceDecisionRequest, "runtime", proto3);
_define_property(RejectOccurrenceDecisionRequest, "typeName", "mono.datagateway.v1.RejectOccurrenceDecisionRequest");
_define_property(RejectOccurrenceDecisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectOccurrenceDecisionResponse
 */ export class RejectOccurrenceDecisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectOccurrenceDecisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectOccurrenceDecisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectOccurrenceDecisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectOccurrenceDecisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 2;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 3;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectOccurrenceDecisionResponse, "runtime", proto3);
_define_property(RejectOccurrenceDecisionResponse, "typeName", "mono.datagateway.v1.RejectOccurrenceDecisionResponse");
_define_property(RejectOccurrenceDecisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 3,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOccurrenceDecisionsRequest
 */ export class ListOccurrenceDecisionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrenceDecisionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrenceDecisionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrenceDecisionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrenceDecisionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * workstream_id: only proposals on that workstream's dates.
   *
   * @generated from field: string workstream_id = 2;
   */ _define_property(this, "workstreamId", ""), /**
   * open_only: only proposals still awaiting approval.
   *
   * @generated from field: bool open_only = 3;
   */ _define_property(this, "openOnly", false), /**
   * as_of is the day the occurrences' status is computed on; "" = today.
   *
   * @generated from field: string as_of = 4;
   */ _define_property(this, "asOf", ""), /**
   * occurrence_id: only proposals on that date.
   *
   * @generated from field: string occurrence_id = 5;
   */ _define_property(this, "occurrenceId", ""), /**
   * page_size 0 = every proposal in one answer; otherwise at most 2000.
   *
   * @generated from field: int32 page_size = 6;
   */ _define_property(this, "pageSize", 0), /**
   * page_token is the previous page's next_page_token (a keyset over the
   * newest-first order, so a page boundary never repeats or skips one).
   *
   * @generated from field: string page_token = 7;
   */ _define_property(this, "pageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrenceDecisionsRequest, "runtime", proto3);
_define_property(ListOccurrenceDecisionsRequest, "typeName", "mono.datagateway.v1.ListOccurrenceDecisionsRequest");
_define_property(ListOccurrenceDecisionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "open_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOccurrenceDecisionsResponse
 */ export class ListOccurrenceDecisionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrenceDecisionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrenceDecisionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrenceDecisionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrenceDecisionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * decisions are newest first.
   *
   * @generated from field: repeated mono.datagateway.v1.OccurrenceDecision decisions = 1;
   */ _define_property(this, "decisions", []), /**
   * occurrences are the decisions' dates, with their status on as_of.
   *
   * @generated from field: repeated mono.datagateway.v1.ContractOccurrence occurrences = 2;
   */ _define_property(this, "occurrences", []), /**
   * total is the filtered proposal count across every page.
   *
   * @generated from field: int32 total = 3;
   */ _define_property(this, "total", 0), /**
   * next_page_token is "" on the last page.
   *
   * @generated from field: string next_page_token = 4;
   */ _define_property(this, "nextPageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrenceDecisionsResponse, "runtime", proto3);
_define_property(ListOccurrenceDecisionsResponse, "typeName", "mono.datagateway.v1.ListOccurrenceDecisionsResponse");
_define_property(ListOccurrenceDecisionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decisions",
            kind: "message",
            T: OccurrenceDecision,
            repeated: true
        },
        {
            no: 2,
            name: "occurrences",
            kind: "message",
            T: ContractOccurrence,
            repeated: true
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOccurrenceRequest
 */ export class GetOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string as_of = 4;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOccurrenceRequest, "runtime", proto3);
_define_property(GetOccurrenceRequest, "typeName", "mono.datagateway.v1.GetOccurrenceRequest");
_define_property(GetOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOccurrenceResponse
 */ export class GetOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 1;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSubmission submissions = 2;
   */ _define_property(this, "submissions", []), /**
   * decisions are the date's proposals, newest first, in every state.
   *
   * @generated from field: repeated mono.datagateway.v1.OccurrenceDecision decisions = 3;
   */ _define_property(this, "decisions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOccurrenceResponse, "runtime", proto3);
_define_property(GetOccurrenceResponse, "typeName", "mono.datagateway.v1.GetOccurrenceResponse");
_define_property(GetOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 2,
            name: "submissions",
            kind: "message",
            T: ContractSubmission,
            repeated: true
        },
        {
            no: 3,
            name: "decisions",
            kind: "message",
            T: OccurrenceDecision,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramSubmissionsRequest
 */ export class ListProgramSubmissionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramSubmissionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramSubmissionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramSubmissionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramSubmissionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * workstream_id: only submissions on that workstream's dates.
   *
   * @generated from field: string workstream_id = 2;
   */ _define_property(this, "workstreamId", ""), /**
   * duty_ids: only submissions on those deliverables' dates (one
   * deliverable, or a CLIN's); empty = every deliverable.
   *
   * @generated from field: repeated string duty_ids = 3;
   */ _define_property(this, "dutyIds", []), /**
   * due_from / due_to: dates due in [due_from, due_to] ("" = open-ended); an
   * undated date is left out when either is set, as ListOccurrences does.
   *
   * @generated from field: string due_from = 4;
   */ _define_property(this, "dueFrom", ""), /**
   * @generated from field: string due_to = 5;
   */ _define_property(this, "dueTo", ""), /**
   * include_withdrawn adds withdrawn attempts. Attempt numbers count them
   * either way, as GetOccurrence's do.
   *
   * @generated from field: bool include_withdrawn = 6;
   */ _define_property(this, "includeWithdrawn", false), /**
   * include_retired adds submissions on retired dates, as ListOccurrences'
   * include_retired adds the dates.
   *
   * @generated from field: bool include_retired = 7;
   */ _define_property(this, "includeRetired", false), /**
   * page_size 0 = 1000; at most 2000.
   *
   * @generated from field: int32 page_size = 8;
   */ _define_property(this, "pageSize", 0), /**
   * page_token is the previous page's next_page_token.
   *
   * @generated from field: string page_token = 9;
   */ _define_property(this, "pageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramSubmissionsRequest, "runtime", proto3);
_define_property(ListProgramSubmissionsRequest, "typeName", "mono.datagateway.v1.ListProgramSubmissionsRequest");
_define_property(ListProgramSubmissionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duty_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "due_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "include_withdrawn",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "include_retired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ProgramSubmission is one submission and the fields of its date an export
 * reads; the date's status comes from ListOccurrences, which computes it.
 *
 * @generated from message mono.datagateway.v1.ProgramSubmission
 */ export class ProgramSubmission extends Message {
    static fromBinary(bytes, options) {
        return new ProgramSubmission().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramSubmission().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramSubmission().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramSubmission, a, b);
    }
    constructor(data){
        super(), /**
   * submission carries its files and every review, superseded ones
   * included, in the order they were recorded (GetOccurrence's shape).
   *
   * @generated from field: mono.datagateway.v1.ContractSubmission submission = 1;
   */ _define_property(this, "submission", void 0), /**
   * @generated from field: string duty_id = 2;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string workstream_id = 3;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string period_of_performance_id = 4;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: string period_key = 5;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: string nominal_due_on = 6;
   */ _define_property(this, "nominalDueOn", ""), /**
   * @generated from field: string due_on = 7;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: string moved_from_due_on = 8;
   */ _define_property(this, "movedFromDueOn", ""), /**
   * @generated from field: string waived_on = 9;
   */ _define_property(this, "waivedOn", ""), /**
   * @generated from field: string waiver_reason = 10;
   */ _define_property(this, "waiverReason", ""), /**
   * @generated from field: bool retired = 11;
   */ _define_property(this, "retired", false), /**
   * @generated from field: string retired_reason = 12;
   */ _define_property(this, "retiredReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramSubmission, "runtime", proto3);
_define_property(ProgramSubmission, "typeName", "mono.datagateway.v1.ProgramSubmission");
_define_property(ProgramSubmission, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission",
            kind: "message",
            T: ContractSubmission
        },
        {
            no: 2,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "nominal_due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "moved_from_due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "waived_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "waiver_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "retired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "retired_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramSubmissionsResponse
 */ export class ListProgramSubmissionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramSubmissionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramSubmissionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramSubmissionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramSubmissionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * submissions are ordered by workstream, due date (undated last), date
   * and attempt.
   *
   * @generated from field: repeated mono.datagateway.v1.ProgramSubmission submissions = 1;
   */ _define_property(this, "submissions", []), /**
   * total is the filtered submission count across every page.
   *
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * next_page_token is "" on the last page.
   *
   * @generated from field: string next_page_token = 3;
   */ _define_property(this, "nextPageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramSubmissionsResponse, "runtime", proto3);
_define_property(ListProgramSubmissionsResponse, "typeName", "mono.datagateway.v1.ListProgramSubmissionsResponse");
_define_property(ListProgramSubmissionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submissions",
            kind: "message",
            T: ProgramSubmission,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOccurrencesRequest
 */ export class ListOccurrencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string duty_id = 3;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string workstream_id = 4;
   */ _define_property(this, "workstreamId", ""), /**
   * states filters by occurrencestatus state; empty = every state.
   * "awaiting_review" also lists an approved date with a later submission
   * awaiting review (SAD-991), which state_counts still counts as approved.
   *
   * @generated from field: repeated string states = 5;
   */ _define_property(this, "states", []), /**
   * retired rows are included only when asked for.
   *
   * @generated from field: bool include_retired = 6;
   */ _define_property(this, "includeRetired", false), /**
   * @generated from field: mono.datagateway.v1.OccurrenceWindow window = 7;
   */ _define_property(this, "window", 0), /**
   * @generated from field: string as_of = 8;
   */ _define_property(this, "asOf", ""), /**
   * page_size 0 = every row.
   *
   * @generated from field: int32 page_size = 9;
   */ _define_property(this, "pageSize", 0), /**
   * @generated from field: string page_token = 10;
   */ _define_property(this, "pageToken", ""), /**
   * period_of_performance_id is required with OCCURRENCE_WINDOW_CONTRACT_PERIOD
   * and refused with any other window.
   *
   * @generated from field: string period_of_performance_id = 11;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * The row filters below narrow the rows like duty_id and workstream_id do:
   * state_counts, on_time and total are taken after them (only `states` is
   * applied after the counts).
   *
   * clin_id: rows minted by a rule on that CLIN, plus one-offs of a duty with
   * such a rule.
   *
   * @generated from field: string clin_id = 12;
   */ _define_property(this, "clinId", ""), /**
   * due_from / due_to: rows due in [due_from, due_to] ("" = open-ended); an
   * undated row is left out when either is set.
   *
   * @generated from field: string due_from = 13;
   */ _define_property(this, "dueFrom", ""), /**
   * @generated from field: string due_to = 14;
   */ _define_property(this, "dueTo", ""), /**
   * submitted_from / submitted_to: rows whose latest live submission was
   * submitted in [submitted_from, submitted_to]; an unfiled row is left out
   * when either is set.
   *
   * @generated from field: string submitted_from = 15;
   */ _define_property(this, "submittedFrom", ""), /**
   * @generated from field: string submitted_to = 16;
   */ _define_property(this, "submittedTo", ""), /**
   * include_projected adds the dates projected from events not logged yet
   * (S6): state "waiting_on_event", never late, counted in state_counts
   * under that state only.
   *
   * @generated from field: bool include_projected = 17;
   */ _define_property(this, "includeProjected", false), /**
   * keyset pages by keyset in the same order (due date, undated last;
   * period; id) and computes status only for the page's dates, so reading a
   * program to the end costs one page of work per page, never the whole
   * program per page. total is exact; state_counts, on_time and
   * carried_over are left empty. It takes the row filters only: states, a
   * window other than ALL, submitted_from/to and include_projected are
   * refused (they need every date's status). page_size 0 = 1000, at most
   * 2000; page_token is the previous keyset page's next_page_token.
   *
   * @generated from field: bool keyset = 18;
   */ _define_property(this, "keyset", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrencesRequest, "runtime", proto3);
_define_property(ListOccurrencesRequest, "typeName", "mono.datagateway.v1.ListOccurrencesRequest");
_define_property(ListOccurrencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "states",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "include_retired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "window",
            kind: "enum",
            T: proto3.getEnumType(OccurrenceWindow)
        },
        {
            no: 8,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "due_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "due_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "submitted_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "submitted_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "include_projected",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 18,
            name: "keyset",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * OnTimeCounts are the on-time KPI's named denominators over the rows
 * counted: approved rows, those whose timing is known, and those on time.
 *
 * @generated from message mono.datagateway.v1.OnTimeCounts
 */ export class OnTimeCounts extends Message {
    static fromBinary(bytes, options) {
        return new OnTimeCounts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OnTimeCounts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OnTimeCounts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OnTimeCounts, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 approved = 1;
   */ _define_property(this, "approved", 0), /**
   * @generated from field: int32 timing_known = 2;
   */ _define_property(this, "timingKnown", 0), /**
   * @generated from field: int32 on_time = 3;
   */ _define_property(this, "onTime", 0), /**
   * Deprecated, never set: 4, 5 and 7 were a second on-time reading on one
   * evidence file's scope. On time is read per the documents only.
   *
   * @generated from field: bool evidence_scoped = 4 [deprecated = true];
   * @deprecated
   */ _define_property(this, "evidenceScoped", false), /**
   * @generated from field: int32 untracked_late = 5 [deprecated = true];
   * @deprecated
   */ _define_property(this, "untrackedLate", 0), /**
   * @generated from field: int32 carried_untracked_late = 7 [deprecated = true];
   * @deprecated
   */ _define_property(this, "carriedUntrackedLate", 0), /**
   * carried_late (owner, 2026-11-03): the late rows counted that are
   * carried over from before the window. The window's own on time is
   * on_time / (timing_known + late - carried_late).
   *
   * @generated from field: int32 carried_late = 6;
   */ _define_property(this, "carriedLate", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OnTimeCounts, "runtime", proto3);
_define_property(OnTimeCounts, "typeName", "mono.datagateway.v1.OnTimeCounts");
_define_property(OnTimeCounts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "approved",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "timing_known",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "on_time",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "evidence_scoped",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "untracked_late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "carried_untracked_late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "carried_late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ResolvedWindow is the window the filter used. basis names where it came
 * from: all | contract_period | sow_in_force | exercise_line | none (the
 * workstream has no current window: the rows are its open ones).
 *
 * @generated from message mono.datagateway.v1.ResolvedWindow
 */ export class ResolvedWindow extends Message {
    static fromBinary(bytes, options) {
        return new ResolvedWindow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvedWindow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvedWindow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvedWindow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string basis = 1;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string start_on = 2;
   */ _define_property(this, "startOn", ""), /**
   * @generated from field: string end_on = 3;
   */ _define_property(this, "endOn", ""), /**
   * @generated from field: string period_of_performance_id = 4;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: string sow_id = 5;
   */ _define_property(this, "sowId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvedWindow, "runtime", proto3);
_define_property(ResolvedWindow, "typeName", "mono.datagateway.v1.ResolvedWindow");
_define_property(ResolvedWindow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "start_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "end_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOccurrencesResponse
 */ export class ListOccurrencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractOccurrence occurrences = 1;
   */ _define_property(this, "occurrences", []), /**
   * state_counts is over the window before the state filter and paging: the
   * named denominators of the KPI strip.
   *
   * @generated from field: map<string, int32> state_counts = 2;
   */ _define_property(this, "stateCounts", {}), /**
   * total is the filtered row count before paging.
   *
   * @generated from field: int32 total = 3;
   */ _define_property(this, "total", 0), /**
   * @generated from field: mono.datagateway.v1.ResolvedWindow window = 4;
   */ _define_property(this, "window", void 0), /**
   * @generated from field: string as_of = 5;
   */ _define_property(this, "asOf", ""), /**
   * carried_over counts rows outside the window that are still open.
   *
   * @generated from field: int32 carried_over = 6;
   */ _define_property(this, "carriedOver", 0), /**
   * @generated from field: string next_page_token = 7;
   */ _define_property(this, "nextPageToken", ""), /**
   * on_time is over the same rows as state_counts.
   *
   * @generated from field: mono.datagateway.v1.OnTimeCounts on_time = 8;
   */ _define_property(this, "onTime", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrencesResponse, "runtime", proto3);
_define_property(ListOccurrencesResponse, "typeName", "mono.datagateway.v1.ListOccurrencesResponse");
_define_property(ListOccurrencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrences",
            kind: "message",
            T: ContractOccurrence,
            repeated: true
        },
        {
            no: 2,
            name: "state_counts",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "window",
            kind: "message",
            T: ResolvedWindow
        },
        {
            no: 5,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "carried_over",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "on_time",
            kind: "message",
            T: OnTimeCounts
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkstreamWindowCountsRequest
 */ export class ListWorkstreamWindowCountsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamWindowCountsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamWindowCountsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamWindowCountsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamWindowCountsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * as_of is the day each window is resolved and each status computed on,
   * as ListOccurrencesRequest.as_of; "" = today.
   *
   * @generated from field: string as_of = 3;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamWindowCountsRequest, "runtime", proto3);
_define_property(ListWorkstreamWindowCountsRequest, "typeName", "mono.datagateway.v1.ListWorkstreamWindowCountsRequest");
_define_property(ListWorkstreamWindowCountsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * WorkstreamWindowCounts is one workstream's counts in its own current
 * window: each field equal to the same field of ListOccurrences with
 * workstream_id, OCCURRENCE_WINDOW_WORKSTREAM_CURRENT_WINDOW and as_of (no
 * state filter, retired rows and projected dates left out).
 *
 * @generated from message mono.datagateway.v1.WorkstreamWindowCounts
 */ export class WorkstreamWindowCounts extends Message {
    static fromBinary(bytes, options) {
        return new WorkstreamWindowCounts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkstreamWindowCounts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkstreamWindowCounts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkstreamWindowCounts, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string workstream_id = 1;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: map<string, int32> state_counts = 2;
   */ _define_property(this, "stateCounts", {}), /**
   * @generated from field: int32 total = 3;
   */ _define_property(this, "total", 0), /**
   * @generated from field: mono.datagateway.v1.ResolvedWindow window = 4;
   */ _define_property(this, "window", void 0), /**
   * @generated from field: int32 carried_over = 5;
   */ _define_property(this, "carriedOver", 0), /**
   * @generated from field: mono.datagateway.v1.OnTimeCounts on_time = 6;
   */ _define_property(this, "onTime", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkstreamWindowCounts, "runtime", proto3);
_define_property(WorkstreamWindowCounts, "typeName", "mono.datagateway.v1.WorkstreamWindowCounts");
_define_property(WorkstreamWindowCounts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state_counts",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "window",
            kind: "message",
            T: ResolvedWindow
        },
        {
            no: 5,
            name: "carried_over",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "on_time",
            kind: "message",
            T: OnTimeCounts
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkstreamWindowCountsResponse
 */ export class ListWorkstreamWindowCountsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamWindowCountsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamWindowCountsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamWindowCountsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamWindowCountsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * workstreams are ListWorkstreams' workstreams, in its order, each with
   * its counts.
   *
   * @generated from field: repeated mono.datagateway.v1.WorkstreamWindowCounts workstreams = 1;
   */ _define_property(this, "workstreams", []), /**
   * @generated from field: string as_of = 2;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamWindowCountsResponse, "runtime", proto3);
_define_property(ListWorkstreamWindowCountsResponse, "typeName", "mono.datagateway.v1.ListWorkstreamWindowCountsResponse");
_define_property(ListWorkstreamWindowCountsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstreams",
            kind: "message",
            T: WorkstreamWindowCounts,
            repeated: true
        },
        {
            no: 2,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * GetPortfolioDeliverySummaryRequest filters the dates of several programs
 * (SAD-999). Every filter narrows the rows before the counts except
 * `states`, which narrows only `total` (as in ListOccurrences: a queue's
 * length is always its tile's count). Retired rows and projected dates are
 * never counted.
 *
 * @generated from message mono.datagateway.v1.GetPortfolioDeliverySummaryRequest
 */ export class GetPortfolioDeliverySummaryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPortfolioDeliverySummaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPortfolioDeliverySummaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPortfolioDeliverySummaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPortfolioDeliverySummaryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * program_ids are the programs read. ryugu names the ones the viewer can
   * see; a program not in the caller's tenant is left out. Empty reads none.
   *
   * @generated from field: repeated string program_ids = 1;
   */ _define_property(this, "programIds", []), /**
   * workstream_ids keeps the dates of these teams; empty keeps every date.
   *
   * @generated from field: repeated string workstream_ids = 2;
   */ _define_property(this, "workstreamIds", []), /**
   * owner_contact_ids keeps the dates these people own. A date's owner is
   * its team's owner, else its program's lead (the one PM definition,
   * programPMRecipientsSQL); "-" stands for a date with neither. "me"
   * (SAD-1005) stands for the caller: its live contacts in the tenant, from
   * the gateway principal (none linked keeps no date). In
   * ListAttentionItems, "me" also keeps the waiting, request and review
   * items of the programs the caller leads, and sets each item's why.
   *
   * @generated from field: repeated string owner_contact_ids = 3;
   */ _define_property(this, "ownerContactIds", []), /**
   * states as in ListOccurrencesRequest.states, plus two of the Command
   * Center's own (SAD-1000): "at_risk" keeps the dates DeliveryCounts.at_risk
   * counts, and "not_yet_due" the due_soon and upcoming dates that are not
   * at risk.
   *
   * @generated from field: repeated string states = 4;
   */ _define_property(this, "states", []), /**
   * window: OCCURRENCE_WINDOW_CONTRACT_CURRENT_PERIOD (each program's own
   * current contract period, the default for UNSPECIFIED) or
   * OCCURRENCE_WINDOW_ALL; any other window is refused.
   *
   * @generated from field: mono.datagateway.v1.OccurrenceWindow window = 5;
   */ _define_property(this, "window", 0), /**
   * due_from / due_to as in ListOccurrencesRequest.
   *
   * @generated from field: string due_from = 6;
   */ _define_property(this, "dueFrom", ""), /**
   * @generated from field: string due_to = 7;
   */ _define_property(this, "dueTo", ""), /**
   * portfolio_id / sector_id keep the programs in that portfolio or sector.
   *
   * @generated from field: string portfolio_id = 8;
   */ _define_property(this, "portfolioId", ""), /**
   * @generated from field: string sector_id = 9;
   */ _define_property(this, "sectorId", ""), /**
   * as_of is the day statuses and windows are taken on; "" = today.
   *
   * @generated from field: string as_of = 10;
   */ _define_property(this, "asOf", ""), /**
   * mine (SAD-1000, "My programs") keeps, of the programs read, the
   * caller's own: those it leads (the first of programPMRecipientsSQL, the
   * one program-manager definition), owns a team on, or holds a program role
   * on (program_role_assignments). With none of its own, every program read
   * is kept and the response's mine_fallback is set.
   *
   * @generated from field: bool mine = 11;
   */ _define_property(this, "mine", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPortfolioDeliverySummaryRequest, "runtime", proto3);
_define_property(GetPortfolioDeliverySummaryRequest, "typeName", "mono.datagateway.v1.GetPortfolioDeliverySummaryRequest");
_define_property(GetPortfolioDeliverySummaryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "workstream_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "owner_contact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "states",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "window",
            kind: "enum",
            T: proto3.getEnumType(OccurrenceWindow)
        },
        {
            no: 6,
            name: "due_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "mine",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * DeliveryCounts are one scope's counts over the window. state_counts,
 * on_time, carried_over and total are ListOccurrences' fields of the same
 * name, summed.
 *
 * @generated from message mono.datagateway.v1.DeliveryCounts
 */ export class DeliveryCounts extends Message {
    static fromBinary(bytes, options) {
        return new DeliveryCounts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliveryCounts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliveryCounts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliveryCounts, a, b);
    }
    constructor(data){
        super(), /**
   * state_counts is over the window before the state filter.
   *
   * @generated from field: map<string, int32> state_counts = 1;
   */ _define_property(this, "stateCounts", {}), /**
   * total is the rows the state filter keeps.
   *
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: int32 carried_over = 3;
   */ _define_property(this, "carriedOver", 0), /**
   * @generated from field: mono.datagateway.v1.OnTimeCounts on_time = 4;
   */ _define_property(this, "onTime", void 0), /**
   * at_risk: dates due within the next 5 working days with nothing filed
   * (state due_soon, due on or before as_of + 5 federal workdays).
   *
   * @generated from field: int32 at_risk = 5;
   */ _define_property(this, "atRisk", 0), /**
   * waiting_on_approval: the dates the awaiting-review queue lists (state
   * awaiting_review, or approved with a later filing awaiting review).
   *
   * @generated from field: int32 waiting_on_approval = 6;
   */ _define_property(this, "waitingOnApproval", 0), /**
   * next_due_on: the earliest date due on or after as_of with nothing
   * filed yet (due_soon or upcoming); "" when none.
   *
   * @generated from field: string next_due_on = 7;
   */ _define_property(this, "nextDueOn", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliveryCounts, "runtime", proto3);
_define_property(DeliveryCounts, "typeName", "mono.datagateway.v1.DeliveryCounts");
_define_property(DeliveryCounts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "state_counts",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "carried_over",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "on_time",
            kind: "message",
            T: OnTimeCounts
        },
        {
            no: 5,
            name: "at_risk",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "waiting_on_approval",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "next_due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * KpiReading is a KPI's one computation (SAD-998): the value it prints, its
 * target and its tone, from the same counts. A client renders it as given.
 *
 * @generated from message mono.datagateway.v1.KpiReading
 */ export class KpiReading extends Message {
    static fromBinary(bytes, options) {
        return new KpiReading().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KpiReading().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KpiReading().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KpiReading, a, b);
    }
    constructor(data){
        super(), /**
   * id: on_time | late_now | due_next_14_days | waiting_on_approval.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * label is the plain metric name.
   *
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * has_value is false with nothing to measure (tone "nodata"): the tile
   * shows no data, never 0% or a red zero.
   *
   * @generated from field: bool has_value = 3;
   */ _define_property(this, "hasValue", false), /**
   * value is a whole percent for on_time (never rounded onto 100% or 0%
   * it has not reached), a count otherwise.
   *
   * @generated from field: int32 value = 4;
   */ _define_property(this, "value", 0), /**
   * numerator / denominator are the counts behind a share ("412 of 474").
   *
   * @generated from field: int32 numerator = 5;
   */ _define_property(this, "numerator", 0), /**
   * @generated from field: int32 denominator = 6;
   */ _define_property(this, "denominator", 0), /**
   * target is the target as shown after "Target: " ("100%", "0",
   * "none at risk").
   *
   * @generated from field: string target = 7;
   */ _define_property(this, "target", ""), /**
   * tone: green (on target) | red (off target) | nodata.
   *
   * @generated from field: string tone = 8;
   */ _define_property(this, "tone", ""), /**
   * rule is the tooltip: what is counted and over what window.
   *
   * @generated from field: string rule = 9;
   */ _define_property(this, "rule", ""), /**
   * detail is the count that puts it off target, shown before the target
   * ("9 at risk (due in ≤5 working days, no draft)"); "" when none.
   *
   * @generated from field: string detail = 10;
   */ _define_property(this, "detail", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(KpiReading, "runtime", proto3);
_define_property(KpiReading, "typeName", "mono.datagateway.v1.KpiReading");
_define_property(KpiReading, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "has_value",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "value",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "numerator",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "denominator",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "target",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "tone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ProgramDeliverySummary is one program's counts, in its own window. The
 * contract number is not here: it is a masked field of the program read,
 * and GetPortfolioDashboard projects it.
 *
 * @generated from message mono.datagateway.v1.ProgramDeliverySummary
 */ export class ProgramDeliverySummary extends Message {
    static fromBinary(bytes, options) {
        return new ProgramDeliverySummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramDeliverySummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramDeliverySummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramDeliverySummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string portfolio_id = 3;
   */ _define_property(this, "portfolioId", ""), /**
   * @generated from field: string sector_id = 4;
   */ _define_property(this, "sectorId", ""), /**
   * owner is the program's lead ("" when it has none).
   *
   * @generated from field: string owner_contact_id = 5;
   */ _define_property(this, "ownerContactId", ""), /**
   * @generated from field: string owner_name = 6;
   */ _define_property(this, "ownerName", ""), /**
   * @generated from field: mono.datagateway.v1.ResolvedWindow window = 7;
   */ _define_property(this, "window", void 0), /**
   * @generated from field: mono.datagateway.v1.DeliveryCounts counts = 8;
   */ _define_property(this, "counts", void 0), /**
   * on_time is the on-time KPI over this program's window.
   *
   * @generated from field: mono.datagateway.v1.KpiReading on_time = 9;
   */ _define_property(this, "onTime", void 0), /**
   * health: late (a date is late) | at_risk (a date is at risk) | on_track
   * (dates, none late or at risk) | no_dates (nothing in the window).
   *
   * @generated from field: string health = 10;
   */ _define_property(this, "health", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramDeliverySummary, "runtime", proto3);
_define_property(ProgramDeliverySummary, "typeName", "mono.datagateway.v1.ProgramDeliverySummary");
_define_property(ProgramDeliverySummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "owner_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "window",
            kind: "message",
            T: ResolvedWindow
        },
        {
            no: 8,
            name: "counts",
            kind: "message",
            T: DeliveryCounts
        },
        {
            no: 9,
            name: "on_time",
            kind: "message",
            T: KpiReading
        },
        {
            no: 10,
            name: "health",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * WorkstreamDeliverySummary is one team's counts; workstream_id "" is a
 * program's contract-wide dates.
 *
 * @generated from message mono.datagateway.v1.WorkstreamDeliverySummary
 */ export class WorkstreamDeliverySummary extends Message {
    static fromBinary(bytes, options) {
        return new WorkstreamDeliverySummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkstreamDeliverySummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkstreamDeliverySummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkstreamDeliverySummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string workstream_id = 1;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 4;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: string owner_contact_id = 5;
   */ _define_property(this, "ownerContactId", ""), /**
   * @generated from field: string owner_name = 6;
   */ _define_property(this, "ownerName", ""), /**
   * @generated from field: mono.datagateway.v1.DeliveryCounts counts = 7;
   */ _define_property(this, "counts", void 0), /**
   * @generated from field: mono.datagateway.v1.KpiReading on_time = 8;
   */ _define_property(this, "onTime", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkstreamDeliverySummary, "runtime", proto3);
_define_property(WorkstreamDeliverySummary, "typeName", "mono.datagateway.v1.WorkstreamDeliverySummary");
_define_property(WorkstreamDeliverySummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "owner_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "counts",
            kind: "message",
            T: DeliveryCounts
        },
        {
            no: 8,
            name: "on_time",
            kind: "message",
            T: KpiReading
        }
    ]));
/**
 * OwnerDeliverySummary is one owner's counts; owner_contact_id "-" is the
 * dates with no owner.
 *
 * @generated from message mono.datagateway.v1.OwnerDeliverySummary
 */ export class OwnerDeliverySummary extends Message {
    static fromBinary(bytes, options) {
        return new OwnerDeliverySummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OwnerDeliverySummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OwnerDeliverySummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OwnerDeliverySummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string owner_contact_id = 1;
   */ _define_property(this, "ownerContactId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: mono.datagateway.v1.DeliveryCounts counts = 3;
   */ _define_property(this, "counts", void 0), /**
   * @generated from field: mono.datagateway.v1.KpiReading on_time = 4;
   */ _define_property(this, "onTime", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OwnerDeliverySummary, "runtime", proto3);
_define_property(OwnerDeliverySummary, "typeName", "mono.datagateway.v1.OwnerDeliverySummary");
_define_property(OwnerDeliverySummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "counts",
            kind: "message",
            T: DeliveryCounts
        },
        {
            no: 4,
            name: "on_time",
            kind: "message",
            T: KpiReading
        }
    ]));
/**
 * OnTimeMonth is one calendar month of the on-time trend: the dates due in
 * it, over every row of the read programs (no window, due range or state
 * filter), with the on-time KPI's rule.
 *
 * @generated from message mono.datagateway.v1.OnTimeMonth
 */ export class OnTimeMonth extends Message {
    static fromBinary(bytes, options) {
        return new OnTimeMonth().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OnTimeMonth().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OnTimeMonth().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OnTimeMonth, a, b);
    }
    constructor(data){
        super(), /**
   * month is "YYYY-MM".
   *
   * @generated from field: string month = 1;
   */ _define_property(this, "month", ""), /**
   * @generated from field: int32 on_time = 2;
   */ _define_property(this, "onTime", 0), /**
   * @generated from field: int32 timing_known = 3;
   */ _define_property(this, "timingKnown", 0), /**
   * overdue: dates due in the month still late (nothing filed) on as_of.
   *
   * @generated from field: int32 overdue = 4;
   */ _define_property(this, "overdue", 0), /**
   * @generated from field: mono.datagateway.v1.KpiReading reading = 5;
   */ _define_property(this, "reading", void 0), /**
   * late_at_month_end: the dates late on the month's last day (on as_of for
   * as_of's month): due before it with nothing filed by it, the rule of the
   * late_now KPI taken on that day (SAD-1000). Dates excused, not owed or
   * dated by an event today are left out.
   *
   * @generated from field: int32 late_at_month_end = 6;
   */ _define_property(this, "lateAtMonthEnd", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OnTimeMonth, "runtime", proto3);
_define_property(OnTimeMonth, "typeName", "mono.datagateway.v1.OnTimeMonth");
_define_property(OnTimeMonth, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "on_time",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "timing_known",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "overdue",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "reading",
            kind: "message",
            T: KpiReading
        },
        {
            no: 6,
            name: "late_at_month_end",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * DueDay is one day's dates still owed (due_soon, upcoming, awaiting
 * review or rejected), over the read rows without the window (the due range
 * and the state filter still apply).
 *
 * @generated from message mono.datagateway.v1.DueDay
 */ export class DueDay extends Message {
    static fromBinary(bytes, options) {
        return new DueDay().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DueDay().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DueDay().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DueDay, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string date = 1;
   */ _define_property(this, "date", ""), /**
   * @generated from field: int32 count = 2;
   */ _define_property(this, "count", 0), /**
   * @generated from field: int32 at_risk = 3;
   */ _define_property(this, "atRisk", 0), /**
   * late: the day's dates past due with nothing filed (only on a day before
   * as_of, in calendar_days; due_days never has one).
   *
   * @generated from field: int32 late = 4;
   */ _define_property(this, "late", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DueDay, "runtime", proto3);
_define_property(DueDay, "typeName", "mono.datagateway.v1.DueDay");
_define_property(DueDay, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "at_risk",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * FacetOption is a filter choice: a team or an owner on the read programs,
 * before the team, owner and state filters.
 *
 * @generated from message mono.datagateway.v1.FacetOption
 */ export class FacetOption extends Message {
    static fromBinary(bytes, options) {
        return new FacetOption().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FacetOption().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FacetOption().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FacetOption, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * program_name is a team's program ("" for an owner).
   *
   * @generated from field: string program_name = 3;
   */ _define_property(this, "programName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FacetOption, "runtime", proto3);
_define_property(FacetOption, "typeName", "mono.datagateway.v1.FacetOption");
_define_property(FacetOption, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPortfolioDeliverySummaryResponse
 */ export class GetPortfolioDeliverySummaryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPortfolioDeliverySummaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPortfolioDeliverySummaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPortfolioDeliverySummaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPortfolioDeliverySummaryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliveryCounts totals = 1;
   */ _define_property(this, "totals", void 0), /**
   * programs are every read program, by name.
   *
   * @generated from field: repeated mono.datagateway.v1.ProgramDeliverySummary programs = 2;
   */ _define_property(this, "programs", []), /**
   * workstreams are the teams with a date in the window, then a program's
   * contract-wide dates, by program then name.
   *
   * @generated from field: repeated mono.datagateway.v1.WorkstreamDeliverySummary workstreams = 3;
   */ _define_property(this, "workstreams", []), /**
   * owners are the owners with a date in the window, by name.
   *
   * @generated from field: repeated mono.datagateway.v1.OwnerDeliverySummary owners = 4;
   */ _define_property(this, "owners", []), /**
   * trend is the 12 calendar months ending with as_of's month, oldest first.
   *
   * @generated from field: repeated mono.datagateway.v1.OnTimeMonth trend = 5;
   */ _define_property(this, "trend", []), /**
   * due_days are the 42 days from as_of on.
   *
   * @generated from field: repeated mono.datagateway.v1.DueDay due_days = 6;
   */ _define_property(this, "dueDays", []), /**
   * kpis: on_time, late_now, due_next_14_days, waiting_on_approval.
   *
   * @generated from field: repeated mono.datagateway.v1.KpiReading kpis = 7;
   */ _define_property(this, "kpis", []), /**
   * @generated from field: string as_of = 8;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: repeated mono.datagateway.v1.FacetOption team_options = 9;
   */ _define_property(this, "teamOptions", []), /**
   * @generated from field: repeated mono.datagateway.v1.FacetOption owner_options = 10;
   */ _define_property(this, "ownerOptions", []), /**
   * calendar_days are the 42 days from the Monday of as_of's week (SAD-1000,
   * the due-date calendar): due_days' rows, plus the dates still late, so a
   * day before as_of counts what is late or still owed on it.
   *
   * @generated from field: repeated mono.datagateway.v1.DueDay calendar_days = 11;
   */ _define_property(this, "calendarDays", []), /**
   * mine_fallback: mine was asked for and the caller has no program of its
   * own among those read, so every one was read (SAD-1000).
   *
   * @generated from field: bool mine_fallback = 12;
   */ _define_property(this, "mineFallback", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPortfolioDeliverySummaryResponse, "runtime", proto3);
_define_property(GetPortfolioDeliverySummaryResponse, "typeName", "mono.datagateway.v1.GetPortfolioDeliverySummaryResponse");
_define_property(GetPortfolioDeliverySummaryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "totals",
            kind: "message",
            T: DeliveryCounts
        },
        {
            no: 2,
            name: "programs",
            kind: "message",
            T: ProgramDeliverySummary,
            repeated: true
        },
        {
            no: 3,
            name: "workstreams",
            kind: "message",
            T: WorkstreamDeliverySummary,
            repeated: true
        },
        {
            no: 4,
            name: "owners",
            kind: "message",
            T: OwnerDeliverySummary,
            repeated: true
        },
        {
            no: 5,
            name: "trend",
            kind: "message",
            T: OnTimeMonth,
            repeated: true
        },
        {
            no: 6,
            name: "due_days",
            kind: "message",
            T: DueDay,
            repeated: true
        },
        {
            no: 7,
            name: "kpis",
            kind: "message",
            T: KpiReading,
            repeated: true
        },
        {
            no: 8,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "team_options",
            kind: "message",
            T: FacetOption,
            repeated: true
        },
        {
            no: 10,
            name: "owner_options",
            kind: "message",
            T: FacetOption,
            repeated: true
        },
        {
            no: 11,
            name: "calendar_days",
            kind: "message",
            T: DueDay,
            repeated: true
        },
        {
            no: 12,
            name: "mine_fallback",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * ListPortfolioOccurrencesRequest lists the dates of several programs
 * (SAD-1000) for the summary's filters, read the same way.
 *
 * @generated from message mono.datagateway.v1.ListPortfolioOccurrencesRequest
 */ export class ListPortfolioOccurrencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPortfolioOccurrencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPortfolioOccurrencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPortfolioOccurrencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPortfolioOccurrencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetPortfolioDeliverySummaryRequest filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * group_by: "" (none) | program | team | owner | status | due_week. Rows
   * come grouped in the group order, then by due date.
   *
   * @generated from field: string group_by = 2;
   */ _define_property(this, "groupBy", ""), /**
   * page_size 0 = every row.
   *
   * @generated from field: int32 page_size = 3;
   */ _define_property(this, "pageSize", 0), /**
   * @generated from field: string page_token = 4;
   */ _define_property(this, "pageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPortfolioOccurrencesRequest, "runtime", proto3);
_define_property(ListPortfolioOccurrencesRequest, "typeName", "mono.datagateway.v1.ListPortfolioOccurrencesRequest");
_define_property(ListPortfolioOccurrencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: GetPortfolioDeliverySummaryRequest
        },
        {
            no: 2,
            name: "group_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PortfolioOccurrence is one listed date, joined.
 *
 * @generated from message mono.datagateway.v1.PortfolioOccurrence
 */ export class PortfolioOccurrence extends Message {
    static fromBinary(bytes, options) {
        return new PortfolioOccurrence().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortfolioOccurrence().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortfolioOccurrence().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortfolioOccurrence, a, b);
    }
    constructor(data){
        super(), /**
   * occurrence is the row ListOccurrences lists for it, dependents and
   * event.dependents included (the deliverables that follow the date, counted
   * as its program's own read counts them).
   *
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 1;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 3;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: string duty_title = 4;
   */ _define_property(this, "dutyTitle", ""), /**
   * @generated from field: string duty_key = 5;
   */ _define_property(this, "dutyKey", ""), /**
   * @generated from field: string final_review_tier = 6;
   */ _define_property(this, "finalReviewTier", ""), /**
   * @generated from field: string workstream_name = 7;
   */ _define_property(this, "workstreamName", ""), /**
   * owner as in the summary: the team's owner, else the program's lead,
   * "-" for neither.
   *
   * @generated from field: string owner_contact_id = 8;
   */ _define_property(this, "ownerContactId", ""), /**
   * @generated from field: string owner_name = 9;
   */ _define_property(this, "ownerName", ""), /**
   * at_risk: due within 5 working days with nothing filed.
   *
   * @generated from field: bool at_risk = 10;
   */ _define_property(this, "atRisk", false), /**
   * carried_over: open, from before the window.
   *
   * @generated from field: bool carried_over = 11;
   */ _define_property(this, "carriedOver", false), /**
   * waiting_since: the day the filing the awaiting-review queue lists it for
   * was made, "" when it is not waiting.
   *
   * @generated from field: string waiting_since = 12;
   */ _define_property(this, "waitingSince", ""), /**
   * @generated from field: string group_key = 13;
   */ _define_property(this, "groupKey", ""), /**
   * last_reminded_at: the last reminder sent for the date (RFC 3339), ""
   * when none (SAD-1000).
   *
   * @generated from field: string last_reminded_at = 14;
   */ _define_property(this, "lastRemindedAt", ""), /**
   * duty_letter: the deliverable's letter (CDRL-style "A"), "" when none.
   *
   * @generated from field: string duty_letter = 15;
   */ _define_property(this, "dutyLetter", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PortfolioOccurrence, "runtime", proto3);
_define_property(PortfolioOccurrence, "typeName", "mono.datagateway.v1.PortfolioOccurrence");
_define_property(PortfolioOccurrence, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "duty_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "duty_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "final_review_tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "workstream_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "owner_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "at_risk",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "carried_over",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "waiting_since",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "group_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "last_reminded_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "duty_letter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PortfolioOccurrenceGroup is one group of the listed rows (before paging).
 *
 * @generated from message mono.datagateway.v1.PortfolioOccurrenceGroup
 */ export class PortfolioOccurrenceGroup extends Message {
    static fromBinary(bytes, options) {
        return new PortfolioOccurrenceGroup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortfolioOccurrenceGroup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortfolioOccurrenceGroup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortfolioOccurrenceGroup, a, b);
    }
    constructor(data){
        super(), /**
   * key: a program, team (a program's contract-wide dates are
   * "contract:<program id>"), owner ("-" none), status (a state, with
   * "at_risk" for the at-risk due-soon dates) or due week (its Monday,
   * "" undated).
   *
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * sublabel: a team's program.
   *
   * @generated from field: string sublabel = 3;
   */ _define_property(this, "sublabel", ""), /**
   * @generated from field: int32 count = 4;
   */ _define_property(this, "count", 0), /**
   * late, at_risk: of the group's rows.
   *
   * @generated from field: int32 late = 5;
   */ _define_property(this, "late", 0), /**
   * @generated from field: int32 at_risk = 6;
   */ _define_property(this, "atRisk", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PortfolioOccurrenceGroup, "runtime", proto3);
_define_property(PortfolioOccurrenceGroup, "typeName", "mono.datagateway.v1.PortfolioOccurrenceGroup");
_define_property(PortfolioOccurrenceGroup, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sublabel",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "at_risk",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPortfolioOccurrencesResponse
 */ export class ListPortfolioOccurrencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPortfolioOccurrencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPortfolioOccurrencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPortfolioOccurrencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPortfolioOccurrencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.PortfolioOccurrence rows = 1;
   */ _define_property(this, "rows", []), /**
   * total is the listed rows before paging: the summary's totals.total.
   *
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: string next_page_token = 3;
   */ _define_property(this, "nextPageToken", ""), /**
   * groups are every group of the listed rows, in row order.
   *
   * @generated from field: repeated mono.datagateway.v1.PortfolioOccurrenceGroup groups = 4;
   */ _define_property(this, "groups", []), /**
   * state_counts are the listed rows' states, before paging.
   *
   * @generated from field: map<string, int32> state_counts = 5;
   */ _define_property(this, "stateCounts", {}), /**
   * @generated from field: int32 at_risk = 6;
   */ _define_property(this, "atRisk", 0), /**
   * oldest_days_late: the most days late among the listed late rows.
   *
   * @generated from field: int32 oldest_days_late = 7;
   */ _define_property(this, "oldestDaysLate", 0), /**
   * @generated from field: string as_of = 8;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: repeated mono.datagateway.v1.FacetOption team_options = 9;
   */ _define_property(this, "teamOptions", []), /**
   * @generated from field: repeated mono.datagateway.v1.FacetOption owner_options = 10;
   */ _define_property(this, "ownerOptions", []), /**
   * mine_fallback as in GetPortfolioDeliverySummaryResponse.
   *
   * @generated from field: bool mine_fallback = 11;
   */ _define_property(this, "mineFallback", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPortfolioOccurrencesResponse, "runtime", proto3);
_define_property(ListPortfolioOccurrencesResponse, "typeName", "mono.datagateway.v1.ListPortfolioOccurrencesResponse");
_define_property(ListPortfolioOccurrencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: PortfolioOccurrence,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "groups",
            kind: "message",
            T: PortfolioOccurrenceGroup,
            repeated: true
        },
        {
            no: 5,
            name: "state_counts",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 6,
            name: "at_risk",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "oldest_days_late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "team_options",
            kind: "message",
            T: FacetOption,
            repeated: true
        },
        {
            no: 10,
            name: "owner_options",
            kind: "message",
            T: FacetOption,
            repeated: true
        },
        {
            no: 11,
            name: "mine_fallback",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * ListAttentionItemsRequest reads the queue for the summary's filters.
 * Dates follow every filter; requests follow the program, team and owner
 * filters (an open request is open whatever the window); review items follow
 * the program filter only (a change set belongs to a program, not a team).
 *
 * @generated from message mono.datagateway.v1.ListAttentionItemsRequest
 */ export class ListAttentionItemsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAttentionItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAttentionItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAttentionItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAttentionItemsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetPortfolioDeliverySummaryRequest filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * kinds keeps these kinds (late | waiting | request | at_risk | review);
   * empty keeps every kind. The counts are always of every kind.
   *
   * @generated from field: repeated string kinds = 2;
   */ _define_property(this, "kinds", []), /**
   * limit caps the items (0 = 50).
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAttentionItemsRequest, "runtime", proto3);
_define_property(ListAttentionItemsRequest, "typeName", "mono.datagateway.v1.ListAttentionItemsRequest");
_define_property(ListAttentionItemsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: GetPortfolioDeliverySummaryRequest
        },
        {
            no: 2,
            name: "kinds",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * PortfolioAttentionItem is one thing that needs someone.
 *
 * @generated from message mono.datagateway.v1.PortfolioAttentionItem
 */ export class PortfolioAttentionItem extends Message {
    static fromBinary(bytes, options) {
        return new PortfolioAttentionItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortfolioAttentionItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortfolioAttentionItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortfolioAttentionItem, a, b);
    }
    constructor(data){
        super(), /**
   * kind: late (past due, nothing filed), waiting (filed, waiting on
   * approval for more than 2 days), request (a proposal to waive, excuse,
   * move or correct a date, awaiting its decision), at_risk (due within 5
   * working days, nothing filed), review (the open review items of a change
   * set the Modification Center lists: a modification, a re-extraction or a
   * contract intake).
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * id is unique in the queue: the date's, the request's or the set's id.
   *
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 4;
   */ _define_property(this, "programName", ""), /**
   * title: the deliverable's title, or the change set's.
   *
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * label: the date's period label, "" when none.
   *
   * @generated from field: string label = 6;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string occurrence_id = 7;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string workstream_name = 8;
   */ _define_property(this, "workstreamName", ""), /**
   * @generated from field: string owner_name = 9;
   */ _define_property(this, "ownerName", ""), /**
   * @generated from field: string due_on = 10;
   */ _define_property(this, "dueOn", ""), /**
   * age_days: days late (late), days waiting (waiting, request, review),
   * days left (at_risk).
   *
   * @generated from field: int32 age_days = 11;
   */ _define_property(this, "ageDays", 0), /**
   * since: the day the age counts from (the due date, the filing, the
   * request, the set's creation).
   *
   * @generated from field: string since = 12;
   */ _define_property(this, "since", ""), /**
   * submission_id: the filing waiting on approval.
   *
   * @generated from field: string submission_id = 13;
   */ _define_property(this, "submissionId", ""), /**
   * change_set_id: the request's or the review's change set.
   *
   * @generated from field: string change_set_id = 14;
   */ _define_property(this, "changeSetId", ""), /**
   * request_kind: waiver | not_owed | extension | submission_edit |
   * submission_evidence.
   *
   * @generated from field: string request_kind = 15;
   */ _define_property(this, "requestKind", ""), /**
   * requested_due_on: an extension's proposed due date.
   *
   * @generated from field: string requested_due_on = 16;
   */ _define_property(this, "requestedDueOn", ""), /**
   * @generated from field: string requested_by = 17;
   */ _define_property(this, "requestedBy", ""), /**
   * change_set_type and open_review_count: a review's set and its open items.
   *
   * @generated from field: string change_set_type = 18;
   */ _define_property(this, "changeSetType", ""), /**
   * @generated from field: int32 open_review_count = 19;
   */ _define_property(this, "openReviewCount", 0), /**
   * rank is the item's place in the queue, from 0.
   *
   * @generated from field: int32 rank = 20;
   */ _define_property(this, "rank", 0), /**
   * last_reminded_at: a date's last reminder (RFC 3339), "" when none.
   *
   * @generated from field: string last_reminded_at = 21;
   */ _define_property(this, "lastRemindedAt", ""), /**
   * why (SAD-1005) is set when owner_contact_ids asks for "me": team_owner
   * (a date of a team the caller owns) or program_lead (a date with no team
   * owner, or a waiting, request or review item, on a program the caller
   * leads).
   *
   * @generated from field: string why = 22;
   */ _define_property(this, "why", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PortfolioAttentionItem, "runtime", proto3);
_define_property(PortfolioAttentionItem, "typeName", "mono.datagateway.v1.PortfolioAttentionItem");
_define_property(PortfolioAttentionItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "workstream_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "owner_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "age_days",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "since",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "request_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "requested_due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "requested_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "change_set_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "open_review_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 20,
            name: "rank",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 21,
            name: "last_reminded_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "why",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PortfolioAttentionCount
 */ export class PortfolioAttentionCount extends Message {
    static fromBinary(bytes, options) {
        return new PortfolioAttentionCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortfolioAttentionCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortfolioAttentionCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortfolioAttentionCount, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: int32 count = 2;
   */ _define_property(this, "count", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PortfolioAttentionCount, "runtime", proto3);
_define_property(PortfolioAttentionCount, "typeName", "mono.datagateway.v1.PortfolioAttentionCount");
_define_property(PortfolioAttentionCount, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAttentionItemsResponse
 */ export class ListAttentionItemsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAttentionItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAttentionItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAttentionItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAttentionItemsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * items, ranked: each kind's most urgent item in consequence order (late,
   * waiting, request, at risk, review), then each kind's next, and so on;
   * within a kind, the oldest first (the soonest due, for at risk).
   *
   * @generated from field: repeated mono.datagateway.v1.PortfolioAttentionItem items = 1;
   */ _define_property(this, "items", []), /**
   * counts are every kind's count, in consequence order, before the kinds
   * filter and the limit.
   *
   * @generated from field: repeated mono.datagateway.v1.PortfolioAttentionCount counts = 2;
   */ _define_property(this, "counts", []), /**
   * @generated from field: int32 total = 3;
   */ _define_property(this, "total", 0), /**
   * @generated from field: string as_of = 4;
   */ _define_property(this, "asOf", ""), /**
   * mine_fallback as in GetPortfolioDeliverySummaryResponse.
   *
   * @generated from field: bool mine_fallback = 5;
   */ _define_property(this, "mineFallback", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAttentionItemsResponse, "runtime", proto3);
_define_property(ListAttentionItemsResponse, "typeName", "mono.datagateway.v1.ListAttentionItemsResponse");
_define_property(ListAttentionItemsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: PortfolioAttentionItem,
            repeated: true
        },
        {
            no: 2,
            name: "counts",
            kind: "message",
            T: PortfolioAttentionCount,
            repeated: true
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "mine_fallback",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * SavedView is a named Command Center filter (SAD-1000).
 *
 * @generated from message mono.datagateway.v1.SavedView
 */ export class SavedView extends Message {
    static fromBinary(bytes, options) {
        return new SavedView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SavedView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SavedView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SavedView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * page: the page the view filters, "command_center".
   *
   * @generated from field: string page = 2;
   */ _define_property(this, "page", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * query is the page's URL query string (the filter, as the page writes it).
   *
   * @generated from field: string query = 4;
   */ _define_property(this, "query", ""), /**
   * shared: every user of the tenant sees it; only its owner changes it.
   *
   * @generated from field: bool shared = 5;
   */ _define_property(this, "shared", false), /**
   * @generated from field: string owner_user_id = 6;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string owner_name = 7;
   */ _define_property(this, "ownerName", ""), /**
   * mine: the caller owns it.
   *
   * @generated from field: bool mine = 8;
   */ _define_property(this, "mine", false), /**
   * @generated from field: string updated_at = 9;
   */ _define_property(this, "updatedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SavedView, "runtime", proto3);
_define_property(SavedView, "typeName", "mono.datagateway.v1.SavedView");
_define_property(SavedView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "page",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "shared",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "owner_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "mine",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSavedViewsRequest
 */ export class ListSavedViewsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSavedViewsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSavedViewsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSavedViewsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSavedViewsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string page = 1;
   */ _define_property(this, "page", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSavedViewsRequest, "runtime", proto3);
_define_property(ListSavedViewsRequest, "typeName", "mono.datagateway.v1.ListSavedViewsRequest");
_define_property(ListSavedViewsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSavedViewsResponse
 */ export class ListSavedViewsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSavedViewsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSavedViewsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSavedViewsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSavedViewsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * views: the caller's own, then the tenant's shared ones, each by name.
   *
   * @generated from field: repeated mono.datagateway.v1.SavedView views = 1;
   */ _define_property(this, "views", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSavedViewsResponse, "runtime", proto3);
_define_property(ListSavedViewsResponse, "typeName", "mono.datagateway.v1.ListSavedViewsResponse");
_define_property(ListSavedViewsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "views",
            kind: "message",
            T: SavedView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveViewRequest
 */ export class SaveViewRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveViewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveViewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveViewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveViewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * id "" creates a view; otherwise the caller's own view to change.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string page = 2;
   */ _define_property(this, "page", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string query = 4;
   */ _define_property(this, "query", ""), /**
   * @generated from field: bool shared = 5;
   */ _define_property(this, "shared", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveViewRequest, "runtime", proto3);
_define_property(SaveViewRequest, "typeName", "mono.datagateway.v1.SaveViewRequest");
_define_property(SaveViewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "page",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "shared",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveViewResponse
 */ export class SaveViewResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveViewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveViewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveViewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveViewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SavedView view = 1;
   */ _define_property(this, "view", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveViewResponse, "runtime", proto3);
_define_property(SaveViewResponse, "typeName", "mono.datagateway.v1.SaveViewResponse");
_define_property(SaveViewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "view",
            kind: "message",
            T: SavedView
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteSavedViewRequest
 */ export class DeleteSavedViewRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSavedViewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSavedViewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSavedViewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSavedViewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSavedViewRequest, "runtime", proto3);
_define_property(DeleteSavedViewRequest, "typeName", "mono.datagateway.v1.DeleteSavedViewRequest");
_define_property(DeleteSavedViewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteSavedViewResponse
 */ export class DeleteSavedViewResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSavedViewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSavedViewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSavedViewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSavedViewResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSavedViewResponse, "runtime", proto3);
_define_property(DeleteSavedViewResponse, "typeName", "mono.datagateway.v1.DeleteSavedViewResponse");
_define_property(DeleteSavedViewResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.RemindOccurrenceRequest
 */ export class RemindOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemindOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemindOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemindOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemindOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemindOccurrenceRequest, "runtime", proto3);
_define_property(RemindOccurrenceRequest, "typeName", "mono.datagateway.v1.RemindOccurrenceRequest");
_define_property(RemindOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RemindOccurrenceResponse
 */ export class RemindOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemindOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemindOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemindOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemindOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * reminded_at is when the reminder was sent (RFC 3339).
   *
   * @generated from field: string reminded_at = 1;
   */ _define_property(this, "remindedAt", ""), /**
   * recipient_name: the owner reminded.
   *
   * @generated from field: string recipient_name = 2;
   */ _define_property(this, "recipientName", ""), /**
   * @generated from field: string notification_event_id = 3;
   */ _define_property(this, "notificationEventId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 4;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemindOccurrenceResponse, "runtime", proto3);
_define_property(RemindOccurrenceResponse, "typeName", "mono.datagateway.v1.RemindOccurrenceResponse");
_define_property(RemindOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reminded_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "recipient_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notification_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LogContractEventRequest
 */ export class LogContractEventRequest extends Message {
    static fromBinary(bytes, options) {
        return new LogContractEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogContractEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogContractEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LogContractEventRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string occurred_on = 5;
   */ _define_property(this, "occurredOn", ""), /**
   * @generated from field: string workstream_id = 6;
   */ _define_property(this, "workstreamId", ""), /**
   * duty_id is required for kind "on_request" (which duty was requested)
   * and refused otherwise.
   *
   * @generated from field: string duty_id = 7;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string label = 8;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string source_document_id = 9;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 10;
   */ _define_property(this, "sourceLocator", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LogContractEventRequest, "runtime", proto3);
_define_property(LogContractEventRequest, "typeName", "mono.datagateway.v1.LogContractEventRequest");
_define_property(LogContractEventRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "occurred_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LogContractEventResponse
 */ export class LogContractEventResponse extends Message {
    static fromBinary(bytes, options) {
        return new LogContractEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogContractEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogContractEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LogContractEventResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractEvent event = 1;
   */ _define_property(this, "event", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LogContractEventResponse, "runtime", proto3);
_define_property(LogContractEventResponse, "typeName", "mono.datagateway.v1.LogContractEventResponse");
_define_property(LogContractEventResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: ContractEvent
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateWorkstreamRequest
 */ export class CreateWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: repeated string aliases = 5;
   */ _define_property(this, "aliases", []), /**
   * @generated from field: string named_by_modification_id = 6;
   */ _define_property(this, "namedByModificationId", ""), /**
   * @generated from field: string owner_contact_id = 7;
   */ _define_property(this, "ownerContactId", ""), /**
   * line_numbers: the base and option-period lines the new team owns.
   *
   * @generated from field: repeated string line_numbers = 8;
   */ _define_property(this, "lineNumbers", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateWorkstreamRequest, "runtime", proto3);
_define_property(CreateWorkstreamRequest, "typeName", "mono.datagateway.v1.CreateWorkstreamRequest");
_define_property(CreateWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "aliases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "named_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "line_numbers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateWorkstreamResponse
 */ export class CreateWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractWorkstream workstream = 1;
   */ _define_property(this, "workstream", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateWorkstreamResponse, "runtime", proto3);
_define_property(CreateWorkstreamResponse, "typeName", "mono.datagateway.v1.CreateWorkstreamResponse");
_define_property(CreateWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream",
            kind: "message",
            T: ContractWorkstream
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * UpdateWorkstreamRequest: a 1:1 continuation under a new name is a rename of
 * the same workstream, never a lineage edge.
 *
 * @generated from message mono.datagateway.v1.UpdateWorkstreamRequest
 */ export class UpdateWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string workstream_id = 4;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: optional string name = 5;
   */ _define_property(this, "name", void 0), /**
   * replace_aliases: aliases replaces the set (an empty set clears it).
   *
   * @generated from field: bool replace_aliases = 6;
   */ _define_property(this, "replaceAliases", false), /**
   * @generated from field: repeated string aliases = 7;
   */ _define_property(this, "aliases", []), /**
   * @generated from field: optional string owner_contact_id = 8;
   */ _define_property(this, "ownerContactId", void 0), /**
   * replace_lines: line_numbers replaces the team's base and option-period
   * lines (an empty set unlinks them all); the program's dates re-mint.
   *
   * @generated from field: bool replace_lines = 9;
   */ _define_property(this, "replaceLines", false), /**
   * @generated from field: repeated string line_numbers = 10;
   */ _define_property(this, "lineNumbers", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkstreamRequest, "runtime", proto3);
_define_property(UpdateWorkstreamRequest, "typeName", "mono.datagateway.v1.UpdateWorkstreamRequest");
_define_property(UpdateWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "replace_aliases",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "aliases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 9,
            name: "replace_lines",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "line_numbers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateWorkstreamResponse
 */ export class UpdateWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractWorkstream workstream = 1;
   */ _define_property(this, "workstream", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkstreamResponse, "runtime", proto3);
_define_property(UpdateWorkstreamResponse, "typeName", "mono.datagateway.v1.UpdateWorkstreamResponse");
_define_property(UpdateWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream",
            kind: "message",
            T: ContractWorkstream
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetWorkstreamRequest
 */ export class GetWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string workstream_id = 3;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string as_of = 4;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkstreamRequest, "runtime", proto3);
_define_property(GetWorkstreamRequest, "typeName", "mono.datagateway.v1.GetWorkstreamRequest");
_define_property(GetWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetWorkstreamResponse
 */ export class GetWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractWorkstream workstream = 1;
   */ _define_property(this, "workstream", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSow sows = 2;
   */ _define_property(this, "sows", []), /**
   * @generated from field: repeated mono.datagateway.v1.ContractWorkstreamLineage predecessors = 3;
   */ _define_property(this, "predecessors", []), /**
   * @generated from field: repeated mono.datagateway.v1.ContractWorkstreamLineage successors = 4;
   */ _define_property(this, "successors", []), /**
   * @generated from field: repeated mono.datagateway.v1.SowGapRuling gap_rulings = 5;
   */ _define_property(this, "gapRulings", []), /**
   * current_window is the D104 window on as_of (basis "none" when there is none).
   *
   * @generated from field: mono.datagateway.v1.ResolvedWindow current_window = 6;
   */ _define_property(this, "currentWindow", void 0), /**
   * open_gaps are the workstream's SOW_HISTORY_MISSING windows not yet ruled.
   *
   * @generated from field: repeated mono.datagateway.v1.DutyCheck open_gaps = 7;
   */ _define_property(this, "openGaps", []), /**
   * exercise_lines are the exercise lines that authorize this workstream.
   *
   * @generated from field: repeated mono.datagateway.v1.ExerciseLine exercise_lines = 8;
   */ _define_property(this, "exerciseLines", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkstreamResponse, "runtime", proto3);
_define_property(GetWorkstreamResponse, "typeName", "mono.datagateway.v1.GetWorkstreamResponse");
_define_property(GetWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream",
            kind: "message",
            T: ContractWorkstream
        },
        {
            no: 2,
            name: "sows",
            kind: "message",
            T: ContractSow,
            repeated: true
        },
        {
            no: 3,
            name: "predecessors",
            kind: "message",
            T: ContractWorkstreamLineage,
            repeated: true
        },
        {
            no: 4,
            name: "successors",
            kind: "message",
            T: ContractWorkstreamLineage,
            repeated: true
        },
        {
            no: 5,
            name: "gap_rulings",
            kind: "message",
            T: SowGapRuling,
            repeated: true
        },
        {
            no: 6,
            name: "current_window",
            kind: "message",
            T: ResolvedWindow
        },
        {
            no: 7,
            name: "open_gaps",
            kind: "message",
            T: DutyCheck,
            repeated: true
        },
        {
            no: 8,
            name: "exercise_lines",
            kind: "message",
            T: ExerciseLine,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkstreamsRequest
 */ export class ListWorkstreamsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * include_detail (SAD-994): also return, per listed workstream, exactly
   * what GetWorkstream returns for it on as_of (details), so a page that
   * needs every team's SOWs, lineage, gaps and lines makes one call.
   *
   * @generated from field: bool include_detail = 3;
   */ _define_property(this, "includeDetail", false), /**
   * as_of is the day the details' SOW states and current windows are read
   * on, as GetWorkstreamRequest.as_of; "" = today. Read only with
   * include_detail.
   *
   * @generated from field: string as_of = 4;
   */ _define_property(this, "asOf", ""), /**
   * include_dossiers (R17-B): the details' SOWs carry their dossier_json,
   * which a SOW reading reads beside its own. Read only with include_detail.
   *
   * @generated from field: bool include_dossiers = 5;
   */ _define_property(this, "includeDossiers", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamsRequest, "runtime", proto3);
_define_property(ListWorkstreamsRequest, "typeName", "mono.datagateway.v1.ListWorkstreamsRequest");
_define_property(ListWorkstreamsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_detail",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "include_dossiers",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkstreamsResponse
 */ export class ListWorkstreamsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractWorkstream workstreams = 1;
   */ _define_property(this, "workstreams", []), /**
   * details is set only with include_detail: one GetWorkstream answer per
   * listed workstream, in the order of workstreams, each equal to
   * GetWorkstream for that workstream on as_of.
   *
   * @generated from field: repeated mono.datagateway.v1.GetWorkstreamResponse details = 2;
   */ _define_property(this, "details", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamsResponse, "runtime", proto3);
_define_property(ListWorkstreamsResponse, "typeName", "mono.datagateway.v1.ListWorkstreamsResponse");
_define_property(ListWorkstreamsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstreams",
            kind: "message",
            T: ContractWorkstream,
            repeated: true
        },
        {
            no: 2,
            name: "details",
            kind: "message",
            T: GetWorkstreamResponse,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkWorkstreamLineageRequest
 */ export class LinkWorkstreamLineageRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkWorkstreamLineageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkWorkstreamLineageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkWorkstreamLineageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkWorkstreamLineageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string predecessor_workstream_id = 4;
   */ _define_property(this, "predecessorWorkstreamId", ""), /**
   * @generated from field: string successor_workstream_id = 5;
   */ _define_property(this, "successorWorkstreamId", ""), /**
   * @generated from field: string effective_on = 6;
   */ _define_property(this, "effectiveOn", ""), /**
   * @generated from field: string source_document_id = 7;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 8;
   */ _define_property(this, "sourceLocator", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkWorkstreamLineageRequest, "runtime", proto3);
_define_property(LinkWorkstreamLineageRequest, "typeName", "mono.datagateway.v1.LinkWorkstreamLineageRequest");
_define_property(LinkWorkstreamLineageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "predecessor_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "successor_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "effective_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkWorkstreamLineageResponse
 */ export class LinkWorkstreamLineageResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkWorkstreamLineageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkWorkstreamLineageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkWorkstreamLineageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkWorkstreamLineageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractWorkstreamLineage lineage = 1;
   */ _define_property(this, "lineage", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkWorkstreamLineageResponse, "runtime", proto3);
_define_property(LinkWorkstreamLineageResponse, "typeName", "mono.datagateway.v1.LinkWorkstreamLineageResponse");
_define_property(LinkWorkstreamLineageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lineage",
            kind: "message",
            T: ContractWorkstreamLineage
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSowRequest
 */ export class CreateSowRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateSowRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSowRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSowRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSowRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string workstream_id = 4;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string version = 6;
   */ _define_property(this, "version", ""), /**
   * @generated from field: string approved_on = 7;
   */ _define_property(this, "approvedOn", ""), /**
   * @generated from field: string pop_start = 8;
   */ _define_property(this, "popStart", ""), /**
   * @generated from field: string pop_end = 9;
   */ _define_property(this, "popEnd", ""), /**
   * @generated from field: string program_document_id = 10;
   */ _define_property(this, "programDocumentId", ""), /**
   * not_held: a version named in a held SOW's history but not held itself
   * (D104); requires named_in_sow_id and named_in_locator.
   *
   * @generated from field: bool not_held = 11;
   */ _define_property(this, "notHeld", false), /**
   * @generated from field: string named_in_sow_id = 12;
   */ _define_property(this, "namedInSowId", ""), /**
   * @generated from field: string named_in_locator = 13;
   */ _define_property(this, "namedInLocator", ""), /**
   * @generated from field: string named_in_quote = 14;
   */ _define_property(this, "namedInQuote", ""), /**
   * @generated from field: string supersedes_sow_id = 15;
   */ _define_property(this, "supersedesSowId", ""), /**
   * @generated from field: string as_of = 16;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSowRequest, "runtime", proto3);
_define_property(CreateSowRequest, "typeName", "mono.datagateway.v1.CreateSowRequest");
_define_property(CreateSowRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "approved_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "pop_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "pop_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "program_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "not_held",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "named_in_sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "named_in_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "named_in_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "supersedes_sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSowResponse
 */ export class CreateSowResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateSowResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSowResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSowResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSowResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractSow sow = 1;
   */ _define_property(this, "sow", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSowResponse, "runtime", proto3);
_define_property(CreateSowResponse, "typeName", "mono.datagateway.v1.CreateSowResponse");
_define_property(CreateSowResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sow",
            kind: "message",
            T: ContractSow
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * ExerciseLine is one exercise line (SLIN) and the workstreams it authorizes.
 *
 * @generated from message mono.datagateway.v1.ExerciseLine
 */ export class ExerciseLine extends Message {
    static fromBinary(bytes, options) {
        return new ExerciseLine().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExerciseLine().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExerciseLine().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExerciseLine, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string slin_id = 1;
   */ _define_property(this, "slinId", ""), /**
   * @generated from field: string exercise_id = 2;
   */ _define_property(this, "exerciseId", ""), /**
   * @generated from field: string optional_task_id = 3;
   */ _define_property(this, "optionalTaskId", ""), /**
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string pop_start = 5;
   */ _define_property(this, "popStart", ""), /**
   * @generated from field: string pop_end = 6;
   */ _define_property(this, "popEnd", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ExerciseLineWorkstream workstreams = 7;
   */ _define_property(this, "workstreams", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExerciseLine, "runtime", proto3);
_define_property(ExerciseLine, "typeName", "mono.datagateway.v1.ExerciseLine");
_define_property(ExerciseLine, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "slin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "pop_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pop_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "workstreams",
            kind: "message",
            T: ExerciseLineWorkstream,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ExerciseLineWorkstream
 */ export class ExerciseLineWorkstream extends Message {
    static fromBinary(bytes, options) {
        return new ExerciseLineWorkstream().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExerciseLineWorkstream().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExerciseLineWorkstream().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExerciseLineWorkstream, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string workstream_id = 1;
   */ _define_property(this, "workstreamId", ""), /**
   * sow_id is the SOW/EP the line's title cites; "" = none.
   *
   * @generated from field: string sow_id = 2;
   */ _define_property(this, "sowId", ""), /**
   * basis: stated (the document says so) | reviewer.
   *
   * @generated from field: string basis = 3;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string source_locator = 4;
   */ _define_property(this, "sourceLocator", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExerciseLineWorkstream, "runtime", proto3);
_define_property(ExerciseLineWorkstream, "typeName", "mono.datagateway.v1.ExerciseLineWorkstream");
_define_property(ExerciseLineWorkstream, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetExerciseWorkstreamRequest
 */ export class SetExerciseWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetExerciseWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetExerciseWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetExerciseWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetExerciseWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string exercise_id = 3;
   */ _define_property(this, "exerciseId", ""), /**
   * workstream_ids is the line's whole reviewer set: reviewer links left out
   * are removed. Links the document states are kept either way.
   *
   * @generated from field: repeated string workstream_ids = 4;
   */ _define_property(this, "workstreamIds", []), /**
   * clin_number names the exercise's line. "" = its only line, or, when it
   * has none, the exercise's own CLIN number (the line is then written).
   *
   * @generated from field: string clin_number = 5;
   */ _define_property(this, "clinNumber", ""), /**
   * sow_id: the SOW/EP the line cites; only with one workstream.
   *
   * @generated from field: string sow_id = 6;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string source_locator = 7;
   */ _define_property(this, "sourceLocator", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetExerciseWorkstreamRequest, "runtime", proto3);
_define_property(SetExerciseWorkstreamRequest, "typeName", "mono.datagateway.v1.SetExerciseWorkstreamRequest");
_define_property(SetExerciseWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workstream_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetExerciseWorkstreamResponse
 */ export class SetExerciseWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetExerciseWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetExerciseWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetExerciseWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetExerciseWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ExerciseLine line = 1;
   */ _define_property(this, "line", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetExerciseWorkstreamResponse, "runtime", proto3);
_define_property(SetExerciseWorkstreamResponse, "typeName", "mono.datagateway.v1.SetExerciseWorkstreamResponse");
_define_property(SetExerciseWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "line",
            kind: "message",
            T: ExerciseLine
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * TeamRule is one rule of an assignment. id set: update that rule in place.
 *
 * @generated from message mono.datagateway.v1.TeamRule
 */ export class TeamRule extends Message {
    static fromBinary(bytes, options) {
        return new TeamRule().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TeamRule().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TeamRule().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TeamRule, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.datagateway.v1.ScheduleRuleFields fields = 2;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TeamRule, "runtime", proto3);
_define_property(TeamRule, "typeName", "mono.datagateway.v1.TeamRule");
_define_property(TeamRule, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "fields",
            kind: "message",
            T: ScheduleRuleFields
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetDutyAssignmentRequest
 */ export class SetDutyAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetDutyAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetDutyAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetDutyAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetDutyAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string sow_id = 4;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string duty_id = 5;
   */ _define_property(this, "dutyId", ""), /**
   * handling: performed | routed | not_owed.
   *
   * @generated from field: string handling = 6;
   */ _define_property(this, "handling", ""), /**
   * routed_to_workstream_id "" with routed = base scope / contract-wide.
   *
   * @generated from field: string routed_to_workstream_id = 7;
   */ _define_property(this, "routedToWorkstreamId", ""), /**
   * not_owed_reason: waived | not_applicable | duplicate | not_listed.
   *
   * @generated from field: string not_owed_reason = 8;
   */ _define_property(this, "notOwedReason", ""), /**
   * @generated from field: string title_as_stated = 9;
   */ _define_property(this, "titleAsStated", ""), /**
   * @generated from field: string sender_contact_id = 10;
   */ _define_property(this, "senderContactId", ""), /**
   * @generated from field: string recipient = 11;
   */ _define_property(this, "recipient", ""), /**
   * @generated from field: string format = 12;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 13;
   */ _define_property(this, "submissionMethod", ""), /**
   * @generated from field: string acceptance_criteria = 14;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * override_locators: one per set override (field as override_locators stores it).
   *
   * @generated from field: repeated mono.datagateway.v1.OverrideLocator override_locators = 15;
   */ _define_property(this, "overrideLocators", []), /**
   * @generated from field: string source_locator = 16;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string note = 17;
   */ _define_property(this, "note", ""), /**
   * team_rules is the whole set: rules left out are removed. Only with
   * handling "performed". Each rule's gate is "sow".
   *
   * @generated from field: repeated mono.datagateway.v1.TeamRule team_rules = 18;
   */ _define_property(this, "teamRules", []), /**
   * settled_by (R11-A) is the reading that settled this answer: IntakeSow
   * records it as the assignment's lineage, so a run can count what each
   * tier decided. Unset for a person's answer (the review item records it).
   *
   * @generated from field: mono.datagateway.v1.SettledBy settled_by = 19;
   */ _define_property(this, "settledBy", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetDutyAssignmentRequest, "runtime", proto3);
_define_property(SetDutyAssignmentRequest, "typeName", "mono.datagateway.v1.SetDutyAssignmentRequest");
_define_property(SetDutyAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "handling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "routed_to_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "not_owed_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "title_as_stated",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sender_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "recipient",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "override_locators",
            kind: "message",
            T: OverrideLocator,
            repeated: true
        },
        {
            no: 16,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "team_rules",
            kind: "message",
            T: TeamRule,
            repeated: true
        },
        {
            no: 19,
            name: "settled_by",
            kind: "message",
            T: SettledBy
        }
    ]));
/**
 * SettledBy is which tier of a document reading settled an answer: "code",
 * "jev" or "luna", the probability it gave, and the option it chose.
 *
 * @generated from message mono.datagateway.v1.SettledBy
 */ export class SettledBy extends Message {
    static fromBinary(bytes, options) {
        return new SettledBy().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SettledBy().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SettledBy().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SettledBy, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tier = 1;
   */ _define_property(this, "tier", ""), /**
   * @generated from field: double probability = 2;
   */ _define_property(this, "probability", 0), /**
   * @generated from field: string option = 3;
   */ _define_property(this, "option", ""), /**
   * by is the reading's own account ("matrix:jev", "code: the row's
   * in-scope cell").
   *
   * @generated from field: string by = 4;
   */ _define_property(this, "by", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SettledBy, "runtime", proto3);
_define_property(SettledBy, "typeName", "mono.datagateway.v1.SettledBy");
_define_property(SettledBy, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "probability",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "option",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetDutyAssignmentResponse
 */ export class SetDutyAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetDutyAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetDutyAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetDutyAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetDutyAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractDutyAssignment assignment = 1;
   */ _define_property(this, "assignment", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetDutyAssignmentResponse, "runtime", proto3);
_define_property(SetDutyAssignmentResponse, "typeName", "mono.datagateway.v1.SetDutyAssignmentResponse");
_define_property(SetDutyAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignment",
            kind: "message",
            T: ContractDutyAssignment
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RuleSowGapRequest
 */ export class RuleSowGapRequest extends Message {
    static fromBinary(bytes, options) {
        return new RuleSowGapRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RuleSowGapRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RuleSowGapRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RuleSowGapRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string workstream_id = 4;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string from_on = 5;
   */ _define_property(this, "fromOn", ""), /**
   * @generated from field: string to_on = 6;
   */ _define_property(this, "toOn", ""), /**
   * @generated from field: mono.datagateway.v1.SowGapChoice choice = 7;
   */ _define_property(this, "choice", 0), /**
   * @generated from field: string sow_id = 8;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string change_item_id = 9;
   */ _define_property(this, "changeItemId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RuleSowGapRequest, "runtime", proto3);
_define_property(RuleSowGapRequest, "typeName", "mono.datagateway.v1.RuleSowGapRequest");
_define_property(RuleSowGapRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "from_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "to_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "choice",
            kind: "enum",
            T: proto3.getEnumType(SowGapChoice)
        },
        {
            no: 8,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "change_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RuleSowGapResponse
 */ export class RuleSowGapResponse extends Message {
    static fromBinary(bytes, options) {
        return new RuleSowGapResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RuleSowGapResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RuleSowGapResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RuleSowGapResponse, a, b);
    }
    constructor(data){
        super(), /**
   * ruling is unset for UPLOAD_EARLIER.
   *
   * @generated from field: mono.datagateway.v1.SowGapRuling ruling = 1;
   */ _define_property(this, "ruling", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0), /**
   * open_gaps are the workstream's SOW_HISTORY_MISSING windows still unruled
   * after this call.
   *
   * @generated from field: repeated mono.datagateway.v1.DutyCheck open_gaps = 3;
   */ _define_property(this, "openGaps", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RuleSowGapResponse, "runtime", proto3);
_define_property(RuleSowGapResponse, "typeName", "mono.datagateway.v1.RuleSowGapResponse");
_define_property(RuleSowGapResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ruling",
            kind: "message",
            T: SowGapRuling
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        },
        {
            no: 3,
            name: "open_gaps",
            kind: "message",
            T: DutyCheck,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SubmissionAttachmentInput
 */ export class SubmissionAttachmentInput extends Message {
    static fromBinary(bytes, options) {
        return new SubmissionAttachmentInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmissionAttachmentInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmissionAttachmentInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmissionAttachmentInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string url = 2;
   */ _define_property(this, "url", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmissionAttachmentInput, "runtime", proto3);
_define_property(SubmissionAttachmentInput, "typeName", "mono.datagateway.v1.SubmissionAttachmentInput");
_define_property(SubmissionAttachmentInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSubmissionRequest
 */ export class CreateSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 4;
   */ _define_property(this, "occurrenceId", ""), /**
   * also_occurrence_ids: the same package also counts for these (siblings).
   *
   * @generated from field: repeated string also_occurrence_ids = 5;
   */ _define_property(this, "alsoOccurrenceIds", []), /**
   * @generated from field: string submitted_on = 6;
   */ _define_property(this, "submittedOn", ""), /**
   * @generated from field: string submitted_at = 7;
   */ _define_property(this, "submittedAt", ""), /**
   * @generated from field: string submitted_by_contact_id = 8;
   */ _define_property(this, "submittedByContactId", ""), /**
   * @generated from field: string submitted_by_display = 9;
   */ _define_property(this, "submittedByDisplay", ""), /**
   * @generated from field: repeated string sent_to_contact_ids = 10;
   */ _define_property(this, "sentToContactIds", []), /**
   * @generated from field: string note = 11;
   */ _define_property(this, "note", ""), /**
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 12;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSubmissionRequest, "runtime", proto3);
_define_property(CreateSubmissionRequest, "typeName", "mono.datagateway.v1.CreateSubmissionRequest");
_define_property(CreateSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "also_occurrence_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "submitted_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "submitted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "submitted_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "submitted_by_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sent_to_contact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSubmissionResponse
 */ export class CreateSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSubmission submissions = 1;
   */ _define_property(this, "submissions", []), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSubmissionResponse, "runtime", proto3);
_define_property(CreateSubmissionResponse, "typeName", "mono.datagateway.v1.CreateSubmissionResponse");
_define_property(CreateSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submissions",
            kind: "message",
            T: ContractSubmission,
            repeated: true
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * UpdateSubmissionRequest replaces the submission's stated fields;
 * attachments are replaced only when replace_attachments is set.
 *
 * @generated from message mono.datagateway.v1.UpdateSubmissionRequest
 */ export class UpdateSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string submission_id = 4;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string submitted_on = 5;
   */ _define_property(this, "submittedOn", ""), /**
   * @generated from field: string submitted_at = 6;
   */ _define_property(this, "submittedAt", ""), /**
   * @generated from field: string submitted_by_contact_id = 7;
   */ _define_property(this, "submittedByContactId", ""), /**
   * @generated from field: string submitted_by_display = 8;
   */ _define_property(this, "submittedByDisplay", ""), /**
   * @generated from field: repeated string sent_to_contact_ids = 9;
   */ _define_property(this, "sentToContactIds", []), /**
   * @generated from field: string note = 10;
   */ _define_property(this, "note", ""), /**
   * @generated from field: bool replace_attachments = 11;
   */ _define_property(this, "replaceAttachments", false), /**
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 12;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSubmissionRequest, "runtime", proto3);
_define_property(UpdateSubmissionRequest, "typeName", "mono.datagateway.v1.UpdateSubmissionRequest");
_define_property(UpdateSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "submitted_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "submitted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "submitted_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "submitted_by_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sent_to_contact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "replace_attachments",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateSubmissionResponse
 */ export class UpdateSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractSubmission submission = 1;
   */ _define_property(this, "submission", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSubmissionResponse, "runtime", proto3);
_define_property(UpdateSubmissionResponse, "typeName", "mono.datagateway.v1.UpdateSubmissionResponse");
_define_property(UpdateSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission",
            kind: "message",
            T: ContractSubmission
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WithdrawSubmissionRequest
 */ export class WithdrawSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string submission_id = 4;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawSubmissionRequest, "runtime", proto3);
_define_property(WithdrawSubmissionRequest, "typeName", "mono.datagateway.v1.WithdrawSubmissionRequest");
_define_property(WithdrawSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WithdrawSubmissionResponse
 */ export class WithdrawSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractSubmission submission = 1;
   */ _define_property(this, "submission", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawSubmissionResponse, "runtime", proto3);
_define_property(WithdrawSubmissionResponse, "typeName", "mono.datagateway.v1.WithdrawSubmissionResponse");
_define_property(WithdrawSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission",
            kind: "message",
            T: ContractSubmission
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordReviewRequest
 */ export class RecordReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string submission_id = 4;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string tier = 5;
   */ _define_property(this, "tier", ""), /**
   * @generated from field: string decision = 6;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string reviewer_contact_id = 7;
   */ _define_property(this, "reviewerContactId", ""), /**
   * @generated from field: string reviewer_display = 8;
   */ _define_property(this, "reviewerDisplay", ""), /**
   * @generated from field: string decided_on = 9;
   */ _define_property(this, "decidedOn", ""), /**
   * @generated from field: string notes = 10;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string evidence_artifact_id = 11;
   */ _define_property(this, "evidenceArtifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordReviewRequest, "runtime", proto3);
_define_property(RecordReviewRequest, "typeName", "mono.datagateway.v1.RecordReviewRequest");
_define_property(RecordReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reviewer_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "reviewer_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "decided_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "evidence_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordReviewResponse
 */ export class RecordReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractSubmissionReview review = 1;
   */ _define_property(this, "review", void 0), /**
   * converged: the review restated the live one and nothing was written.
   *
   * @generated from field: bool converged = 2;
   */ _define_property(this, "converged", false), /**
   * @generated from field: string superseded_review_id = 3;
   */ _define_property(this, "supersededReviewId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 4;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordReviewResponse, "runtime", proto3);
_define_property(RecordReviewResponse, "typeName", "mono.datagateway.v1.RecordReviewResponse");
_define_property(RecordReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: ContractSubmissionReview
        },
        {
            no: 2,
            name: "converged",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "superseded_review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * ApplyEvidenceBatch files one batch of deliverable evidence against the
 * program's dates as one staged change set (chat stages it, the user's
 * Accept applies it). The evidence is any file or list chat read: a status
 * report, a sheet or CSV of submissions, an email export, a list typed in
 * chat. It is evidence, never the authority: the documents say what is owed.
 *
 * Staging (dry_run) carries the records already matched to occurrences
 * (chat matches; pangaea never reads the source). It plans every write against
 * the program's current state and keeps the rows and the plan as a run;
 * nothing else is written. Applying names the run: the plan is recomputed,
 * so applying twice or staging the same evidence again converges, and is
 * written in one transaction with set-based statements, never a write per
 * row. A dry run naming a run_id (and no filings) reads that run as stored:
 * its plan and whether it is applied, so chat's card never offers Accept on
 * an applied run.
 *
 * Per filing the plan is:
 *   - submissions: each attempt whose day the date has no live submission
 *     on; a date already filed on a day the record does not state is a
 *     FILED_DIFFERENTLY conflict and nothing is written for it;
 *   - reviews: each tier's verdict on the last attempt, converging like
 *     RecordReview (only with include_reviews);
 *   - the adjusted date, when it differs from the date's due date: a roll
 *     (the next federal workday after a weekend or holiday) is counted and
 *     never written, it is the program's roll setting; a move that leaves
 *     the filing's on-time status as it is applies as MoveOccurrence; a move
 *     that would turn a late filing on time, or of a date other deliverables
 *     follow, is proposed as an extension for a second approver
 *     (ProposeOccurrenceExtension). skip_adjusted leaves every adjusted
 *     date out (the user unticked them).
 *
 * Closing the gaps is a second, separate run (gaps, no filings): what the
 * evidence has and the documents miss, and the reverse. Each gap carries its
 * reason, cause tag and source. Applying names the run with close_gaps set
 * and the gaps the user unticked (skip_gaps); nothing else is written:
 *   - add: a deliverable the evidence files for a team whose documents do not
 *     create it (a new SOW-only deliverable, or found again by its key). A
 *     cadence that reads (monthly, weekly, every N weeks, quarterly, with
 *     its day when stated) becomes the team's schedule rule, so later dates
 *     project; each record is filed on the rule's date nearest its own, or
 *     on a date of its own when the rule has none near it. Without a cadence
 *     (or a SOW for the team rule), one date per record;
 *   - waive: past-due unfiled dates the evidence itself gives the reason
 *     for (a record's own status or note, or the cadence its records
 *     state), quoted verbatim with the record. Never a date the evidence
 *     only leaves out: absence is not a reason.
 *     Waived at once when the user is an instant approver (admin, delivery
 *     VP, program lead), otherwise proposed for a second approver;
 *   - not_owed: dates the documents, re-read, do not make owed (the
 *     extraction misread them). Never a waiver: each date is proposed not
 *     owed (generated_in_error) for a second approver, as
 *     ProposeOccurrenceNotOwed does, the misread and the documents' quote as
 *     its note.
 *
 * @generated from message mono.datagateway.v1.ApplyEvidenceBatchRequest
 */ export class ApplyEvidenceBatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApplyEvidenceBatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyEvidenceBatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyEvidenceBatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyEvidenceBatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * artifact_id: the evidence file, kept on the run (optional).
   *
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: bool dry_run = 5;
   */ _define_property(this, "dryRun", false), /**
   * Staging: the matched records, and the source's name for the run.
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceFiling filings = 6;
   */ _define_property(this, "filings", []), /**
   * @generated from field: string source_name = 7;
   */ _define_property(this, "sourceName", ""), /**
   * Applying: the staged run. With dry_run: the run to read.
   *
   * @generated from field: string run_id = 8;
   */ _define_property(this, "runId", ""), /**
   * include_reviews: also record the records' verdicts. Recording a verdict is
   * area:execution.verdict, as for RecordReview; ryugu refuses it without.
   *
   * @generated from field: bool include_reviews = 9;
   */ _define_property(this, "includeReviews", false), /**
   * Staging a gap run: its gaps (with dry_run, never with filings).
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceGap gaps = 10;
   */ _define_property(this, "gaps", []), /**
   * Applying a gap run: close_gaps is required (ryugu gates it on creating
   * deliverables), skip_gaps the gap ids the user unticked, gap_causes the
   * cause tags the user changed, by gap id.
   *
   * @generated from field: bool close_gaps = 11;
   */ _define_property(this, "closeGaps", false), /**
   * @generated from field: repeated string skip_gaps = 12;
   */ _define_property(this, "skipGaps", []), /**
   * @generated from field: map<string, string> gap_causes = 13;
   */ _define_property(this, "gapCauses", {}), /**
   * Applying a filing run: leave the adjusted dates out (no move, no
   * extension), as the user unticked them.
   *
   * @generated from field: bool skip_adjusted = 14;
   */ _define_property(this, "skipAdjusted", false), /**
   * Staging a filing run: the records of deliverables that hold no date for
   * their team, which date the event such a deliverable is due after
   * (EvidenceEventRecord). A run may stage these alone.
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceEventRecord event_records = 15;
   */ _define_property(this, "eventRecords", []), /**
   * Staging a filing run from a complete source: where it speaks for each
   * team and deliverable, and its last due date. The run's as-of day (its
   * latest submission or verdict) ends the coverage when earlier.
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceCoverage coverage = 16;
   */ _define_property(this, "coverage", []), /**
   * @generated from field: string covered_through = 17;
   */ _define_property(this, "coveredThrough", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyEvidenceBatchRequest, "runtime", proto3);
_define_property(ApplyEvidenceBatchRequest, "typeName", "mono.datagateway.v1.ApplyEvidenceBatchRequest");
_define_property(ApplyEvidenceBatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "filings",
            kind: "message",
            T: EvidenceFiling,
            repeated: true
        },
        {
            no: 7,
            name: "source_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "include_reviews",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "gaps",
            kind: "message",
            T: EvidenceGap,
            repeated: true
        },
        {
            no: 11,
            name: "close_gaps",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "skip_gaps",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "gap_causes",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        },
        {
            no: 14,
            name: "skip_adjusted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "event_records",
            kind: "message",
            T: EvidenceEventRecord,
            repeated: true
        },
        {
            no: 16,
            name: "coverage",
            kind: "message",
            T: EvidenceCoverage,
            repeated: true
        },
        {
            no: 17,
            name: "covered_through",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * EvidenceEventRecord is a record of a deliverable that holds no date for its
 * team. When the deliverable is due a set time after an event (due = event +
 * offset), the record's stated due date run back through that rule dates the
 * event; a record stating no due date leaves it unknown (the filing date is
 * never used: on-time would then be judged against the filing itself).
 *
 * @generated from message mono.datagateway.v1.EvidenceEventRecord
 */ export class EvidenceEventRecord extends Message {
    static fromBinary(bytes, options) {
        return new EvidenceEventRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvidenceEventRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvidenceEventRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvidenceEventRecord, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string source_key = 1;
   */ _define_property(this, "sourceKey", ""), /**
   * @generated from field: string duty_id = 2;
   */ _define_property(this, "dutyId", ""), /**
   * workstream_id: the team ("" = contract-wide).
   *
   * @generated from field: string workstream_id = 3;
   */ _define_property(this, "workstreamId", ""), /**
   * stated_due_on: the record's own due date, "" when it states none.
   *
   * @generated from field: string stated_due_on = 4;
   */ _define_property(this, "statedDueOn", ""), /**
   * quote: the record as its source states it.
   *
   * @generated from field: string quote = 5;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvidenceEventRecord, "runtime", proto3);
_define_property(EvidenceEventRecord, "typeName", "mono.datagateway.v1.EvidenceEventRecord");
_define_property(EvidenceEventRecord, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "stated_due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * EvidenceInferredEvent is one event the run's records date, logged on
 * Accept by LogContractEvent with the records as its provenance.
 *
 * @generated from message mono.datagateway.v1.EvidenceInferredEvent
 */ export class EvidenceInferredEvent extends Message {
    static fromBinary(bytes, options) {
        return new EvidenceInferredEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvidenceInferredEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvidenceInferredEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvidenceInferredEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * name: how the event reads (its dating deliverable, or its kind in words).
   *
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string workstream_id = 3;
   */ _define_property(this, "workstreamId", ""), /**
   * duty_id: the requested deliverable of an on_request event.
   *
   * @generated from field: string duty_id = 4;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string occurred_on = 5;
   */ _define_property(this, "occurredOn", ""), /**
   * @generated from field: repeated string source_keys = 6;
   */ _define_property(this, "sourceKeys", []), /**
   * quote: the first record, as stated.
   *
   * @generated from field: string quote = 7;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvidenceInferredEvent, "runtime", proto3);
_define_property(EvidenceInferredEvent, "typeName", "mono.datagateway.v1.EvidenceInferredEvent");
_define_property(EvidenceInferredEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "occurred_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * EvidenceGap is one gap to close, by kind (add | waive | cover | lineage |
 * not_owed).
 *
 * @generated from message mono.datagateway.v1.EvidenceGap
 */ export class EvidenceGap extends Message {
    static fromBinary(bytes, options) {
        return new EvidenceGap().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvidenceGap().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvidenceGap().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvidenceGap, a, b);
    }
    constructor(data){
        super(), /**
   * id is the gap's key within its run ("add:<team>:<title>",
   * "waive:<team>:<deliverable>", "c<n>" for a cover).
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", ""), /**
   * cause: document_error | client_change | not_performed.
   *
   * @generated from field: string cause = 4;
   */ _define_property(this, "cause", ""), /**
   * source: the evidence records, or the document page, that say so.
   *
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * workstream_id: the team ("" = contract-wide).
   *
   * @generated from field: string workstream_id = 6;
   */ _define_property(this, "workstreamId", ""), /**
   * add: the deliverable's title and the evidence's cadence, and one date
   * per record; each date's filing names no occurrence (applying finds or
   * creates it).
   *
   * @generated from field: string title = 7;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string cadence = 8;
   */ _define_property(this, "cadence", ""), /**
   * @generated from field: repeated mono.datagateway.v1.EvidenceGapDate dates = 9;
   */ _define_property(this, "dates", []), /**
   * waive and not_owed: the series' dates.
   *
   * @generated from field: repeated string occurrence_ids = 10;
   */ _define_property(this, "occurrenceIds", []), /**
   * cover (R15-A): the team's records file the dates of duty_id that
   * owner_workstream_id ("" = the contract) owes, with one document: one
   * artifact. dates are the records (their due dates and source keys, never
   * filed by this gap). Applying routes the team's SOWs in force on those
   * dates to the owner, so the team watches the owner's dates; it creates
   * no obligation.
   *
   * @generated from field: string duty_id = 11;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string owner_workstream_id = 12;
   */ _define_property(this, "ownerWorkstreamId", ""), /**
   * A waive with no occurrence_ids (R20-A) is a series the batch's own
   * records date by logging its event, whose records state the reason
   * (R21-A, filed once): applying waives the dates of duty_id for
   * workstream_id due in [from, through] that nothing files.
   *
   * @generated from field: string from = 13;
   */ _define_property(this, "from", ""), /**
   * @generated from field: string through = 14;
   */ _define_property(this, "through", ""), /**
   * owner_duty_id (R22-A): a cover of the dates occurrence_ids of duty_id
   * (workstream_id and owner_workstream_id "", the contract's own) by
   * another deliverable's series, this one. Applying closes those dates as
   * covered by it; it routes and files nothing.
   *
   * @generated from field: string owner_duty_id = 15;
   */ _define_property(this, "ownerDutyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvidenceGap, "runtime", proto3);
_define_property(EvidenceGap, "typeName", "mono.datagateway.v1.EvidenceGap");
_define_property(EvidenceGap, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "cause",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "dates",
            kind: "message",
            T: EvidenceGapDate,
            repeated: true
        },
        {
            no: 10,
            name: "occurrence_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "owner_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "through",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "owner_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EvidenceGapDate
 */ export class EvidenceGapDate extends Message {
    static fromBinary(bytes, options) {
        return new EvidenceGapDate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvidenceGapDate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvidenceGapDate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvidenceGapDate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string due_on = 1;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: mono.datagateway.v1.EvidenceFiling filing = 2;
   */ _define_property(this, "filing", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvidenceGapDate, "runtime", proto3);
_define_property(EvidenceGapDate, "typeName", "mono.datagateway.v1.EvidenceGapDate");
_define_property(EvidenceGapDate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filing",
            kind: "message",
            T: EvidenceFiling
        }
    ]));
/**
 * EvidenceFiling is one evidence record matched to one occurrence.
 *
 * @generated from message mono.datagateway.v1.EvidenceFiling
 */ export class EvidenceFiling extends Message {
    static fromBinary(bytes, options) {
        return new EvidenceFiling().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvidenceFiling().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvidenceFiling().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvidenceFiling, a, b);
    }
    constructor(data){
        super(), /**
   * source_key names the record in its source ("Base year!ID 5297").
   *
   * @generated from field: string source_key = 1;
   */ _define_property(this, "sourceKey", ""), /**
   * @generated from field: string occurrence_id = 2;
   */ _define_property(this, "occurrenceId", ""), /**
   * attempts in submission order: the original, then a resubmission.
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceAttempt attempts = 3;
   */ _define_property(this, "attempts", []), /**
   * reviews are the verdicts on the last attempt, one per tier.
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceReview reviews = 4;
   */ _define_property(this, "reviews", []), /**
   * adjusted_due_on is the record's adjusted date, "" when it states none.
   *
   * @generated from field: string adjusted_due_on = 5;
   */ _define_property(this, "adjustedDueOn", ""), /**
   * A filing that logs its own date (occurrence_id ""): the deliverable holds
   * no date for the team (an as-needed or event rule, or a schedule with no
   * first date), so applying finds or adds the one-off date of duty_id for
   * workstream_id ("" = contract-wide) on due_on, as AddOccurrence would, and
   * files on it.
   *
   * @generated from field: string duty_id = 6;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string workstream_id = 7;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string due_on = 8;
   */ _define_property(this, "dueOn", ""), /**
   * attested: the record states its submissions but carries no document, so
   * they are filed as attested by the record (no file or link).
   *
   * @generated from field: bool attested = 9;
   */ _define_property(this, "attested", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvidenceFiling, "runtime", proto3);
_define_property(EvidenceFiling, "typeName", "mono.datagateway.v1.EvidenceFiling");
_define_property(EvidenceFiling, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attempts",
            kind: "message",
            T: EvidenceAttempt,
            repeated: true
        },
        {
            no: 4,
            name: "reviews",
            kind: "message",
            T: EvidenceReview,
            repeated: true
        },
        {
            no: 5,
            name: "adjusted_due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "attested",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * EvidenceCoverage is where a complete source (the whole record of a date
 * range) speaks for a team's deliverable: from its first
 * row of that deliverable (duty_id "": of any deliverable, the team's first
 * row) to the source's last date. An unfiled date no applied source covers
 * is "not covered by evidence", never overdue.
 *
 * @generated from message mono.datagateway.v1.EvidenceCoverage
 */ export class EvidenceCoverage extends Message {
    static fromBinary(bytes, options) {
        return new EvidenceCoverage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvidenceCoverage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvidenceCoverage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvidenceCoverage, a, b);
    }
    constructor(data){
        super(), /**
   * workstream_id: the team ("" = contract-wide).
   *
   * @generated from field: string workstream_id = 1;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string duty_id = 2;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string from = 3;
   */ _define_property(this, "from", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvidenceCoverage, "runtime", proto3);
_define_property(EvidenceCoverage, "typeName", "mono.datagateway.v1.EvidenceCoverage");
_define_property(EvidenceCoverage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EvidenceAttempt
 */ export class EvidenceAttempt extends Message {
    static fromBinary(bytes, options) {
        return new EvidenceAttempt().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvidenceAttempt().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvidenceAttempt().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvidenceAttempt, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string submitted_on = 1;
   */ _define_property(this, "submittedOn", ""), /**
   * @generated from field: string submitted_by_display = 2;
   */ _define_property(this, "submittedByDisplay", ""), /**
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 3;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvidenceAttempt, "runtime", proto3);
_define_property(EvidenceAttempt, "typeName", "mono.datagateway.v1.EvidenceAttempt");
_define_property(EvidenceAttempt, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submitted_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "submitted_by_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EvidenceReview
 */ export class EvidenceReview extends Message {
    static fromBinary(bytes, options) {
        return new EvidenceReview().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvidenceReview().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvidenceReview().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvidenceReview, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tier = 1;
   */ _define_property(this, "tier", ""), /**
   * @generated from field: string decision = 2;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string reviewer_display = 3;
   */ _define_property(this, "reviewerDisplay", ""), /**
   * @generated from field: string decided_on = 4;
   */ _define_property(this, "decidedOn", ""), /**
   * @generated from field: string notes = 5;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvidenceReview, "runtime", proto3);
_define_property(EvidenceReview, "typeName", "mono.datagateway.v1.EvidenceReview");
_define_property(EvidenceReview, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reviewer_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decided_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * EvidenceBatchPlan counts what applying the run writes (staged) or wrote
 * (applied). *_existing are already on file and are not written again.
 *
 * @generated from message mono.datagateway.v1.EvidenceBatchPlan
 */ export class EvidenceBatchPlan extends Message {
    static fromBinary(bytes, options) {
        return new EvidenceBatchPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvidenceBatchPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvidenceBatchPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvidenceBatchPlan, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 filings = 1;
   */ _define_property(this, "filings", 0), /**
   * @generated from field: int32 submissions_new = 2;
   */ _define_property(this, "submissionsNew", 0), /**
   * @generated from field: int32 submissions_existing = 3;
   */ _define_property(this, "submissionsExisting", 0), /**
   * @generated from field: int32 reviews_new = 4;
   */ _define_property(this, "reviewsNew", 0), /**
   * @generated from field: int32 reviews_existing = 5;
   */ _define_property(this, "reviewsExisting", 0), /**
   * @generated from field: int32 moves = 6;
   */ _define_property(this, "moves", 0), /**
   * @generated from field: int32 extensions = 7;
   */ _define_property(this, "extensions", 0), /**
   * @generated from field: int32 rolls = 8;
   */ _define_property(this, "rolls", 0), /**
   * conflicts are what is not written (a filing, or one of its verdicts),
   * each with its reason.
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceConflict conflicts = 9;
   */ _define_property(this, "conflicts", []), /**
   * reviews_skipped: verdicts left out because include_reviews was not set.
   *
   * @generated from field: int32 reviews_skipped = 10;
   */ _define_property(this, "reviewsSkipped", 0), /**
   * extensions_existing: adjusted dates already proposed or applied.
   *
   * @generated from field: int32 extensions_existing = 11;
   */ _define_property(this, "extensionsExisting", 0), /**
   * extensions_instant: extensions applied at once because the user needs no
   * second approver (instant_approver says why: "admin", "delivery VP" or
   * "program lead"); extensions counts only the ones proposed.
   *
   * @generated from field: int32 extensions_instant = 12;
   */ _define_property(this, "extensionsInstant", 0), /**
   * @generated from field: string instant_approver = 13;
   */ _define_property(this, "instantApprover", ""), /**
   * A gap run: the gaps staged and those the user skipped; deliverables and
   * dates added; dates waived at once (instant_approver says why), proposed
   * for a second approver, or waived or proposed already.
   *
   * @generated from field: int32 gaps = 14;
   */ _define_property(this, "gaps", 0), /**
   * @generated from field: int32 gaps_skipped = 15;
   */ _define_property(this, "gapsSkipped", 0), /**
   * @generated from field: int32 deliverables_new = 16;
   */ _define_property(this, "deliverablesNew", 0), /**
   * @generated from field: int32 dates_new = 17;
   */ _define_property(this, "datesNew", 0), /**
   * @generated from field: int32 waivers_instant = 18;
   */ _define_property(this, "waiversInstant", 0), /**
   * @generated from field: int32 waivers = 19;
   */ _define_property(this, "waivers", 0), /**
   * @generated from field: int32 waivers_existing = 20;
   */ _define_property(this, "waiversExisting", 0), /**
   * rules_new: team schedule rules an added deliverable's cadence set, so
   * its later dates project.
   *
   * @generated from field: int32 rules_new = 21;
   */ _define_property(this, "rulesNew", 0), /**
   * adjusted_skipped: adjusted dates left out by skip_adjusted.
   *
   * @generated from field: int32 adjusted_skipped = 22;
   */ _define_property(this, "adjustedSkipped", 0), /**
   * events: the events the run's event records date (logged on Accept);
   * events_existing: those already logged on that day; events_unknown: the
   * records whose event is not dated, each with why (code EVENT_UNKNOWN).
   * Records putting a once-a-period event on different days are a conflict
   * (EVENT_DATES_DISAGREE) quoting both, and nothing is logged for it.
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceInferredEvent events = 23;
   */ _define_property(this, "events", []), /**
   * @generated from field: int32 events_existing = 24;
   */ _define_property(this, "eventsExisting", 0), /**
   * @generated from field: repeated mono.datagateway.v1.EvidenceConflict events_unknown = 25;
   */ _define_property(this, "eventsUnknown", []), /**
   * covers_new: SOW assignments a gap run's covers routed to the producer
   * (R15-A); covers_existing: those already routed there.
   *
   * @generated from field: int32 covers_new = 26;
   */ _define_property(this, "coversNew", 0), /**
   * @generated from field: int32 covers_existing = 27;
   */ _define_property(this, "coversExisting", 0), /**
   * dates_covered (R22-A): dates a gap run's covers closed as covered by
   * another deliverable's series.
   *
   * @generated from field: int32 dates_covered = 28;
   */ _define_property(this, "datesCovered", 0), /**
   * gaps_skipped_ids: the gaps the user unticked (gaps_skipped of them), so
   * an applied run shows what was accepted.
   *
   * @generated from field: repeated string gaps_skipped_ids = 29;
   */ _define_property(this, "gapsSkippedIds", []), /**
   * not_owed_proposed: dates a gap run's not_owed gaps proposed not owed
   * for a second approver; not_owed_existing: those already retired or with
   * a decision open.
   *
   * @generated from field: int32 not_owed_proposed = 30;
   */ _define_property(this, "notOwedProposed", 0), /**
   * @generated from field: int32 not_owed_existing = 31;
   */ _define_property(this, "notOwedExisting", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvidenceBatchPlan, "runtime", proto3);
_define_property(EvidenceBatchPlan, "typeName", "mono.datagateway.v1.EvidenceBatchPlan");
_define_property(EvidenceBatchPlan, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filings",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "submissions_new",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "submissions_existing",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "reviews_new",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "reviews_existing",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "moves",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "extensions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "rolls",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "conflicts",
            kind: "message",
            T: EvidenceConflict,
            repeated: true
        },
        {
            no: 10,
            name: "reviews_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "extensions_existing",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "extensions_instant",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "instant_approver",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "gaps",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "gaps_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "deliverables_new",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "dates_new",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 18,
            name: "waivers_instant",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 19,
            name: "waivers",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 20,
            name: "waivers_existing",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 21,
            name: "rules_new",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 22,
            name: "adjusted_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 23,
            name: "events",
            kind: "message",
            T: EvidenceInferredEvent,
            repeated: true
        },
        {
            no: 24,
            name: "events_existing",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 25,
            name: "events_unknown",
            kind: "message",
            T: EvidenceConflict,
            repeated: true
        },
        {
            no: 26,
            name: "covers_new",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 27,
            name: "covers_existing",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 28,
            name: "dates_covered",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 29,
            name: "gaps_skipped_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 30,
            name: "not_owed_proposed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 31,
            name: "not_owed_existing",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * EvidenceConflict code: OCCURRENCE_NOT_FOUND | OCCURRENCE_RETIRED |
 * FILED_DIFFERENTLY | NO_ATTACHMENT | NO_REVIEWER | BAD_DATE |
 * EVENT_DATES_DISAGREE | EVENT_UNKNOWN (events_unknown only), and on a gap
 * run GAP_FILED (a date to waive has a filing now) | GAP_TEAM_NOT_FOUND |
 * DATE_TAKEN (two records name one date of an added deliverable).
 *
 * @generated from message mono.datagateway.v1.EvidenceConflict
 */ export class EvidenceConflict extends Message {
    static fromBinary(bytes, options) {
        return new EvidenceConflict().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvidenceConflict().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvidenceConflict().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvidenceConflict, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string source_key = 1;
   */ _define_property(this, "sourceKey", ""), /**
   * @generated from field: string occurrence_id = 2;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string code = 3;
   */ _define_property(this, "code", ""), /**
   * @generated from field: string message = 4;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvidenceConflict, "runtime", proto3);
_define_property(EvidenceConflict, "typeName", "mono.datagateway.v1.EvidenceConflict");
_define_property(EvidenceConflict, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ApplyEvidenceBatchResponse
 */ export class ApplyEvidenceBatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApplyEvidenceBatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyEvidenceBatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyEvidenceBatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyEvidenceBatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string run_id = 1;
   */ _define_property(this, "runId", ""), /**
   * @generated from field: mono.datagateway.v1.EvidenceBatchPlan plan = 2;
   */ _define_property(this, "plan", void 0), /**
   * applied: the run is applied (by this call, or by an earlier one, in
   * which case nothing was written and result is empty).
   *
   * @generated from field: bool applied = 3;
   */ _define_property(this, "applied", false), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 4;
   */ _define_property(this, "result", void 0), /**
   * reviews_permitted is set by ryugu on a dry run: whether the caller may
   * record the verdicts (area:execution.verdict), so the card offers them
   * only to who the UI would.
   *
   * @generated from field: bool reviews_permitted = 5;
   */ _define_property(this, "reviewsPermitted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyEvidenceBatchResponse, "runtime", proto3);
_define_property(ApplyEvidenceBatchResponse, "typeName", "mono.datagateway.v1.ApplyEvidenceBatchResponse");
_define_property(ApplyEvidenceBatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "plan",
            kind: "message",
            T: EvidenceBatchPlan
        },
        {
            no: 3,
            name: "applied",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "result",
            kind: "message",
            T: WriteResult
        },
        {
            no: 5,
            name: "reviews_permitted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeliverableSettings
 */ export class DeliverableSettings extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableSettings().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableSettings().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableSettings().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableSettings, a, b);
    }
    constructor(data){
        super(), /**
   * roll: following_federal_workday | preceding_federal_workday | none;
   * "" = the contract does not state it (never assumed, D86).
   *
   * @generated from field: string roll = 1;
   */ _define_property(this, "roll", ""), /**
   * @generated from field: string roll_locator = 2;
   */ _define_property(this, "rollLocator", ""), /**
   * @generated from field: repeated string recipients = 3;
   */ _define_property(this, "recipients", []), /**
   * higher_tier_satisfies (D110): an approval at a VA tier above the duty's
   * final tier also approves. Default false (strict).
   *
   * @generated from field: bool higher_tier_satisfies = 4;
   */ _define_property(this, "higherTierSatisfies", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableSettings, "runtime", proto3);
_define_property(DeliverableSettings, "typeName", "mono.datagateway.v1.DeliverableSettings");
_define_property(DeliverableSettings, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "roll",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "roll_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "recipients",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "higher_tier_satisfies",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDeliverableSettingsRequest
 */ export class GetDeliverableSettingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableSettingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableSettingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableSettingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableSettingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableSettingsRequest, "runtime", proto3);
_define_property(GetDeliverableSettingsRequest, "typeName", "mono.datagateway.v1.GetDeliverableSettingsRequest");
_define_property(GetDeliverableSettingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDeliverableSettingsResponse
 */ export class GetDeliverableSettingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableSettingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableSettingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableSettingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableSettingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableSettings settings = 1;
   */ _define_property(this, "settings", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableSettingsResponse, "runtime", proto3);
_define_property(GetDeliverableSettingsResponse, "typeName", "mono.datagateway.v1.GetDeliverableSettingsResponse");
_define_property(GetDeliverableSettingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "settings",
            kind: "message",
            T: DeliverableSettings
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateDeliverableSettingsRequest
 */ export class UpdateDeliverableSettingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableSettingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableSettingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableSettingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableSettingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * Each field is written only when present.
   *
   * @generated from field: optional string roll = 4;
   */ _define_property(this, "roll", void 0), /**
   * @generated from field: optional string roll_locator = 5;
   */ _define_property(this, "rollLocator", void 0), /**
   * @generated from field: bool replace_recipients = 6;
   */ _define_property(this, "replaceRecipients", false), /**
   * @generated from field: repeated string recipients = 7;
   */ _define_property(this, "recipients", []), /**
   * @generated from field: optional bool higher_tier_satisfies = 8;
   */ _define_property(this, "higherTierSatisfies", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableSettingsRequest, "runtime", proto3);
_define_property(UpdateDeliverableSettingsRequest, "typeName", "mono.datagateway.v1.UpdateDeliverableSettingsRequest");
_define_property(UpdateDeliverableSettingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "roll",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "roll_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "replace_recipients",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "recipients",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "higher_tier_satisfies",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateDeliverableSettingsResponse
 */ export class UpdateDeliverableSettingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableSettingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableSettingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableSettingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableSettingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableSettings settings = 1;
   */ _define_property(this, "settings", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableSettingsResponse, "runtime", proto3);
_define_property(UpdateDeliverableSettingsResponse, "typeName", "mono.datagateway.v1.UpdateDeliverableSettingsResponse");
_define_property(UpdateDeliverableSettingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "settings",
            kind: "message",
            T: DeliverableSettings
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossaryRef
 */ export class GlossaryRef extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 page = 1;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string quote = 2;
   */ _define_property(this, "quote", ""), /**
   * @generated from field: string document_id = 3;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string section_key = 4;
   */ _define_property(this, "sectionKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryRef, "runtime", proto3);
_define_property(GlossaryRef, "typeName", "mono.datagateway.v1.GlossaryRef");
_define_property(GlossaryRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossaryTerm
 */ export class GlossaryTerm extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryTerm().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryTerm().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryTerm().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryTerm, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string term = 2;
   */ _define_property(this, "term", ""), /**
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string expansion = 4;
   */ _define_property(this, "expansion", ""), /**
   * @generated from field: string workstream_id = 5;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRef refs = 6;
   */ _define_property(this, "refs", []), /**
   * @generated from field: string source = 7;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string status = 8;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryTerm, "runtime", proto3);
_define_property(GlossaryTerm, "typeName", "mono.datagateway.v1.GlossaryTerm");
_define_property(GlossaryTerm, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "term",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expansion",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "refs",
            kind: "message",
            T: GlossaryRef,
            repeated: true
        },
        {
            no: 7,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossaryRelation
 */ export class GlossaryRelation extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryRelation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryRelation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryRelation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryRelation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string from_term_id = 2;
   */ _define_property(this, "fromTermId", ""), /**
   * @generated from field: string to_term_id = 3;
   */ _define_property(this, "toTermId", ""), /**
   * @generated from field: string relation = 4;
   */ _define_property(this, "relation", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRef refs = 6;
   */ _define_property(this, "refs", []), /**
   * @generated from field: string source = 7;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string status = 8;
   */ _define_property(this, "status", ""), /**
   * A reviewer link's source: the document page it was
   * read from, and/or the statement in reason ("client statement, date").
   *
   * @generated from field: string source_document_id = 9;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: int32 source_page = 10;
   */ _define_property(this, "sourcePage", 0), /**
   * edited_by_name is who added the reviewer link; "" for a document link.
   *
   * @generated from field: string edited_by_name = 11;
   */ _define_property(this, "editedByName", ""), /**
   * created_at is RFC 3339.
   *
   * @generated from field: string created_at = 12;
   */ _define_property(this, "createdAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryRelation, "runtime", proto3);
_define_property(GlossaryRelation, "typeName", "mono.datagateway.v1.GlossaryRelation");
_define_property(GlossaryRelation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "refs",
            kind: "message",
            T: GlossaryRef,
            repeated: true
        },
        {
            no: 7,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "edited_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossarySectionHealth
 */ export class GlossarySectionHealth extends Message {
    static fromBinary(bytes, options) {
        return new GlossarySectionHealth().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossarySectionHealth().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossarySectionHealth().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossarySectionHealth, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 verified = 1;
   */ _define_property(this, "verified", 0), /**
   * @generated from field: int32 failed = 2;
   */ _define_property(this, "failed", 0), /**
   * @generated from field: int32 total = 3;
   */ _define_property(this, "total", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossarySectionHealth, "runtime", proto3);
_define_property(GlossarySectionHealth, "typeName", "mono.datagateway.v1.GlossarySectionHealth");
_define_property(GlossarySectionHealth, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "verified",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "failed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossaryTermInput
 */ export class GlossaryTermInput extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryTermInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryTermInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryTermInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryTermInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string term = 1;
   */ _define_property(this, "term", ""), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string expansion = 3;
   */ _define_property(this, "expansion", ""), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRef refs = 4;
   */ _define_property(this, "refs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryTermInput, "runtime", proto3);
_define_property(GlossaryTermInput, "typeName", "mono.datagateway.v1.GlossaryTermInput");
_define_property(GlossaryTermInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "term",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "expansion",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "refs",
            kind: "message",
            T: GlossaryRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossaryRelationInput
 */ export class GlossaryRelationInput extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryRelationInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryRelationInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryRelationInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryRelationInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string from = 1;
   */ _define_property(this, "from", ""), /**
   * @generated from field: string to = 2;
   */ _define_property(this, "to", ""), /**
   * @generated from field: string relation = 3;
   */ _define_property(this, "relation", ""), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRef refs = 4;
   */ _define_property(this, "refs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryRelationInput, "runtime", proto3);
_define_property(GlossaryRelationInput, "typeName", "mono.datagateway.v1.GlossaryRelationInput");
_define_property(GlossaryRelationInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "refs",
            kind: "message",
            T: GlossaryRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertGlossarySectionRequest
 */ export class UpsertGlossarySectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertGlossarySectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertGlossarySectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertGlossarySectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertGlossarySectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string document_id = 4;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string section_key = 5;
   */ _define_property(this, "sectionKey", ""), /**
   * @generated from field: string section_number = 6;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: string heading = 7;
   */ _define_property(this, "heading", ""), /**
   * @generated from field: string content_sha256 = 8;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string prompt_version = 9;
   */ _define_property(this, "promptVersion", ""), /**
   * @generated from field: string model = 10;
   */ _define_property(this, "model", ""), /**
   * status: verified | failed
   *
   * @generated from field: string status = 11;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 proposed = 12;
   */ _define_property(this, "proposed", 0), /**
   * @generated from field: int32 kept = 13;
   */ _define_property(this, "kept", 0), /**
   * @generated from field: int32 dropped = 14;
   */ _define_property(this, "dropped", 0), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryTermInput terms = 15;
   */ _define_property(this, "terms", []), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRelationInput relations = 16;
   */ _define_property(this, "relations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertGlossarySectionRequest, "runtime", proto3);
_define_property(UpsertGlossarySectionRequest, "typeName", "mono.datagateway.v1.UpsertGlossarySectionRequest");
_define_property(UpsertGlossarySectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "heading",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "prompt_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "model",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "proposed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "kept",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "dropped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "terms",
            kind: "message",
            T: GlossaryTermInput,
            repeated: true
        },
        {
            no: 16,
            name: "relations",
            kind: "message",
            T: GlossaryRelationInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertGlossarySectionResponse
 */ export class UpsertGlossarySectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertGlossarySectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertGlossarySectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertGlossarySectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertGlossarySectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_id = 1;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: bool cache_hit = 2;
   */ _define_property(this, "cacheHit", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertGlossarySectionResponse, "runtime", proto3);
_define_property(UpsertGlossarySectionResponse, "typeName", "mono.datagateway.v1.UpsertGlossarySectionResponse");
_define_property(UpsertGlossarySectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "cache_hit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.FindGlossarySectionRequest
 */ export class FindGlossarySectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new FindGlossarySectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindGlossarySectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindGlossarySectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindGlossarySectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string section_key = 3;
   */ _define_property(this, "sectionKey", ""), /**
   * @generated from field: string content_sha256 = 4;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string prompt_version = 5;
   */ _define_property(this, "promptVersion", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindGlossarySectionRequest, "runtime", proto3);
_define_property(FindGlossarySectionRequest, "typeName", "mono.datagateway.v1.FindGlossarySectionRequest");
_define_property(FindGlossarySectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "prompt_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.FindGlossarySectionResponse
 */ export class FindGlossarySectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new FindGlossarySectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindGlossarySectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindGlossarySectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindGlossarySectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool found = 1;
   */ _define_property(this, "found", false), /**
   * verified | failed; empty when not found. A failed section is retried.
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string section_id = 3;
   */ _define_property(this, "sectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindGlossarySectionResponse, "runtime", proto3);
_define_property(FindGlossarySectionResponse, "typeName", "mono.datagateway.v1.FindGlossarySectionResponse");
_define_property(FindGlossarySectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "found",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramGlossaryRequest
 */ export class GetProgramGlossaryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramGlossaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramGlossaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramGlossaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramGlossaryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramGlossaryRequest, "runtime", proto3);
_define_property(GetProgramGlossaryRequest, "typeName", "mono.datagateway.v1.GetProgramGlossaryRequest");
_define_property(GetProgramGlossaryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramGlossaryResponse
 */ export class GetProgramGlossaryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramGlossaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramGlossaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramGlossaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramGlossaryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryTerm terms = 1;
   */ _define_property(this, "terms", []), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRelation relations = 2;
   */ _define_property(this, "relations", []), /**
   * @generated from field: repeated string background = 3;
   */ _define_property(this, "background", []), /**
   * @generated from field: repeated string hosting = 4;
   */ _define_property(this, "hosting", []), /**
   * @generated from field: mono.datagateway.v1.GlossarySectionHealth sections = 5;
   */ _define_property(this, "sections", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramGlossaryResponse, "runtime", proto3);
_define_property(GetProgramGlossaryResponse, "typeName", "mono.datagateway.v1.GetProgramGlossaryResponse");
_define_property(GetProgramGlossaryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "terms",
            kind: "message",
            T: GlossaryTerm,
            repeated: true
        },
        {
            no: 2,
            name: "relations",
            kind: "message",
            T: GlossaryRelation,
            repeated: true
        },
        {
            no: 3,
            name: "background",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "hosting",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "sections",
            kind: "message",
            T: GlossarySectionHealth
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RekindGlossaryTermRequest
 */ export class RekindGlossaryTermRequest extends Message {
    static fromBinary(bytes, options) {
        return new RekindGlossaryTermRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RekindGlossaryTermRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RekindGlossaryTermRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RekindGlossaryTermRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string term_id = 4;
   */ _define_property(this, "termId", ""), /**
   * @generated from field: string kind = 5;
   */ _define_property(this, "kind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RekindGlossaryTermRequest, "runtime", proto3);
_define_property(RekindGlossaryTermRequest, "typeName", "mono.datagateway.v1.RekindGlossaryTermRequest");
_define_property(RekindGlossaryTermRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RekindGlossaryTermResponse
 */ export class RekindGlossaryTermResponse extends Message {
    static fromBinary(bytes, options) {
        return new RekindGlossaryTermResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RekindGlossaryTermResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RekindGlossaryTermResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RekindGlossaryTermResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GlossaryTerm term = 1;
   */ _define_property(this, "term", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RekindGlossaryTermResponse, "runtime", proto3);
_define_property(RekindGlossaryTermResponse, "typeName", "mono.datagateway.v1.RekindGlossaryTermResponse");
_define_property(RekindGlossaryTermResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "term",
            kind: "message",
            T: GlossaryTerm
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectGlossaryTermRequest
 */ export class RejectGlossaryTermRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryTermRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryTermRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryTermRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryTermRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string term_id = 4;
   */ _define_property(this, "termId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryTermRequest, "runtime", proto3);
_define_property(RejectGlossaryTermRequest, "typeName", "mono.datagateway.v1.RejectGlossaryTermRequest");
_define_property(RejectGlossaryTermRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectGlossaryTermResponse
 */ export class RejectGlossaryTermResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryTermResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryTermResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryTermResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryTermResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryTermResponse, "runtime", proto3);
_define_property(RejectGlossaryTermResponse, "typeName", "mono.datagateway.v1.RejectGlossaryTermResponse");
_define_property(RejectGlossaryTermResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.RejectGlossaryRelationRequest
 */ export class RejectGlossaryRelationRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryRelationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryRelationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryRelationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryRelationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string relation_id = 4;
   */ _define_property(this, "relationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryRelationRequest, "runtime", proto3);
_define_property(RejectGlossaryRelationRequest, "typeName", "mono.datagateway.v1.RejectGlossaryRelationRequest");
_define_property(RejectGlossaryRelationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "relation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectGlossaryRelationResponse
 */ export class RejectGlossaryRelationResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryRelationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryRelationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryRelationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryRelationResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryRelationResponse, "runtime", proto3);
_define_property(RejectGlossaryRelationResponse, "typeName", "mono.datagateway.v1.RejectGlossaryRelationResponse");
_define_property(RejectGlossaryRelationResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.AddGlossaryRelationRequest
 */ export class AddGlossaryRelationRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddGlossaryRelationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddGlossaryRelationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddGlossaryRelationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddGlossaryRelationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string from_term_id = 4;
   */ _define_property(this, "fromTermId", ""), /**
   * @generated from field: string to_term_id = 5;
   */ _define_property(this, "toTermId", ""), /**
   * @generated from field: string relation = 6;
   */ _define_property(this, "relation", ""), /**
   * reason is the free-text source ("client statement, 2026-03-02"). A link
   * needs a reason, a source document, or both.
   *
   * @generated from field: string reason = 7;
   */ _define_property(this, "reason", ""), /**
   * A team end: the team's glossary term, minted as a reviewer team term
   * when the team has none. Set instead of from_term_id / to_term_id.
   *
   * @generated from field: string from_workstream_id = 8;
   */ _define_property(this, "fromWorkstreamId", ""), /**
   * @generated from field: string to_workstream_id = 9;
   */ _define_property(this, "toWorkstreamId", ""), /**
   * The document page the link was read from.
   *
   * @generated from field: string source_document_id = 10;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: int32 source_page = 11;
   */ _define_property(this, "sourcePage", 0), /**
   * replaces_relation_id edits a link: that link is rejected in the same
   * write, and the new one is the reviewer's.
   *
   * @generated from field: string replaces_relation_id = 12;
   */ _define_property(this, "replacesRelationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddGlossaryRelationRequest, "runtime", proto3);
_define_property(AddGlossaryRelationRequest, "typeName", "mono.datagateway.v1.AddGlossaryRelationRequest");
_define_property(AddGlossaryRelationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "from_term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "to_term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "from_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "to_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "replaces_relation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddGlossaryRelationResponse
 */ export class AddGlossaryRelationResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddGlossaryRelationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddGlossaryRelationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddGlossaryRelationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddGlossaryRelationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GlossaryRelation relation = 1;
   */ _define_property(this, "relation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddGlossaryRelationResponse, "runtime", proto3);
_define_property(AddGlossaryRelationResponse, "typeName", "mono.datagateway.v1.AddGlossaryRelationResponse");
_define_property(AddGlossaryRelationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relation",
            kind: "message",
            T: GlossaryRelation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BindGlossaryTermRequest
 */ export class BindGlossaryTermRequest extends Message {
    static fromBinary(bytes, options) {
        return new BindGlossaryTermRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BindGlossaryTermRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BindGlossaryTermRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BindGlossaryTermRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string term_id = 4;
   */ _define_property(this, "termId", ""), /**
   * @generated from field: string workstream_id = 5;
   */ _define_property(this, "workstreamId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BindGlossaryTermRequest, "runtime", proto3);
_define_property(BindGlossaryTermRequest, "typeName", "mono.datagateway.v1.BindGlossaryTermRequest");
_define_property(BindGlossaryTermRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BindGlossaryTermResponse
 */ export class BindGlossaryTermResponse extends Message {
    static fromBinary(bytes, options) {
        return new BindGlossaryTermResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BindGlossaryTermResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BindGlossaryTermResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BindGlossaryTermResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GlossaryTerm term = 1;
   */ _define_property(this, "term", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BindGlossaryTermResponse, "runtime", proto3);
_define_property(BindGlossaryTermResponse, "typeName", "mono.datagateway.v1.BindGlossaryTermResponse");
_define_property(BindGlossaryTermResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "term",
            kind: "message",
            T: GlossaryTerm
        }
    ]));
/**
 * SowWorkProduct is a SOW's own commitment (origin sow) and its team rules.
 *
 * @generated from message mono.datagateway.v1.SowWorkProduct
 */ export class SowWorkProduct extends Message {
    static fromBinary(bytes, options) {
        return new SowWorkProduct().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SowWorkProduct().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SowWorkProduct().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SowWorkProduct, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateDutyRequest duty = 1;
   */ _define_property(this, "duty", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.TeamRule team_rules = 2;
   */ _define_property(this, "teamRules", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SowWorkProduct, "runtime", proto3);
_define_property(SowWorkProduct, "typeName", "mono.datagateway.v1.SowWorkProduct");
_define_property(SowWorkProduct, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty",
            kind: "message",
            T: CreateDutyRequest
        },
        {
            no: 2,
            name: "team_rules",
            kind: "message",
            T: TeamRule,
            repeated: true
        }
    ]));
/**
 * IntakeSowRequest is a SOW/EP reading as writes. sow, assignments and
 * work products carry no program_id or sow_id: the request's program and
 * the SOW this call creates fill them.
 *
 * @generated from message mono.datagateway.v1.IntakeSowRequest
 */ export class IntakeSowRequest extends Message {
    static fromBinary(bytes, options) {
        return new IntakeSowRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntakeSowRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntakeSowRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntakeSowRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: mono.datagateway.v1.CreateSowRequest sow = 3;
   */ _define_property(this, "sow", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.SetDutyAssignmentRequest assignments = 4;
   */ _define_property(this, "assignments", []), /**
   * @generated from field: repeated mono.datagateway.v1.SowWorkProduct work_products = 5;
   */ _define_property(this, "workProducts", []), /**
   * Unsettled facts. target_locator is filled with the new SOW's id for a
   * DutyAssignment target.
   *
   * @generated from field: repeated mono.common.v1.ReviewItem review_items = 6;
   */ _define_property(this, "reviewItems", []), /**
   * scope (SAD-969): the PWS sections the document says it covers, read
   * from its task-area units. An award deliverable it never mentions whose
   * PWS section is outside them is pre-filled "not applicable".
   *
   * @generated from field: mono.datagateway.v1.SowScope scope = 7;
   */ _define_property(this, "scope", void 0), /**
   * closed_list (SAD-973): the document's statement that it requires no
   * deliverable beyond those it lists. An award deliverable of the team's
   * tasks it never mentions is pre-filled "not owed", citing it.
   *
   * @generated from field: mono.datagateway.v1.SowClosedList closed_list = 8;
   */ _define_property(this, "closedList", void 0), /**
   * group_routes (R10-A): the document's statements that every deliverable
   * of one of its CLINs is provided under another effort. Each routes every
   * award deliverable the team owes under that CLIN's task, the ones it
   * inherits by a PWS clause included, that the reading does not settle.
   *
   * @generated from field: repeated mono.datagateway.v1.SowGroupRoute group_routes = 9;
   */ _define_property(this, "groupRoutes", []), /**
   * peer_assignments (R17-B) are cells of the program's other SOWs that this
   * SOW's deliverable dossiers settled: each names its own sow_id and is
   * written unless a person decided that cell.
   *
   * @generated from field: repeated mono.datagateway.v1.SetDutyAssignmentRequest peer_assignments = 10;
   */ _define_property(this, "peerAssignments", []), /**
   * dossier_json (R17-B) is this SOW's rows (what it says about each
   * deliverable it could owe), kept with the SOW so a later SOW's dossiers
   * read it beside its own.
   *
   * @generated from field: string dossier_json = 11;
   */ _define_property(this, "dossierJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntakeSowRequest, "runtime", proto3);
_define_property(IntakeSowRequest, "typeName", "mono.datagateway.v1.IntakeSowRequest");
_define_property(IntakeSowRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "sow",
            kind: "message",
            T: CreateSowRequest
        },
        {
            no: 4,
            name: "assignments",
            kind: "message",
            T: SetDutyAssignmentRequest,
            repeated: true
        },
        {
            no: 5,
            name: "work_products",
            kind: "message",
            T: SowWorkProduct,
            repeated: true
        },
        {
            no: 6,
            name: "review_items",
            kind: "message",
            T: ReviewItem,
            repeated: true
        },
        {
            no: 7,
            name: "scope",
            kind: "message",
            T: SowScope
        },
        {
            no: 8,
            name: "closed_list",
            kind: "message",
            T: SowClosedList
        },
        {
            no: 9,
            name: "group_routes",
            kind: "message",
            T: SowGroupRoute,
            repeated: true
        },
        {
            no: 10,
            name: "peer_assignments",
            kind: "message",
            T: SetDutyAssignmentRequest,
            repeated: true
        },
        {
            no: 11,
            name: "dossier_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SowGroupRoute is one CLIN's deliverables handed to another team.
 *
 * @generated from message mono.datagateway.v1.SowGroupRoute
 */ export class SowGroupRoute extends Message {
    static fromBinary(bytes, options) {
        return new SowGroupRoute().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SowGroupRoute().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SowGroupRoute().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SowGroupRoute, a, b);
    }
    constructor(data){
        super(), /**
   * clin is the CLIN family the statement's heading names ("22001").
   *
   * @generated from field: string clin = 1;
   */ _define_property(this, "clin", ""), /**
   * @generated from field: string routed_to_workstream_id = 2;
   */ _define_property(this, "routedToWorkstreamId", ""), /**
   * @generated from field: int32 page = 3;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string quote = 4;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SowGroupRoute, "runtime", proto3);
_define_property(SowGroupRoute, "typeName", "mono.datagateway.v1.SowGroupRoute");
_define_property(SowGroupRoute, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "routed_to_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SowClosedList is where a SOW says its deliverables are only those it lists.
 *
 * @generated from message mono.datagateway.v1.SowClosedList
 */ export class SowClosedList extends Message {
    static fromBinary(bytes, options) {
        return new SowClosedList().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SowClosedList().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SowClosedList().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SowClosedList, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 page = 1;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string quote = 2;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SowClosedList, "runtime", proto3);
_define_property(SowClosedList, "typeName", "mono.datagateway.v1.SowClosedList");
_define_property(SowClosedList, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SowScope is a SOW's stated scope list and where it was read.
 *
 * @generated from message mono.datagateway.v1.SowScope
 */ export class SowScope extends Message {
    static fromBinary(bytes, options) {
        return new SowScope().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SowScope().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SowScope().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SowScope, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string pws_refs = 1;
   */ _define_property(this, "pwsRefs", []), /**
   * @generated from field: int32 page = 2;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string quote = 3;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SowScope, "runtime", proto3);
_define_property(SowScope, "typeName", "mono.datagateway.v1.SowScope");
_define_property(SowScope, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pws_refs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.IntakeSowResponse
 */ export class IntakeSowResponse extends Message {
    static fromBinary(bytes, options) {
        return new IntakeSowResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntakeSowResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntakeSowResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntakeSowResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractSow sow = 1;
   */ _define_property(this, "sow", void 0), /**
   * @generated from field: int32 assignments = 2;
   */ _define_property(this, "assignments", 0), /**
   * @generated from field: int32 work_products = 3;
   */ _define_property(this, "workProducts", 0), /**
   * The ContractIntake set the review items were staged on ("" when none).
   *
   * @generated from field: string change_set_id = 4;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: int32 review_items = 5;
   */ _define_property(this, "reviewItems", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntakeSowResponse, "runtime", proto3);
_define_property(IntakeSowResponse, "typeName", "mono.datagateway.v1.IntakeSowResponse");
_define_property(IntakeSowResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sow",
            kind: "message",
            T: ContractSow
        },
        {
            no: 2,
            name: "assignments",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "work_products",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "review_items",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WorkstreamMember
 */ export class WorkstreamMember extends Message {
    static fromBinary(bytes, options) {
        return new WorkstreamMember().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkstreamMember().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkstreamMember().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkstreamMember, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string workstream_id = 2;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string contact_id = 4;
   */ _define_property(this, "contactId", ""), /**
   * role: lead | member.
   *
   * @generated from field: string role = 5;
   */ _define_property(this, "role", ""), /**
   * effective_user_id is user_id, else the contact's platform user ("" when
   * neither signs in): the identity membership is checked against.
   *
   * @generated from field: string effective_user_id = 6;
   */ _define_property(this, "effectiveUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkstreamMember, "runtime", proto3);
_define_property(WorkstreamMember, "typeName", "mono.datagateway.v1.WorkstreamMember");
_define_property(WorkstreamMember, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "effective_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkstreamMembersRequest
 */ export class ListWorkstreamMembersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamMembersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamMembersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamMembersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamMembersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * workstream_id "" lists every team's members.
   *
   * @generated from field: string workstream_id = 2;
   */ _define_property(this, "workstreamId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamMembersRequest, "runtime", proto3);
_define_property(ListWorkstreamMembersRequest, "typeName", "mono.datagateway.v1.ListWorkstreamMembersRequest");
_define_property(ListWorkstreamMembersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkstreamMembersResponse
 */ export class ListWorkstreamMembersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamMembersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamMembersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamMembersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamMembersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.WorkstreamMember members = 1;
   */ _define_property(this, "members", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamMembersResponse, "runtime", proto3);
_define_property(ListWorkstreamMembersResponse, "typeName", "mono.datagateway.v1.ListWorkstreamMembersResponse");
_define_property(ListWorkstreamMembersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "members",
            kind: "message",
            T: WorkstreamMember,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddWorkstreamMemberRequest
 */ export class AddWorkstreamMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddWorkstreamMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddWorkstreamMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddWorkstreamMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddWorkstreamMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string workstream_id = 3;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string contact_id = 5;
   */ _define_property(this, "contactId", ""), /**
   * role: lead | member; "" = member.
   *
   * @generated from field: string role = 6;
   */ _define_property(this, "role", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddWorkstreamMemberRequest, "runtime", proto3);
_define_property(AddWorkstreamMemberRequest, "typeName", "mono.datagateway.v1.AddWorkstreamMemberRequest");
_define_property(AddWorkstreamMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddWorkstreamMemberResponse
 */ export class AddWorkstreamMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddWorkstreamMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddWorkstreamMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddWorkstreamMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddWorkstreamMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WorkstreamMember member = 1;
   */ _define_property(this, "member", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddWorkstreamMemberResponse, "runtime", proto3);
_define_property(AddWorkstreamMemberResponse, "typeName", "mono.datagateway.v1.AddWorkstreamMemberResponse");
_define_property(AddWorkstreamMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "member",
            kind: "message",
            T: WorkstreamMember
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateWorkstreamMemberRequest
 */ export class UpdateWorkstreamMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkstreamMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkstreamMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkstreamMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkstreamMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string member_id = 3;
   */ _define_property(this, "memberId", ""), /**
   * @generated from field: string role = 4;
   */ _define_property(this, "role", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkstreamMemberRequest, "runtime", proto3);
_define_property(UpdateWorkstreamMemberRequest, "typeName", "mono.datagateway.v1.UpdateWorkstreamMemberRequest");
_define_property(UpdateWorkstreamMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "member_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateWorkstreamMemberResponse
 */ export class UpdateWorkstreamMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkstreamMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkstreamMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkstreamMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkstreamMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WorkstreamMember member = 1;
   */ _define_property(this, "member", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkstreamMemberResponse, "runtime", proto3);
_define_property(UpdateWorkstreamMemberResponse, "typeName", "mono.datagateway.v1.UpdateWorkstreamMemberResponse");
_define_property(UpdateWorkstreamMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "member",
            kind: "message",
            T: WorkstreamMember
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RemoveWorkstreamMemberRequest
 */ export class RemoveWorkstreamMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveWorkstreamMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveWorkstreamMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveWorkstreamMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveWorkstreamMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string member_id = 3;
   */ _define_property(this, "memberId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveWorkstreamMemberRequest, "runtime", proto3);
_define_property(RemoveWorkstreamMemberRequest, "typeName", "mono.datagateway.v1.RemoveWorkstreamMemberRequest");
_define_property(RemoveWorkstreamMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "member_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RemoveWorkstreamMemberResponse
 */ export class RemoveWorkstreamMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveWorkstreamMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveWorkstreamMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveWorkstreamMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveWorkstreamMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveWorkstreamMemberResponse, "runtime", proto3);
_define_property(RemoveWorkstreamMemberResponse, "typeName", "mono.datagateway.v1.RemoveWorkstreamMemberResponse");
_define_property(RemoveWorkstreamMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WorkProductAttachment
 */ export class WorkProductAttachment extends Message {
    static fromBinary(bytes, options) {
        return new WorkProductAttachment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkProductAttachment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkProductAttachment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkProductAttachment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string url = 3;
   */ _define_property(this, "url", ""), /**
   * @generated from field: string label = 4;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkProductAttachment, "runtime", proto3);
_define_property(WorkProductAttachment, "typeName", "mono.datagateway.v1.WorkProductAttachment");
_define_property(WorkProductAttachment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WorkProductAttachmentInput
 */ export class WorkProductAttachmentInput extends Message {
    static fromBinary(bytes, options) {
        return new WorkProductAttachmentInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkProductAttachmentInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkProductAttachmentInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkProductAttachmentInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string url = 2;
   */ _define_property(this, "url", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkProductAttachmentInput, "runtime", proto3);
_define_property(WorkProductAttachmentInput, "typeName", "mono.datagateway.v1.WorkProductAttachmentInput");
_define_property(WorkProductAttachmentInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * WorkProductFields is a work product's writable content (its team is fixed
 * at create).
 *
 * @generated from message mono.datagateway.v1.WorkProductFields
 */ export class WorkProductFields extends Message {
    static fromBinary(bytes, options) {
        return new WorkProductFields().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkProductFields().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkProductFields().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkProductFields, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", ""), /**
   * produced_on is the day it was produced, YYYY-MM-DD; required.
   *
   * @generated from field: string produced_on = 3;
   */ _define_property(this, "producedOn", ""), /**
   * pws_ref is the PWS / Schedule B section it falls under; "" = none named.
   *
   * @generated from field: string pws_ref = 4;
   */ _define_property(this, "pwsRef", ""), /**
   * not_in_scope_docs is the stated claim that no PWS, Schedule B or SOW
   * asks for it; refused beside a pws_ref.
   *
   * @generated from field: bool not_in_scope_docs = 5;
   */ _define_property(this, "notInScopeDocs", false), /**
   * hours and value_cents: unset = not stated.
   *
   * @generated from field: optional double hours = 6;
   */ _define_property(this, "hours", void 0), /**
   * @generated from field: optional int64 value_cents = 7;
   */ _define_property(this, "valueCents", void 0), /**
   * authority_basis is who asked; required.
   *
   * @generated from field: mono.common.v1.ExecutionAuthorityBasis authority_basis = 8;
   */ _define_property(this, "authorityBasis", ExecutionAuthorityBasis.UNSPECIFIED), /**
   * item_kind UNSPECIFIED = WORK_PRODUCT.
   *
   * @generated from field: mono.common.v1.ExecutionWorkItemKind item_kind = 9;
   */ _define_property(this, "itemKind", ExecutionWorkItemKind.UNSPECIFIED);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkProductFields, "runtime", proto3);
_define_property(WorkProductFields, "typeName", "mono.datagateway.v1.WorkProductFields");
_define_property(WorkProductFields, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "produced_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pws_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "not_in_scope_docs",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "hours",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 7,
            name: "value_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        },
        {
            no: 8,
            name: "authority_basis",
            kind: "enum",
            T: proto3.getEnumType(ExecutionAuthorityBasis)
        },
        {
            no: 9,
            name: "item_kind",
            kind: "enum",
            T: proto3.getEnumType(ExecutionWorkItemKind)
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WorkProduct
 */ export class WorkProduct extends Message {
    static fromBinary(bytes, options) {
        return new WorkProduct().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkProduct().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkProduct().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkProduct, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string workstream_id = 3;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: mono.common.v1.ExecutionWorkItemKind item_kind = 4;
   */ _define_property(this, "itemKind", ExecutionWorkItemKind.UNSPECIFIED), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string produced_on = 7;
   */ _define_property(this, "producedOn", ""), /**
   * @generated from field: string pws_ref = 8;
   */ _define_property(this, "pwsRef", ""), /**
   * @generated from field: bool not_in_scope_docs = 9;
   */ _define_property(this, "notInScopeDocs", false), /**
   * @generated from field: optional double hours = 10;
   */ _define_property(this, "hours", void 0), /**
   * @generated from field: optional int64 value_cents = 11;
   */ _define_property(this, "valueCents", void 0), /**
   * @generated from field: mono.common.v1.ExecutionAuthorityBasis authority_basis = 12;
   */ _define_property(this, "authorityBasis", ExecutionAuthorityBasis.UNSPECIFIED), /**
   * @generated from field: mono.common.v1.ExecutionScopeAssessment scope_assessment = 13;
   */ _define_property(this, "scopeAssessment", ExecutionScopeAssessment.UNSPECIFIED), /**
   * @generated from field: mono.common.v1.ExecutionCommercialTreatment commercial_treatment = 14;
   */ _define_property(this, "commercialTreatment", ExecutionCommercialTreatment.UNSPECIFIED), /**
   * @generated from field: string promoted_to_duty_id = 15;
   */ _define_property(this, "promotedToDutyId", ""), /**
   * @generated from field: string logged_by_user_id = 16;
   */ _define_property(this, "loggedByUserId", ""), /**
   * created_at / updated_at are RFC 3339.
   *
   * @generated from field: string created_at = 17;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string updated_at = 18;
   */ _define_property(this, "updatedAt", ""), /**
   * @generated from field: repeated mono.datagateway.v1.WorkProductAttachment attachments = 19;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkProduct, "runtime", proto3);
_define_property(WorkProduct, "typeName", "mono.datagateway.v1.WorkProduct");
_define_property(WorkProduct, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "item_kind",
            kind: "enum",
            T: proto3.getEnumType(ExecutionWorkItemKind)
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "produced_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "pws_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "not_in_scope_docs",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "hours",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 11,
            name: "value_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        },
        {
            no: 12,
            name: "authority_basis",
            kind: "enum",
            T: proto3.getEnumType(ExecutionAuthorityBasis)
        },
        {
            no: 13,
            name: "scope_assessment",
            kind: "enum",
            T: proto3.getEnumType(ExecutionScopeAssessment)
        },
        {
            no: 14,
            name: "commercial_treatment",
            kind: "enum",
            T: proto3.getEnumType(ExecutionCommercialTreatment)
        },
        {
            no: 15,
            name: "promoted_to_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "logged_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "attachments",
            kind: "message",
            T: WorkProductAttachment,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateWorkProductRequest
 */ export class CreateWorkProductRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateWorkProductRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateWorkProductRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateWorkProductRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateWorkProductRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string workstream_id = 3;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: mono.datagateway.v1.WorkProductFields fields = 4;
   */ _define_property(this, "fields", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.WorkProductAttachmentInput attachments = 5;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateWorkProductRequest, "runtime", proto3);
_define_property(CreateWorkProductRequest, "typeName", "mono.datagateway.v1.CreateWorkProductRequest");
_define_property(CreateWorkProductRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "fields",
            kind: "message",
            T: WorkProductFields
        },
        {
            no: 5,
            name: "attachments",
            kind: "message",
            T: WorkProductAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateWorkProductResponse
 */ export class CreateWorkProductResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateWorkProductResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateWorkProductResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateWorkProductResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateWorkProductResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WorkProduct work_product = 1;
   */ _define_property(this, "workProduct", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateWorkProductResponse, "runtime", proto3);
_define_property(CreateWorkProductResponse, "typeName", "mono.datagateway.v1.CreateWorkProductResponse");
_define_property(CreateWorkProductResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "work_product",
            kind: "message",
            T: WorkProduct
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * UpdateWorkProductRequest replaces the writable content; attachments are
 * replaced only when replace_attachments is set.
 *
 * @generated from message mono.datagateway.v1.UpdateWorkProductRequest
 */ export class UpdateWorkProductRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkProductRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkProductRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkProductRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkProductRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string work_product_id = 3;
   */ _define_property(this, "workProductId", ""), /**
   * @generated from field: mono.datagateway.v1.WorkProductFields fields = 4;
   */ _define_property(this, "fields", void 0), /**
   * @generated from field: bool replace_attachments = 5;
   */ _define_property(this, "replaceAttachments", false), /**
   * @generated from field: repeated mono.datagateway.v1.WorkProductAttachmentInput attachments = 6;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkProductRequest, "runtime", proto3);
_define_property(UpdateWorkProductRequest, "typeName", "mono.datagateway.v1.UpdateWorkProductRequest");
_define_property(UpdateWorkProductRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "work_product_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "fields",
            kind: "message",
            T: WorkProductFields
        },
        {
            no: 5,
            name: "replace_attachments",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "attachments",
            kind: "message",
            T: WorkProductAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateWorkProductResponse
 */ export class UpdateWorkProductResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkProductResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkProductResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkProductResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkProductResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WorkProduct work_product = 1;
   */ _define_property(this, "workProduct", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkProductResponse, "runtime", proto3);
_define_property(UpdateWorkProductResponse, "typeName", "mono.datagateway.v1.UpdateWorkProductResponse");
_define_property(UpdateWorkProductResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "work_product",
            kind: "message",
            T: WorkProduct
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetWorkProductRequest
 */ export class GetWorkProductRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkProductRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkProductRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkProductRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkProductRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string work_product_id = 2;
   */ _define_property(this, "workProductId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkProductRequest, "runtime", proto3);
_define_property(GetWorkProductRequest, "typeName", "mono.datagateway.v1.GetWorkProductRequest");
_define_property(GetWorkProductRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "work_product_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetWorkProductResponse
 */ export class GetWorkProductResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkProductResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkProductResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkProductResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkProductResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WorkProduct work_product = 1;
   */ _define_property(this, "workProduct", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkProductResponse, "runtime", proto3);
_define_property(GetWorkProductResponse, "typeName", "mono.datagateway.v1.GetWorkProductResponse");
_define_property(GetWorkProductResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "work_product",
            kind: "message",
            T: WorkProduct
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkProductsRequest
 */ export class ListWorkProductsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkProductsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkProductsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkProductsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkProductsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * workstream_id "" = every team.
   *
   * @generated from field: string workstream_id = 2;
   */ _define_property(this, "workstreamId", ""), /**
   * promoted_to_duty_id: only the work products promoted to this duty (its
   * history); "" = no filter.
   *
   * @generated from field: string promoted_to_duty_id = 3;
   */ _define_property(this, "promotedToDutyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkProductsRequest, "runtime", proto3);
_define_property(ListWorkProductsRequest, "typeName", "mono.datagateway.v1.ListWorkProductsRequest");
_define_property(ListWorkProductsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "promoted_to_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkProductsResponse
 */ export class ListWorkProductsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkProductsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkProductsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkProductsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkProductsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.WorkProduct work_products = 1;
   */ _define_property(this, "workProducts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkProductsResponse, "runtime", proto3);
_define_property(ListWorkProductsResponse, "typeName", "mono.datagateway.v1.ListWorkProductsResponse");
_define_property(ListWorkProductsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "work_products",
            kind: "message",
            T: WorkProduct,
            repeated: true
        }
    ]));
/**
 * AssessWorkProductsRequest sets one scope assessment on many work products.
 * commercial_treatment UNSPECIFIED derives it: POTENTIAL_CHANGE when out of
 * scope, else NON_BILLABLE.
 *
 * @generated from message mono.datagateway.v1.AssessWorkProductsRequest
 */ export class AssessWorkProductsRequest extends Message {
    static fromBinary(bytes, options) {
        return new AssessWorkProductsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssessWorkProductsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssessWorkProductsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssessWorkProductsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: repeated string work_product_ids = 3;
   */ _define_property(this, "workProductIds", []), /**
   * @generated from field: mono.common.v1.ExecutionScopeAssessment scope_assessment = 4;
   */ _define_property(this, "scopeAssessment", ExecutionScopeAssessment.UNSPECIFIED), /**
   * @generated from field: mono.common.v1.ExecutionCommercialTreatment commercial_treatment = 5;
   */ _define_property(this, "commercialTreatment", ExecutionCommercialTreatment.UNSPECIFIED);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssessWorkProductsRequest, "runtime", proto3);
_define_property(AssessWorkProductsRequest, "typeName", "mono.datagateway.v1.AssessWorkProductsRequest");
_define_property(AssessWorkProductsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "work_product_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "scope_assessment",
            kind: "enum",
            T: proto3.getEnumType(ExecutionScopeAssessment)
        },
        {
            no: 5,
            name: "commercial_treatment",
            kind: "enum",
            T: proto3.getEnumType(ExecutionCommercialTreatment)
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AssessWorkProductsResponse
 */ export class AssessWorkProductsResponse extends Message {
    static fromBinary(bytes, options) {
        return new AssessWorkProductsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssessWorkProductsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssessWorkProductsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssessWorkProductsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.WorkProduct work_products = 1;
   */ _define_property(this, "workProducts", []), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssessWorkProductsResponse, "runtime", proto3);
_define_property(AssessWorkProductsResponse, "typeName", "mono.datagateway.v1.AssessWorkProductsResponse");
_define_property(AssessWorkProductsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "work_products",
            kind: "message",
            T: WorkProduct,
            repeated: true
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PromoteWorkProductRequest
 */ export class PromoteWorkProductRequest extends Message {
    static fromBinary(bytes, options) {
        return new PromoteWorkProductRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromoteWorkProductRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromoteWorkProductRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromoteWorkProductRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string work_product_id = 3;
   */ _define_property(this, "workProductId", ""), /**
   * title "" = the work product's title.
   *
   * @generated from field: string title = 4;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PromoteWorkProductRequest, "runtime", proto3);
_define_property(PromoteWorkProductRequest, "typeName", "mono.datagateway.v1.PromoteWorkProductRequest");
_define_property(PromoteWorkProductRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "work_product_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PromoteWorkProductResponse
 */ export class PromoteWorkProductResponse extends Message {
    static fromBinary(bytes, options) {
        return new PromoteWorkProductResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromoteWorkProductResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromoteWorkProductResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromoteWorkProductResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WorkProduct work_product = 1;
   */ _define_property(this, "workProduct", void 0), /**
   * @generated from field: mono.datagateway.v1.ContractDuty duty = 2;
   */ _define_property(this, "duty", void 0), /**
   * sow_id is the SOW the duty is performed under ("" when the team has none).
   *
   * @generated from field: string sow_id = 3;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 4;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PromoteWorkProductResponse, "runtime", proto3);
_define_property(PromoteWorkProductResponse, "typeName", "mono.datagateway.v1.PromoteWorkProductResponse");
_define_property(PromoteWorkProductResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "work_product",
            kind: "message",
            T: WorkProduct
        },
        {
            no: 2,
            name: "duty",
            kind: "message",
            T: ContractDuty
        },
        {
            no: 3,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.FindWorkProductDuplicatesRequest
 */ export class FindWorkProductDuplicatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new FindWorkProductDuplicatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindWorkProductDuplicatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindWorkProductDuplicatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindWorkProductDuplicatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string workstream_id = 2;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindWorkProductDuplicatesRequest, "runtime", proto3);
_define_property(FindWorkProductDuplicatesRequest, "typeName", "mono.datagateway.v1.FindWorkProductDuplicatesRequest");
_define_property(FindWorkProductDuplicatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WorkProductDuplicate
 */ export class WorkProductDuplicate extends Message {
    static fromBinary(bytes, options) {
        return new WorkProductDuplicate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkProductDuplicate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkProductDuplicate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkProductDuplicate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string duty_id = 1;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string pws_ref = 3;
   */ _define_property(this, "pwsRef", ""), /**
   * score is the title similarity, 0..1.
   *
   * @generated from field: double score = 4;
   */ _define_property(this, "score", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkProductDuplicate, "runtime", proto3);
_define_property(WorkProductDuplicate, "typeName", "mono.datagateway.v1.WorkProductDuplicate");
_define_property(WorkProductDuplicate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pws_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.FindWorkProductDuplicatesResponse
 */ export class FindWorkProductDuplicatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new FindWorkProductDuplicatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindWorkProductDuplicatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindWorkProductDuplicatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindWorkProductDuplicatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.WorkProductDuplicate matches = 1;
   */ _define_property(this, "matches", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindWorkProductDuplicatesResponse, "runtime", proto3);
_define_property(FindWorkProductDuplicatesResponse, "typeName", "mono.datagateway.v1.FindWorkProductDuplicatesResponse");
_define_property(FindWorkProductDuplicatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "matches",
            kind: "message",
            T: WorkProductDuplicate,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.Comment
 */ export class Comment extends Message {
    static fromBinary(bytes, options) {
        return new Comment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Comment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Comment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Comment, a, b);
    }
    constructor(data){
        super(), /**
   * id is "imported:<kind>:<row id>" for an imported note.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string target_type = 2;
   */ _define_property(this, "targetType", ""), /**
   * @generated from field: string target_id = 3;
   */ _define_property(this, "targetId", ""), /**
   * parent_id is "" on a top-level comment.
   *
   * @generated from field: string parent_id = 4;
   */ _define_property(this, "parentId", ""), /**
   * author_user_id is "" when an imported note has no known author.
   *
   * @generated from field: string author_user_id = 5;
   */ _define_property(this, "authorUserId", ""), /**
   * @generated from field: string author_name = 6;
   */ _define_property(this, "authorName", ""), /**
   * body is "" on a deleted comment, which is listed only while it has replies.
   *
   * @generated from field: string body = 7;
   */ _define_property(this, "body", ""), /**
   * created_at / edited_at are RFC 3339; edited_at is "" until an edit.
   *
   * @generated from field: string created_at = 8;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string edited_at = 9;
   */ _define_property(this, "editedAt", ""), /**
   * @generated from field: bool deleted = 10;
   */ _define_property(this, "deleted", false), /**
   * @generated from field: int32 upvote_count = 11;
   */ _define_property(this, "upvoteCount", 0), /**
   * @generated from field: bool upvoted_by_me = 12;
   */ _define_property(this, "upvotedByMe", false), /**
   * imported is an old free-text note shown as a comment: it cannot be
   * replied to, upvoted, edited or deleted here.
   *
   * @generated from field: bool imported = 13;
   */ _define_property(this, "imported", false), /**
   * via_assist is true when the comment was posted from a Specra Assist
   * Accept card (X-Specra-Via: assist). The author is still the human.
   *
   * @generated from field: bool via_assist = 14;
   */ _define_property(this, "viaAssist", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Comment, "runtime", proto3);
_define_property(Comment, "typeName", "mono.datagateway.v1.Comment");
_define_property(Comment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "author_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "author_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "edited_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "upvote_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "upvoted_by_me",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "imported",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "via_assist",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCommentsRequest
 */ export class ListCommentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCommentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCommentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCommentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCommentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string target_type = 2;
   */ _define_property(this, "targetType", ""), /**
   * @generated from field: string target_id = 3;
   */ _define_property(this, "targetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCommentsRequest, "runtime", proto3);
_define_property(ListCommentsRequest, "typeName", "mono.datagateway.v1.ListCommentsRequest");
_define_property(ListCommentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ListCommentsResponse lists imported notes first, then every comment and
 * reply oldest first; a reply follows nothing in particular, its parent_id
 * places it.
 *
 * @generated from message mono.datagateway.v1.ListCommentsResponse
 */ export class ListCommentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCommentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCommentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCommentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCommentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Comment comments = 1;
   */ _define_property(this, "comments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCommentsResponse, "runtime", proto3);
_define_property(ListCommentsResponse, "typeName", "mono.datagateway.v1.ListCommentsResponse");
_define_property(ListCommentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "comments",
            kind: "message",
            T: Comment,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCommentRequest
 */ export class CreateCommentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCommentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCommentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCommentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCommentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string target_type = 2;
   */ _define_property(this, "targetType", ""), /**
   * @generated from field: string target_id = 3;
   */ _define_property(this, "targetId", ""), /**
   * @generated from field: string parent_id = 4;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: string body = 5;
   */ _define_property(this, "body", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCommentRequest, "runtime", proto3);
_define_property(CreateCommentRequest, "typeName", "mono.datagateway.v1.CreateCommentRequest");
_define_property(CreateCommentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCommentResponse
 */ export class CreateCommentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCommentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCommentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCommentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCommentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Comment comment = 1;
   */ _define_property(this, "comment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCommentResponse, "runtime", proto3);
_define_property(CreateCommentResponse, "typeName", "mono.datagateway.v1.CreateCommentResponse");
_define_property(CreateCommentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "comment",
            kind: "message",
            T: Comment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCommentRequest
 */ export class UpdateCommentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCommentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCommentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCommentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCommentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string comment_id = 2;
   */ _define_property(this, "commentId", ""), /**
   * @generated from field: string body = 3;
   */ _define_property(this, "body", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCommentRequest, "runtime", proto3);
_define_property(UpdateCommentRequest, "typeName", "mono.datagateway.v1.UpdateCommentRequest");
_define_property(UpdateCommentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "comment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCommentResponse
 */ export class UpdateCommentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCommentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCommentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCommentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCommentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Comment comment = 1;
   */ _define_property(this, "comment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCommentResponse, "runtime", proto3);
_define_property(UpdateCommentResponse, "typeName", "mono.datagateway.v1.UpdateCommentResponse");
_define_property(UpdateCommentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "comment",
            kind: "message",
            T: Comment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCommentRequest
 */ export class DeleteCommentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCommentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCommentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCommentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCommentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string comment_id = 2;
   */ _define_property(this, "commentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCommentRequest, "runtime", proto3);
_define_property(DeleteCommentRequest, "typeName", "mono.datagateway.v1.DeleteCommentRequest");
_define_property(DeleteCommentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "comment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCommentResponse
 */ export class DeleteCommentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCommentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCommentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCommentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCommentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCommentResponse, "runtime", proto3);
_define_property(DeleteCommentResponse, "typeName", "mono.datagateway.v1.DeleteCommentResponse");
_define_property(DeleteCommentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.SetCommentUpvoteRequest
 */ export class SetCommentUpvoteRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetCommentUpvoteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCommentUpvoteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCommentUpvoteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCommentUpvoteRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string comment_id = 2;
   */ _define_property(this, "commentId", ""), /**
   * @generated from field: bool upvoted = 3;
   */ _define_property(this, "upvoted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCommentUpvoteRequest, "runtime", proto3);
_define_property(SetCommentUpvoteRequest, "typeName", "mono.datagateway.v1.SetCommentUpvoteRequest");
_define_property(SetCommentUpvoteRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "comment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "upvoted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetCommentUpvoteResponse
 */ export class SetCommentUpvoteResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetCommentUpvoteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCommentUpvoteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCommentUpvoteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCommentUpvoteResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Comment comment = 1;
   */ _define_property(this, "comment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCommentUpvoteResponse, "runtime", proto3);
_define_property(SetCommentUpvoteResponse, "typeName", "mono.datagateway.v1.SetCommentUpvoteResponse");
_define_property(SetCommentUpvoteResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "comment",
            kind: "message",
            T: Comment
        }
    ]));
/**
 * Deprecated: ImportTracker's messages as main carried them, kept in proto
 * only. Use ApplyEvidenceBatchRequest / ApplyEvidenceBatchResponse.
 *
 * @generated from message mono.datagateway.v1.ImportTrackerRequest
 * @deprecated
 */ export class ImportTrackerRequest extends Message {
    static fromBinary(bytes, options) {
        return new ImportTrackerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportTrackerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportTrackerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportTrackerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * artifact_id: the evidence file, kept on the run (optional).
   *
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: bool dry_run = 5;
   */ _define_property(this, "dryRun", false), /**
   * Staging: the matched records, and the source's name for the run.
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceFiling filings = 6;
   */ _define_property(this, "filings", []), /**
   * @generated from field: string source_name = 7;
   */ _define_property(this, "sourceName", ""), /**
   * Applying: the staged run. With dry_run: the run to read.
   *
   * @generated from field: string run_id = 8;
   */ _define_property(this, "runId", ""), /**
   * include_reviews: also record the records' verdicts. Recording a verdict is
   * area:execution.verdict, as for RecordReview; ryugu refuses it without.
   *
   * @generated from field: bool include_reviews = 9;
   */ _define_property(this, "includeReviews", false), /**
   * Staging a gap run: its gaps (with dry_run, never with filings).
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceGap gaps = 10;
   */ _define_property(this, "gaps", []), /**
   * Applying a gap run: close_gaps is required (ryugu gates it on creating
   * deliverables), skip_gaps the gap ids the user unticked, gap_causes the
   * cause tags the user changed, by gap id.
   *
   * @generated from field: bool close_gaps = 11;
   */ _define_property(this, "closeGaps", false), /**
   * @generated from field: repeated string skip_gaps = 12;
   */ _define_property(this, "skipGaps", []), /**
   * @generated from field: map<string, string> gap_causes = 13;
   */ _define_property(this, "gapCauses", {}), /**
   * Applying a filing run: leave the adjusted dates out (no move, no
   * extension), as the user unticked them.
   *
   * @generated from field: bool skip_adjusted = 14;
   */ _define_property(this, "skipAdjusted", false), /**
   * Staging a filing run: the records of deliverables that hold no date for
   * their team, which date the event such a deliverable is due after
   * (EvidenceEventRecord). A run may stage these alone.
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceEventRecord event_records = 15;
   */ _define_property(this, "eventRecords", []), /**
   * Staging a filing run from a complete source: where it speaks for each
   * team and deliverable, and its last due date. The run's as-of day (its
   * latest submission or verdict) ends the coverage when earlier.
   *
   * @generated from field: repeated mono.datagateway.v1.EvidenceCoverage coverage = 16;
   */ _define_property(this, "coverage", []), /**
   * @generated from field: string covered_through = 17;
   */ _define_property(this, "coveredThrough", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportTrackerRequest, "runtime", proto3);
_define_property(ImportTrackerRequest, "typeName", "mono.datagateway.v1.ImportTrackerRequest");
_define_property(ImportTrackerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "filings",
            kind: "message",
            T: EvidenceFiling,
            repeated: true
        },
        {
            no: 7,
            name: "source_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "include_reviews",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "gaps",
            kind: "message",
            T: EvidenceGap,
            repeated: true
        },
        {
            no: 11,
            name: "close_gaps",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "skip_gaps",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "gap_causes",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        },
        {
            no: 14,
            name: "skip_adjusted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "event_records",
            kind: "message",
            T: EvidenceEventRecord,
            repeated: true
        },
        {
            no: 16,
            name: "coverage",
            kind: "message",
            T: EvidenceCoverage,
            repeated: true
        },
        {
            no: 17,
            name: "covered_through",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ImportTrackerResponse
 * @deprecated
 */ export class ImportTrackerResponse extends Message {
    static fromBinary(bytes, options) {
        return new ImportTrackerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportTrackerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportTrackerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportTrackerResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string run_id = 1;
   */ _define_property(this, "runId", ""), /**
   * @generated from field: mono.datagateway.v1.EvidenceBatchPlan plan = 2;
   */ _define_property(this, "plan", void 0), /**
   * applied: the run is applied (by this call, or by an earlier one, in
   * which case nothing was written and result is empty).
   *
   * @generated from field: bool applied = 3;
   */ _define_property(this, "applied", false), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 4;
   */ _define_property(this, "result", void 0), /**
   * reviews_permitted is set by ryugu on a dry run: whether the caller may
   * record the verdicts (area:execution.verdict), so the card offers them
   * only to who the UI would.
   *
   * @generated from field: bool reviews_permitted = 5;
   */ _define_property(this, "reviewsPermitted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportTrackerResponse, "runtime", proto3);
_define_property(ImportTrackerResponse, "typeName", "mono.datagateway.v1.ImportTrackerResponse");
_define_property(ImportTrackerResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "plan",
            kind: "message",
            T: EvidenceBatchPlan
        },
        {
            no: 3,
            name: "applied",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "result",
            kind: "message",
            T: WriteResult
        },
        {
            no: 5,
            name: "reviews_permitted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
